export const sv = {
    addDatabase: {
        addDatabase: "LÃ¤gg till databas",
        addFromFile: "LÃ¤gg till frÃ¥n fil",
        analyse: "Analyse",
        analysingYourData: "Analysing your data",
        createFromExcel: "Create from Excel",
        databaseImport: "Database import",
        databaseNotImported: "Import has finished with errors",
        databasePrepared: "Database successfully prepared",
        excelFile: "Excel file",
        fileInformation: "File information",
        fixErrors: "To continue please fix following errors and retry",
        importingYourData: "Importing your data",
        productFilesPath: "Product files path",
        productImagesPath: "Product images path"
    },
    availablePrice: {
        allPackage: "Alla paket",
        onePackage: "Ett paket",
        priceType: "Pristyp",
        setPriceVatVisibility: "Momssynlighet",
        setVisibilityAndOrder: "Ange synlighet och ordning fÃ¶r pristyper",
        withAndWithoutVat: "BÃ¥de med och utan moms",
        withVat: "Endast med moms",
        withoutVat: "Endast utan moms"
    },
    barvis: {
        base: "Basnamn",
        bigCanSize: "Stor burk/hink",
        coating: "GrundfÃ¤rg",
        identifier: "Identifierare",
        laboratory: "Laboratorium",
        orderOverview: "Ordersammanfattning",
        rank: "Rangordning",
        smallCanSize: "Liten burk/hink"
    },
    basicSetup: {
        alreadyLoggedIn: "Du Ã¤r redan inloggad som %{login}.",
        askSupplier: "Be programvaruleverantÃ¶ren att tilldela fler licenser.",
        asterisk: "FÃ¤lt som Ã¤r markerade med en asterisk mÃ¥ste fyllas i.",
        identificationKeys: "Identifieringsnycklar",
        importCustomData: "Om tillÃ¤mpligt, importera dina anpassade data frÃ¥n den tidigare brytningsprogramvaran.",
        learnIdentification: "LÃ¤r dig identifieringsnyckeln frÃ¥n din programvaruleverantÃ¶r.",
        login: "FÃ¶ljande steg i den inledande konfigurationen krÃ¤ver administratÃ¶rsbehÃ¶righet",
        noDatabase: "Inga databaser har lagts till Ã¤nnu, minst en mÃ¥ste infogas.",
        offlineLicensing: "Offlinelicensiering",
        productSelection: "Produktval",
        registrationForm: "AnmÃ¤lningsblankett",
        seeQuestionMark: "AnvÃ¤nd de smÃ¥ frÃ¥getecknen fÃ¶r att lÃ¤ra dig mer om instÃ¤llningen.",
        selectDefaultPrinter: "VÃ¤lj standardskrivare och ange ytterligare konfiguration.",
        selectDefaultTemplate: "VÃ¤lj en standardmall frÃ¥n de befintliga, skapa en ny eller ladda upp din egen.",
        selectDispenser: "VÃ¤lj vilken typ av brytningsmaskin du anvÃ¤nder.",
        selectLanguage: "VÃ¤lj sprÃ¥k.",
        selectProducts: "VÃ¤lj en av de tillgÃ¤ngliga produkterna som du vill aktivera.",
        selectSpectroType: "VÃ¤lj den spektrometertyp du anvÃ¤nder.",
        setAdditionalPrinterOptions: "Ange ytterligare skrivarinstÃ¤llningar.",
        setAutomaticUpdates: "Ange instÃ¤llningar fÃ¶r automatiska uppdateringar.",
        setCustomItems: "Ange specialartiklar och datasynlighet. Rulla nedÃ¥t fÃ¶r att visa fler alternativ",
        setEnvironment: "Ange Ã¶vergripande miljÃ¶ fÃ¶r programvaran. Rulla nedÃ¥t fÃ¶r att se fler alternativ.",
        setFormulaRepresentation: "Ange receptrepresentation. Rulla nedÃ¥t fÃ¶r att se fler alternativ.",
        summary:
            "Du kan nÃ¤r som helst Ã¤ndra de hÃ¤r instÃ¤llningarna och hitta Ã¤nnu fler konfigurationsalternativ. Hoppas att du gillar att jobba med %{name}!",
        summarySuccess: "Du Ã¤r klar med instÃ¤llningarna!"
    },
    beforeDispenseColorantBatch: {
        batchNumber: "Batch number: %{batchNumber}",
        colorantIsDefective: "The canister is filled with a defective batch of colorant. Do not use this batch.",
        defectiveInfoLine1: "Please do not use colorant",
        defectiveInfoLine2: "with this batch number.",
        emptyQuickTint: "Empty the canister using Quick tint.",
        warningInfoLine1: "Colorant",
        warningInfoLine2: "with this batch number may be damaged."
    },
    canisterLevel: {
        canisterLevel: "Ange behÃ¥llarnivÃ¥",
        criticalLevelCanister: "Kritisk behÃ¥llarnivÃ¥",
        fillToMax: "Fyll till max",
        maxDispenseLevel: "Maximal dosering",
        otherCanisters: "Andra behÃ¥llarnivÃ¥er",
        warningLevelCanister: "Varning om behÃ¥llarnivÃ¥er"
    },
    canisterRefillHistoryModal: {
        batchNumberOfFilling: "Batch number of filling",
        ufiCodeStatus: "UFI code status"
    },
    canistersTab: {
        availableServiceActions: "TillgÃ¤ngliga serviceÃ¥tgÃ¤rder",
        canisterInformation: "BehÃ¥llarinformation",
        canisterPreview: "FÃ¶rhandsgranskning av behÃ¥llare",
        currentLevel: "Nuvarande nivÃ¥",
        errors: "Fel",
        fillState: "PÃ¥fyllningsstatus",
        fillToMax: "Fyll till max",
        fillingAmount: "Fyllnads nivÃ¥",
        finalLevel: "Slutlig nivÃ¥",
        minimumAmount: "MinimimÃ¤ngd",
        minimumLevel: "MiniminivÃ¥",
        moveTableToRefill: "Flytta bordet fÃ¶r att fylla pÃ¥",
        refillNoAmount: "Ingen mÃ¤ngd har angetts",
        refillOverLimit: "Den angivna mÃ¤ngden Ã¶verskrider den maximala behÃ¥llarkapaciteten.",
        refillSummary: "%{amount} %{unit} av fÃ¤rganten %{colorant} lÃ¤ggs till i behÃ¥llaren %{canisterId}.",
        systemWarningAmount: "Systemvarning â mÃ¤ngd",
        warningAmount: "VarningsmÃ¤ngd"
    },
    changeDatabase: {
        changeDatabase: "Byt databas ",
        databaseWarning: "Database %{databaseName} cannot be used due to"
    },
    changelog: {
        allVersion: "All versions",
        changelog: "Changelog",
        link: "Link",
        links: "Links",
        version: "Version",
        versionFilter: "Version filter"
    },
    checkBeforeDispensing: {
        checkBeforeDispensingModal: "There is not enough colorant in the canisters for %{numOfPackages} packages.",
        fillAdditionally: "Fill additionally",
        refillToMax: "Refill to max"
    },
    cleanChannels: {
        cleanAllChannels: "RengÃ¶r alla kanaler",
        cleanChannels: "RengÃ¶r kanaler",
        cleaningTime: "RengÃ¶ringstid",
        selectChannels: "VÃ¤lj kanaler",
        startCleaning: "Starta rengÃ¶ring "
    },
    clientServerSettings: {
        activeServer: "Aktiv server",
        addNewServer: "LÃ¤gg till ny server",
        availableServers: "Andra tillgÃ¤ngliga servrar",
        clientIdentifier: "Klientidentifierare",
        clientServerSettings: "Klientâserver-instÃ¤llningar",
        disabledStatus: "Inaktiverad",
        editServer: "Redigera server",
        fillRequiredFields: "Obligatoriska fÃ¤lt mÃ¥ste fyllas i",
        noOtherServers: "Det finns inga andra tillgÃ¤ngliga servrar",
        offlineStatus: "Offline",
        onlineStatus: "Online",
        port: "Port",
        serverName: "Servernamn",
        serverNameMissing: "Servernamnet mÃ¥ste anges",
        stabileConnection: "AnvÃ¤nd statisk IP-adress fÃ¶r att sÃ¤kerstÃ¤lla stabil anslutning.",
        wrongFormatIp: "Fel format pÃ¥ IP-adress"
    },
    colorSearchTab: {
        notEveryItemSelected: "One or more items are not selected"
    },
    colorTab: {
        colorTone: "Nyans",
        fandeckPosition: "Position pÃ¥ fÃ¤rgkarta",
        moreInfoIcons: "Fler informationsikoner",
        notExistingFormula: "Receptet finns inte",
        orderBy: "Ordna efter",
        selectYourGrid: "VÃ¤lj rutnÃ¤t",
        showInPanel: "Visa pÃ¥ panel",
        warningIcon: "Varningsikon nÃ¤r receptet inte finns"
    },
    colorantBatchNumberSettings: {
        batchNumberByPercentage: "Use Batch numbers by percentage",
        batchNumberFromLastFilling: "Use Batch numbers from the last filling",
        defectiveBatchOfColorant: "Defective Batch of colorant",
        enableBatchNumber: "Enable colorant Batch numbers",
        possibleDamagedBatchOfColorant: "Possibly damaged Batch of colorant",
        scanOrTypeBatchNumber: "Scan or type Batch number"
    },
    colorantPanel: {
        manualMachine: "machine"
    },
    colorantsTable: {
        numberOfColorants: "Antal brytpastor:",
        preview: "FÃ¶rhandsgranskning",
        prices: "Priser"
    },
    currencySettings: {
        addNewCurrency: "LÃ¤gg till ny valuta ",
        codePlaceholder: "Kod",
        currencySettings: "ValutainstÃ¤llningar",
        namePlaceholder: "Namn",
        ratePlaceholder: "VÃ¤xelkurs",
        setDecimalPlaces: "Ange antal decimaler",
        setMainCurrency: "Ange primÃ¤r valuta",
        setRounding: "Avrundning",
        symbolPlaceholder: "Symbol"
    },
    customFandecks: {
        customFandecks: "Anpassade fÃ¤rgkartor",
        deleteButtonWarning: "Alla formler i fÃ¤rgkartan kommer ocksÃ¥ att tas bort.",
        deleteCustomFandeck:
            "Vill du verkligen ta bort denna specialtillverkade fÃ¤rgkarta? Alla formler i fÃ¤rgkartan kommer ocksÃ¥ att tas bort.",
        disableStandardFandecks: "Visa bara kundfÃ¤rgkartor",
        enableStandardFandecks: "Visa standard fÃ¤rgkartor",
        fandeckName: "Namn pÃ¥ fÃ¤rgkarta "
    },
    customRedlike: {
        addColorantFromBrand: "LÃ¤gg till fÃ¤rg frÃ¥n varumÃ¤rket %{brandName}",
        addNewCustomer: "LÃ¤gg till ny kund",
        addNewNote: "LÃ¤gg till ny anteckning",
        addedDate: "Tillagda data",
        addedQuantity: "Tillagd kvantitet",
        availableMachine: "Maskinen Ã¤r tillgÃ¤nglig",
        brand: "VarumÃ¤rke",
        brandPlease: "VÃ¤lj varumÃ¤rke",
        cancelCustomer: "Avbryt kund",
        colorPlease: "VÃ¤lj fÃ¤rg",
        confirmCustomerData: "BekrÃ¤fta kunddata",
        confirmNoteData: "BekrÃ¤fta anteckningsdata",
        confirmSelectedUser: "Vill du anvÃ¤nda kunden %{customerName} fÃ¶r den hÃ¤r ordern?",
        confirmed: "BekrÃ¤ftat",
        controlData: "Slutlig datakontroll",
        customerCellNumber: "Telefonnummer till kund",
        customerFilter: "Kundfilter",
        customerName: "Kundens namn",
        customerPhone: "Telefon till kund",
        customerPlease: "VÃ¤lj kund",
        dateFilter: "Datumfilter",
        enterPin: "Ange din PIN-kod",
        enterTheNumberOfPackages: "Ange antalet paket",
        existingCustomer: "AnvÃ¤ndaren finns redan",
        fandeckPlease: "VÃ¤lj fÃ¤rgkarta",
        fillCanisterHistory: "Historik Ã¶ver behÃ¥llarpÃ¥fyllning",
        findCustomer:
            "Ange ett fÃ¶rmÃ¥nskort fÃ¶r den hÃ¤r ordern genom att skanna streckkoden eller sÃ¶k efter e-postadressen",
        findCustomerByEmail: "Filtrera kunder efter e-post eller streckkod",
        finishPreviousStep: "(SlutfÃ¶r fÃ¶regÃ¥ende steg)",
        formulaUnit: "Receptenhet",
        getBackToList: "Tillbaka till kundlistan",
        historyOfOrders: "Orderhistorik",
        insertNote: "GÃ¥ till Infoga anteckning",
        loadHistoryOrder: "Vill du lÃ¤sa in vald order?",
        loyaltyCards: "FÃ¶rmÃ¥nskort",
        machineIsAvailable: "MASKINEN ÃR TILLGÃNGLIG",
        machineIsUnavailable: "MASKINEN ÃR INTE TILLGÃNGLIG",
        newLoyaltyCard: "Nytt fÃ¶rmÃ¥nskort",
        noAvailableMachine: "Maskinen Ã¤r inte tillgÃ¤nglig",
        noCustomerSelected: "Ingen kund har valts. Vill du fortsÃ¤tta?",
        notePlease: "Infoga anteckning",
        openHistory: "Ãppna historik",
        orAdd: "eller lÃ¤gg till kund",
        orSelect: "eller vÃ¤lj kund",
        orderModification: "Den ursprungliga ordern kommer att Ã¤ndras. Vill du fortsÃ¤tta?",
        orderOverview: "Ordersammanfattning",
        orderToMachine: "SKICKA MIN ORDER TILL MASKINEN",
        ordersHistory: "Orderhistorik",
        packagePlease: "VÃ¤lj paket",
        pleaseSelectBrand: "VÃ¤lj varumÃ¤rke",
        previewImage: "FÃ¶rhandsgranskning av IMG",
        previewPackage: "FÃ¶rhandsgranskning av paket",
        productPlease: "VÃ¤lj produkt",
        resetFilters: "ÃterstÃ¤ll alla filter",
        searchForHistoricalOrders: "Eller sÃ¶k efter tidigare order",
        selectBrand: "VÃ¤lj varumÃ¤rke",
        selectColor: "GÃ¥ till val av kulÃ¶r",
        selectCustomer: "GÃ¥ till val av kund",
        selectExistingCustomer: "VÃ¤lj befintlig kund",
        selectFandeck: "GÃ¥ till val av fÃ¤rgkarta",
        selectManually: "If you want to use this color in %{brandNames} brand, please select it manually.",
        selectPackage: "GÃ¥ till val av paket",
        selectProduct: "GÃ¥ till val av produkt",
        shotsCoefficient: "Doskoefficient",
        showDetail: "Visa detaljer",
        showHideEshopName: "Visa/dÃ¶lj eshop-namnet pÃ¥ fÃ¤rgen i en separat kolumn",
        showKeyboard: "Visa tangentbord",
        skipCustomerButton: "Hoppa Ã¶ver kundval",
        skipCustomerText: "Hoppa Ã¶ver om du inte vill ange en kund",
        skipNote: "Hoppa Ã¶ver anteckning och visa sammanfattning",
        spectroBrand: "SÃ¶ker i varumÃ¤rket %{brandName}",
        statusAccepted: "accepterat",
        statusCanceled: "annullerat",
        statusCreated: "skapat",
        statusDone: "slutfÃ¶rt",
        statusPartlyDone: "delvis utfÃ¶rt",
        statusPreparing: "fÃ¶rbereder",
        summaryChosenBase: "bas",
        summaryChosenBrand: "varumÃ¤rke",
        summaryChosenCanSize: "storlek pÃ¥ burk/hink",
        summaryChosenColor: "kulÃ¶r",
        summaryChosenColorCard: "fÃ¤rgkarta",
        summaryChosenProduct: "produkt",
        summaryChosenQuantity: "mÃ¤ngd",
        summaryColorPreview: "FÃ¶rhandsgranskning av kulÃ¶r",
        summaryCustomNote: "Anpassad anteckning",
        summaryCustomerNumber: "kundnummer",
        summaryFormula: "Recept",
        summaryFormulaNote: "Receptanteckningar",
        summaryNote: "anteckning",
        sureAboutSend: "Vill du skicka en order?",
        useCustomerInOrder: "Vill du anvÃ¤nda kunden %{customerName} fÃ¶r den hÃ¤r ordern?",
        uuid: "UUID ",
        viewSummary: "Visa sammanfattning",
        volume: "Volym"
    },
    customRedlikeAnother: {
        pinOrderConfirmation: "FÃ¤st orderbekrÃ¤ftelse",
        pinScreenSaverConfirmation: "FÃ¤st bekrÃ¤ftelse som skÃ¤rmslÃ¤ckare",
        pinSettingsConfirmation: "BekrÃ¤ftelse av PIN-instÃ¤llning",
        printAuto: "TillÃ¥t automatisk utskrift",
        printerSettings: "SkrivarinstÃ¤llningar",
        selectColorWithFandeck: "Ofta valda kulÃ¶rer och fÃ¤rgkartor",
        setKeyboard: "Ange tangentbord",
        setKioskMode: "Ange helskÃ¤rmslÃ¤ge",
        setLanguage: "Ange sprÃ¥k",
        setModule: "Ange modul",
        setQuickSelect: "Ange snabbval",
        setScreensaverTimeout: "Ange sluttid fÃ¶r skÃ¤rmslÃ¤ckare",
        setUnit: "Ange enhet "
    },
    customRedlikeMachine: {
        action: "ÃtgÃ¤rd",
        additionalPrint: "Ytterligare utskrift",
        brand: "VarumÃ¤rke",
        brandAccess: "AnvÃ¤ndaren %{userName} har inte Ã¥tkomst till data frÃ¥n varumÃ¤rket %{brandName}",
        can: "Burk/hink har placerats",
        canistersLevel: "Ãversikt Ã¶ver behÃ¥llarnivÃ¥er",
        closeDetailInformation: "StÃ¤ng detaljer",
        colorantsAmount: "MÃ¤ngden brytpasta",
        confirmRefill: "BekrÃ¤fta pÃ¥fyllning av brytpasta",
        deleteOrder: "Ta bort order",
        dialogNoMachine: "Maskinen Ã¤r inte ansluten",
        dialogNoRcc: "Ingen RCC Ã¤r ansluten",
        dispense: "Bryt",
        dispenserInErrorState: "Brytmaskinen Ã¤r i fellÃ¤ge",
        dispensingIsOk: "Brytmaskinen Ã¤r OK",
        emergencyButtonPressed: "NÃ¶dstoppsbrytaren intryckt",
        errorCode: "Felkod",
        errorEvents: "Brytmaskinsfel",
        errorReset: "NollstÃ¤ll fel",
        explanation: "FÃ¶rklaring",
        imageNotAvailable: "Bilden Ã¤r inte tillgÃ¤nglig",
        incorrectCanister: "Den skannade behÃ¥llaren Ã¤r fel!",
        incorrectColorant: "Fel: Den skannade brytpastan Ã¤r fel. VÃ¤lj rÃ¤tt brytpasta.",
        lastEvents: "Senaste hÃ¤ndelser",
        machineActions: "Brytmaskinssensorer",
        machineConfiguration: "Konfiguration av brytmaskin",
        machineError: "Maskinfel",
        machineIsBusy: "Maskinen Ã¤r upptagen",
        machineNotAvailable: "Maskinen Ã¤r inte tillgÃ¤nglig",
        machineTinting: "VÃ¤nta, maskinen bryter...",
        manualScan: "Manuell skanning",
        notEnoughSpace: "FEL: Det finns inte tillrÃ¤ckligt med utrymme fÃ¶r det hÃ¤r brytpastapaketet",
        numberOfCanistersUnderCriticalLevel: "Antalet behÃ¥llare under kritiska nivÃ¥er Ã¤r %{0}",
        numberOfCanistersUnderWarningLevel: "Antalet behÃ¥llare  under varningsnivÃ¥erna Ã¤r %{0}",
        offlinePressed: "Offline-knappen Ã¤r nedtryckt",
        orderSettings: "OrderinstÃ¤llningar",
        otherOrderInformation: "Orderdetaljer",
        packageCount: "Antal paket",
        packageWithSeparator: "Paket",
        received: "Mottaget",
        receivedOrders: "Mottagna order",
        receivedTime: "Mottaget, tid",
        recirculation: "Ãtercirkulation",
        refillInformation: "Brytpasta: %{0}, pÃ¥fyllning: %{1}, behÃ¥llare: %{2}",
        resetErrors: "NollstÃ¤llningsfel",
        scanCanister: "Skanna den hÃ¤r behÃ¥llaren",
        scanColorantPackage: "Skanna rÃ¤tt brytpastapaket",
        selectedOrder: "Vald order",
        shelfMovingDown: "Hyllan flyttas nedÃ¥t",
        shelfMovingUp: "Hyllan flyttas uppÃ¥t",
        solution: "LÃ¶sning",
        startDispensing: "Starta brytning",
        stirring: "OmrÃ¶rning",
        touchToStartFilling: "Tryck fÃ¶r att starta pÃ¥fyllning av fÃ¤rgpasta",
        unknownBrand: "OkÃ¤nt varumÃ¤rke"
    },
    customRedlikeSettings: {
        addPos: "Information om fÃ¶rsÃ¤ljningsstÃ¤lle (POS)",
        addServer: "LÃ¤gg till server",
        adminOperations: "Administrativa Ã¥tgÃ¤rder",
        adminSettings: "AdministratÃ¶rsinstÃ¤llningar",
        another: "Annan",
        aslOrService: "TeckensprÃ¥k eller service",
        availableMachines: "TillgÃ¤ngliga maskiner",
        barcode: "Streckkod",
        basicOperations: "GrundlÃ¤ggande aktiviteter",
        canisterBarcodes: "BehÃ¥llarstreckkoder",
        canisterLevels: "BehÃ¥llarnivÃ¥er",
        closeConnection: "StÃ¤ng anslutningen",
        closeRedlike: "StÃ¤ng %{name}",
        databaseList: "Databaser",
        disabledStatus: "Inaktiverad",
        dispenseLogicType: "Logiktyp fÃ¶r dosering",
        dropServers: "Koppla bort servrar",
        editServer: "Redigera server",
        lastEvent: "Senaste hÃ¤ndelser",
        logOut: "Logga ut",
        machineConfiguration: "Konfiguration",
        maxDispenseAmount: "Maximal doseringsmÃ¤ngd",
        offlineStatus: "Offline",
        onlineStatus: "Online",
        openFrondesk: "Ãppna receptionen",
        print: "UtskriftsinstÃ¤llningar",
        rebootPC: "Starta om PC",
        restartRedlike: "Starta om %{name}",
        restoreConnection: "ÃterstÃ¤ll anslutning",
        scanCanisterBarcode: "Skanna behÃ¥llarens streckkod",
        scanOrDeleteCanisterBarcode: "Skanna eller ta bort streckkod",
        setCanisterBarcode: "Ange behÃ¥llarens streckkod",
        swVersion: "Programvaruversion",
        systemFunctions: "Systemfunktioner",
        userSettings: "AnvÃ¤ndarinstÃ¤llningar "
    },
    customTab: {
        cifCombinationCheck:
            "The color %{colorName} already exists in fandeck %{fandeckName}, but it contains different spectral data. Would you like to overwrite existing data?",
        editColor: "Redigera kulÃ¶r",
        editColorant: "Redigera brytpasta",
        emptyColorant: "En av brytpastorna har ingen mÃ¤ngd angiven",
        formulaCombinationCheck:
            'The formula with the color name "%{colorName}" already exists. Would you like to overwrite existing formula with the new one?',
        formulaForMasterProduct: "Formel fÃ¶r huvudprodukt",
        formulaForMasterProductWithParam: "Formel fÃ¶r huvudprodukten %{productName}",
        isNotAvailable: "Ã¤r inte tillgÃ¤nglig",
        noBaseSelected: "Bas Ã¤r obligatoriskt",
        noColorantsSelected: "Inga brytpastor har valts",
        noFandeckSelected: "FÃ¤rgkarta Ã¤r obligatoriskt",
        noNameOrCode: "Color name and code are required",
        noProductSelected: "Produkt Ã¤r obligatoriskt",
        productPreview: "ProduktfÃ¶rhandsgranskning",
        saveCustomRecipe: "Spara anpassat recept",
        saveIsNotAvailable: "Det gÃ¥r inte att spara",
        showSiblingProducts: "Visa liknade produkter",
        siblingProducts: "Liknade produkter efter huvudprodukt"
    },
    customersTab: {
        addCustomer: "LÃ¤gg till kund",
        additionalSettings: "Ytterligare instÃ¤llningar",
        adress: "Adress",
        createAndSelect: "LÃ¤gg till och vÃ¤lj",
        createNewCustomer: "Skapa en ny kund",
        editCustomer: "Redigera kund",
        expiration: "Customer %{name} will expire in %{dayCount} days",
        identificationNumber: "Kontonummer",
        information: "Kontaktuppgifter",
        listOfCustomers: "Kundlista",
        rabat: "Rabatt",
        selectCustomer: "VÃ¤lj kund",
        spentLastMonth: "KÃ¶p fÃ¶rra mÃ¥naden",
        spentMoney: "InkÃ¶psbelopp",
        typeOfMargin: "Typ av marginal",
        zipCode: "Postnummer"
    },
    dialog: {
        cheaperColorSearch: "SÃ¶kning efter billigare fÃ¤rger pÃ¥gÃ¥r",
        competitiveColorSearch: "Konkurrerande kulÃ¶rsÃ¶kning pÃ¥gÃ¥r",
        reallyChangeModule: "Vill du byta modul?",
        reallyCloseRedlike:
            "Vill du stÃ¤nga %{name}? Alla %{name}-paneler stÃ¤ngs och Ã¤ndringar som inte sparats gÃ¥r fÃ¶rlorade.",
        reallyDeleteOrder: "Vill du ta bort den hÃ¤r ordern? Alla data i ordern tas bort.",
        reallyRebootPC: "Vill du starta om datorn? Alla paneler stÃ¤ngs och Ã¤ndringar som inte sparats gÃ¥r fÃ¶rlorade.",
        reallyRestartRedlike:
            "Vill du starta om %{name}? Alla paneler stÃ¤ngs och Ã¤ndringar som inte sparats gÃ¥r fÃ¶rlorade.",
        reallyShutdownPc:
            "Vill du stÃ¤nga av den hÃ¤r datorn? Alla %{name}-paneler stÃ¤ngs och Ã¤ndringar som inte sparats gÃ¥r fÃ¶rlorade. ",
        unlockComputer: "Computer will be unlocked."
    },
    dispenseLogicTypes: {
        1: "Dosera endast maximal brytbar mÃ¤ngd",
        2: "TillÃ¥t manuell dosering med hjÃ¤lp av skala fÃ¶r mÃ¤ngder Ã¶ver den maximala brytbara mÃ¤ngden",
        3: "Fyll pÃ¥ under brytning (dela upp mÃ¤ngden i mindre delar)",
        4: "Force manual dispensing using scale only in case of custom package"
    },
    editCustomFandeck: {
        fandeckName: "Namn pÃ¥ fÃ¤rgkarta"
    },
    editFormulaRgbModal: {
        apply: "AnvÃ¤nd",
        blue: "BlÃ¥",
        green: "GrÃ¶n",
        modalLabel: "Redigera kulÃ¶r",
        red: "RÃ¶d",
        tryGenerateRgb: "FÃ¶rsÃ¶k att generera RGB efter fÃ¤rgmÃ¤ngder"
    },
    environmentsSettings: {
        allowAutoCloseTab: "StÃ¤ng formelfliken automatiskt",
        allowBarcodes: "TillÃ¥t streckkoder",
        allowBuildingSitePanel: "Allow building site specification",
        allowCustomers: "TillÃ¥t kunder",
        allowDeleteConfirmation: "TillÃ¥t borttagningsbekrÃ¤ftelse",
        allowDiskSpaceNotification: "Allow disk space notification",
        allowDispensing: "TillÃ¥t brytning",
        allowFileTransfer: "TillÃ¥t automatisk filÃ¶verfÃ¶ring",
        allowFormulaModificationPanel: "Allow formula modification panel",
        allowFormulaStatusPanel: "TillÃ¥t formelstatus panel",
        allowInternalNotes: "TillÃ¥t interna anteckningar",
        allowLight: "TillÃ¥t %{name}",
        allowOrderNotificationModal: "Visa nya orderaviseringar",
        allowOrdering: "TillÃ¥t order",
        allowPricing: "TillÃ¥t priser",
        allowPrint: "TillÃ¥t utskrift",
        allowProductPreviewImage: "Visa fÃ¶rhandsgranskning av produktbild",
        allowQualityControl: "Allow quality control",
        allowSearchCheaperColors: "TillÃ¥t sÃ¶kning efter billigare fÃ¤rger",
        allowSound: "TillÃ¥t orderaviseringar med ljud",
        allowSpectro: "TillÃ¥t spektrometer",
        allowTabs: "TillÃ¥t flikar",
        applyZoom: "TillÃ¥t zoom",
        automaticLogout: "Automatisk utloggning",
        barcodeScan: "Streckkodsskanning",
        canisterBarcode: "BehÃ¥llarstreckkod",
        canisterLevel: "BehÃ¥llarnivÃ¥er",
        changelog: "Ãndringslogg",
        closeTab: "StÃ¤ng flik",
        colorDifference: "Color difference",
        colorPanelNavItem: "KulÃ¶rpanel",
        competitiveColorSearch: "Konkurrerande kulÃ¶rsÃ¶kning",
        customBanner: "Anpassad banner",
        customCurrencyFormat: "Valutaformat",
        customDateFormat: "Datumformat",
        customNumberFormat: "Talformat",
        customTimeFormat: "Tidsformat",
        deltaA: "Delta A",
        deltaB: "Delta B",
        deltaE: "Delta E",
        deltaL: "Delta L",
        deltaMetamerism: "Delta metamerism",
        discount: "Visa rabatt",
        dispensingHistory: "Brytningshistorik",
        dispensingNotes: "TillÃ¥t brytningsanteckningar",
        enableCustomers: "Aktivera kunder",
        enableDeleteConfirmation: "Aktivera borttagningsbekrÃ¤ftelse",
        enableDispensing: "Aktivera brytning",
        enableLight: "Aktivera %{name}",
        enableMarginMarkup: "Aktivera marginal eller pÃ¥slag",
        enableNotes: "Aktivera anteckningar",
        enableOrdering: "Aktivera order",
        enableProductPreviewImage: "Aktivera fÃ¶rhandsgranskning av produkt",
        enableSpectro: "Aktivera spektrometer",
        enableVirtualKeyboard: "TillÃ¥t virtuellt tangentbord",
        environmentsSettings: "MiljÃ¶instÃ¤llningar",
        exportTranslationKeys: "Exportera Ã¶versÃ¤ttningsnycklar",
        formulaNotes: "TillÃ¥t receptanteckningar",
        hintTooltips: "Knappbeskrivningar",
        image: "FÃ¤rg + bild/mer information",
        keyboardShortcuts: "Kortkommandon",
        languageBased: "SprÃ¥kbaserat",
        lockYourComputer: "LÃ¥s datorn",
        machineReset: "MaskinÃ¥terstÃ¤llning",
        manageTranslations: "Hantera Ã¶versÃ¤ttningar",
        margin: "Endast marginal",
        markup: "Endast pÃ¥slag",
        matchingRowCount: "Set number of results found",
        maxNumberTabs: "Maximalt antal receptflikar",
        memoryTabs: "Store recently opened tabs",
        moreInfo: "FÃ¤rg + bild + mer information",
        navigationItems: "InstÃ¤llningar fÃ¶r navigeringsobjekt",
        newTab: "Ny flik",
        numberOfPriceGroups: "Antal prisgrupper",
        order: "Order",
        orderId: "Order-ID",
        ordersHistory: "Orderhistorik",
        overwriteLastTab: "Skriv Ã¶ver den sista receptfliken",
        priceCalculation: "PrisutrÃ¤kning",
        priceDefBothPurchasePrimary: "BÃ¥da, med kÃ¶p som den primÃ¤ra",
        priceDefBothSellPrimary: "BÃ¥da, med sÃ¤lj och den primÃ¤ra",
        priceDefPurchaseOnly: "Endast inkÃ¶pspris",
        priceDefSellOnly: "Endast sÃ¤ljpris",
        priceDefinition: "Prisdefinition",
        priceGroupsEnabled: "Aktivera prisgrupper",
        runLightAtStartUp: "KÃ¶r %{light} vid start",
        screenSaverTimeout: "TidsgrÃ¤ns fÃ¶r skÃ¤rmslÃ¤ckare",
        selectedSpectro: "VÃ¤lj  %{spectro}spektro.",
        selectedSpectroNone: "Ingen spektrometer har valts.",
        setAutomaticClientStart: "KÃ¶r %{name} nÃ¤r datorn startar",
        setCustomHomeButton: "ÃtgÃ¤rder fÃ¶r startknapp",
        setDecimalPlaces: "Ange antal decimaler",
        setFormulaPreview: "FÃ¶rhandsgranskning av recept",
        setFormulaUnit: "Ange receptenhet",
        setFts: "AnvÃ¤nd fulltextsÃ¶kning",
        setInfoItemInRgb: "Data i fÃ¤rgfÃ¶rhandsgranskning",
        setKeyboardShortcuts: "Ange kortkommandon",
        setKioskMode: "StÃ¤ll in helskÃ¤rmslÃ¤ge",
        setKioskModeOff: "StÃ¤ng av helskÃ¤rmslÃ¤ge",
        setKioskModeOn: "Starta helskÃ¤rmslÃ¤ge",
        setNavigationItems: "Ange navigeringsobjekt",
        setNavigationItemsList: "Ange synlighet och ordning fÃ¶r navigeringsobjekt",
        setOrderSearchItems: "Ange parametrar fÃ¶r ordersÃ¶kning",
        setRounding: "Ange avrundning",
        setSearchParameters: "Ange parametrar fÃ¶r receptsÃ¶kning",
        setTabLimit: "Ange flikbegrÃ¤nsning",
        setYourLanguage: "Ange sprÃ¥k",
        setZoom: "Ange zoom",
        showLocalPrices: "Show local prices",
        skipPlaceCanDialogEnabled:
            "Den hÃ¤r instÃ¤llningen kan inte Ã¤ndras eftersom dialogrutan har inaktiverats i MaskininstÃ¤llningar",
        sortItems: "Sortera navigeringsobjekt",
        startDispensing: "Starta brytning",
        stir: "RÃ¶r om"
    },
    error: {
        errorDetail: "Felinformation",
        errorOccurred:
            "Ett ovÃ¤ntat fel uppstod. Kontakta vÃ¥r support pÃ¥ %{0} sÃ¥ Ã¥terkommer vi till dig sÃ¥ snart vi kan.",
        hideDetail: "DÃ¶lj detaljer"
    },
    favoritesTab: {
        addFolder: "LÃ¤gg till mapp",
        closeTabToLoadFormula:
            "StÃ¤ng ett av recepten fÃ¶r att Ã¶ppna en ny flik. Du har nÃ¥tt det maximala antalet Ã¶ppna flikar",
        deleteFolder: "Ta bort mapp",
        editFolder: "Redigera mapp",
        favoriteFormulas: "Favoritrecept",
        formulaNotes: "Receptanteckningar",
        message: {
            formulasFromFolder: "Recept frÃ¥n mapp",
            moveAllFormulas: "Flytta alla recept frÃ¥n den hÃ¤r mappen till Ã¶verordnad",
            removeAllFormulas: "Ta bort alla recept frÃ¥n den hÃ¤r mappen",
            wantToDeleteFolder: "Vill du ta bort den hÃ¤r mappen?"
        },
        newFolder: "Ny mapp",
        packages: "Paket",
        pricePerPackage: "Pris per paket",
        regularPrice: "AllmÃ¤nt pris",
        removeFromFavorites: "Ta bort frÃ¥n favoriter",
        specialPriceOff: "Specialpris %{number}Â % rabatt",
        specialPriceVIP: "Specialpris VIP"
    },
    fileTransfer: {
        afterImport: "Efter import",
        alreadyExists: "Uppgift fÃ¶r given typ och format finns redan",
        customFormulaSimple: "Anpassad formel enkel",
        direction: "Riktning",
        exportTask: "Fil export uppgift",
        fileTransferNotification: "Meddelande om filÃ¶verfÃ¶ring",
        flashMessage: "Flash-meddelande",
        importTask: "Uppgift om filimport",
        noInformation: "Ingen information",
        protocol: {
            folder: "Mapp",
            ftp: "FTP-protokoll",
            ftps: "FTPS-protokoll",
            redlikeStorage: "%{softwareName} FTP lagringsprotokoll",
            sftp: "SFTP protocol"
        },
        protocolDescription: {
            folder: "Protokollkontroll av filer i definierad lokal mapp.",
            ftp: "Protokollkontroll av filer i fjÃ¤rr FTP mapp anvÃ¤nder standard FTPanslutning.",
            ftps: "Protokollkontroll av filer i FTPS-servern (FTP-SSL / FTP Secure) anvÃ¤nder standard FTP-anslutning.",
            redlikeStorage: "Protokollkontroll av filer i  %{softwareName} Lager."
        },
        remoteFolder: "FjÃ¤rrmapp",
        startType: "Starttyp",
        statusbar: "Information om statusfÃ¤ltet",
        testConnection: "Testanslutning",
        xMoreLeft: "(%{amount} more left)",
        xmlImporting: "XML file is being imported"
    },
    filtering: {
        consumptionType: "Konsumtionstyp",
        filter: "Filter",
        from: "FrÃ¥n",
        to: "Till"
    },
    findText: {
        findTextTitle: "SÃ¶k efter text",
        removeMarks: "Ta bort mÃ¤rkning",
        search: "SÃ¶k efter ord"
    },
    flashMessage: {
        VMNotAllowed: "Virtuella datorer Ã¤r inte tillÃ¥tna.",
        addedToStock: "Successfully added items to stock",
        allRecordsDeleted: "All imported records were successfully deleted",
        autologinFailed: "Automatisk databasinloggning misslyckades.",
        autotaskDuplicateName: "Fel i databasintegriteten: %{0} artikel med %{1} %{2} finns redan, anvÃ¤nd annat %{3}.",
        barcodeIsUsed: "Streckkoden anvÃ¤nds redan",
        barcodeNotFound: "Det gick inte att hitta streckkoden.",
        bugReportSent: "Felrapporten har skickats.",
        cannoctConnectToServer: "Det gÃ¥r inte att ansluta till servern.",
        cannotWriteLicense: "Det gÃ¥r inte att skriva licensen.",
        clientConnectionRejected: "Anslutningen avvisades.",
        clientNotLoggedIn: "Klienten Ã¤r inte inloggad.",
        colorFromInactiveDatabase: "Color is from inactive database %{0}.",
        colorantPackageRemovedStock: "Colorant package successfully removed from stock.",
        competitiveSearchEmpty: "Resultatet av konkurrerande fÃ¤rgsÃ¶kning Ã¤r tomt",
        competitiveSearchSelectProduct: "Please select product to start competitive color search.",
        computerBackdated: "Datorn har bakdaterats.",
        connectionFailed: "Anslutningstestet misslyckades: %{0}",
        connectionSuccess: "Anslutningstestet lyckades",
        corruptedLicenseFile: "Licensfilen Ã¤r skadad.",
        customFormulaCreated: "Custom formula successfully created.",
        customFormulaCreationError: "Error while creating custom formula.",
        customFormulaFromXmlCreationError:
            "Error while creating custom formula with colorants '%{colorants}' for combination of product '%{product}', fandeck '%{fandeck}', color '%{color}' and base '%{base}'.",
        customerNotFound: "Det gick inte att hitta kunden.",
        dataNotAvailable: "Servern kan inte ansluta till databasen.",
        datacolorMatching: {
            couldNotConnect: "Could not connect to Datacolor Matching, either server down or PC is offline.",
            disabled: "Datacolor Matching disabled.",
            internalError: "Datacolor Matching internal error: '%{0}'",
            invalidCredentials: "No or invalid credentials for Datacolor Matching provided, contact database provider.",
            noCansAvailable: "No cans available for selected color file (product line), contact database provider."
        },
        defaultMessage: "Ett ovÃ¤ntat fel uppstod under den senaste serverÃ¥tgÃ¤rden.",
        deleteAll: "Ta bort alla.",
        deletingImportedData: "Deleting imported records.",
        disableWinterPlugin:
            "Du kan inaktivera vinter-pluginprogrammet med hjÃ¤lp av listrutan till hÃ¶ger om fliknavigeringen.",
        duplicateBarcode: "Det finns redan en dubblettstreckkod",
        duplicateName: "Dubblett, namnet finns redan.",
        emptyFandeck: "Selected fandeck is empty.",
        emptyStock: "There are no records in stock for the item you have used.",
        expiredLicense: "Licensen har gÃ¥tt ut.",
        exportSuccess: "Data exporterades.",
        fandeckExist: "Namnet pÃ¥ anpassad fÃ¤rgkarta finns redan.",
        featureNotAutorized: "Funktionen har inte godkÃ¤nts.",
        fileExportComplete: "Filen exporterades.",
        fileExportError: "An error occurred during file export.",
        fileSaveComplete: "File was successfully saved.",
        fileSaveError: "An error occurred during file saving.",
        fileTransferCustomFormulaRecordsAdded: "New custom formula records were added from the received file.",
        fileTransferCustomFormulaRecordsNotFullyProcessed:
            "Could not fully process custom formula data in file: '%{0}', see error log files for more info.",
        fileTransferCustomFormulaRecordsProcessed:
            "The new custom formula records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferCustomerRecordsAdded: "New customer records were added from the received file.",
        fileTransferCustomerRecordsNotFullyProcessed:
            "Could not fully process customer data in file: '%{0}', see error log files for more info.",
        fileTransferCustomerRecordsProcessed:
            "The new customer records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferFileNotProvided: "Filen har inte angetts eller Ã¤r tom.",
        fileTransferHistoryRecordsAdded: "New dispensing history records were added from the received file.",
        fileTransferHistoryRecordsNotFullyProcessed:
            "Could not fully process dispensing history data in file: '%{0}', see error log files for more info.",
        fileTransferHistoryRecordsProcessed:
            "The new history records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferInvalidFile: "Det gick inte att bearbeta data i filen, filen Ã¤r inte giltig.",
        fileTransferOrderRecordsAdded: "New order records were added from the received file.",
        fileTransferOrderRecordsNotFullyProcessed:
            "Could not fully process order data in file: '%{0}', see error log files for more info.",
        fileTransferOrderRecordsProcessed:
            "The new order records (%{0} of the %{1}) were succesfully added from the recieved file.",
        fileTransferUnknownVersion: "Det gick inte att identifiera filversionen.",
        filetransferNoData: "Ingen databasanslutning, kontrollera instÃ¤llningarna",
        formulaDataUnavailable: "Receptdata Ã¤r inte tillgÃ¤ngliga.",
        helperDefaultMessage: "Ett ovÃ¤ntat fel uppstod under den senaste Ã¥tgÃ¤rden frÃ¥n hjÃ¤lpservern.",
        helperServerError: "HjÃ¤lpserverfel.",
        importAborted: "Importprocessen avbrÃ¶ts.",
        importSuccess: "Data har importerats.",
        incompatibleBaseCan: "Basburken Ã¤r inte kompatibel med angiven produkt, bas och paket.",
        incorrectPassword: "Det gamla lÃ¶senordet Ã¤r felaktigt. Ange rÃ¤tt lÃ¶senord.",
        invalidCurrency: "Valutakoden Ã¤r ogiltig. Euro har angetts som standardvaluta.",
        invalidDatabaseName: "Databasens namn Ã¤r ogiltigt.",
        invalidEmail: "Din e-post Ã¤r ogiltig.",
        invalidFormulaColorants:
            "There is the software issue in the formula. Formula could be wrong! Contact your support!",
        invalidLicenseCompanyUserKey: "Ogiltig fÃ¶retagsanvÃ¤ndarnyckel.",
        invalidLicenseFile: "Ogiltig licensfil.",
        invalidLicenseIdentificationKeys: "Dina licensidentifieringsnycklar Ã¤r ogiltiga.",
        invalidLicenseKey: "Din licens Ã¤r ogiltig",
        invalidLicenseProduct: "Licensfilen Ã¶verensstÃ¤mmer inte med produkten.",
        invalidRccResponse: "Ett ovÃ¤ntat fel uppstod vid bearbetningen av det sista RCC-svaret.",
        invalidServerResponse: "Ett ovÃ¤ntat fel uppstod vid bearbetningen av det sista serversvaret.",
        invalidUrl: "URL:en Ã¤r ogiltig.",
        itemNotFound: "Det gick inte att hitta artikeln.",
        keyboardShortcutUsedInModal:
            "Det hÃ¤r kortkommandot kan inte anvÃ¤ndas i popup-fÃ¶nstret. StÃ¤ng fÃ¶rst popup-fÃ¶nstret.",
        keyboardShortcutValidation: "Ett och samma kortkommando kan inte anges fÃ¶r tvÃ¥ olika Ã¥tgÃ¤rder.",
        licenseHasBeenRevoked: "Din licens har Ã¥terkallats. Kontakta programvaruleverantÃ¶ren fÃ¶r att fÃ¶rnya den.",
        licenseProlongationNeeded: "LicensfÃ¶rlÃ¤ngning krÃ¤vs (anslut PC till Internet fÃ¶r att fÃ¥ en ny licens)",
        licenseUpToDate: "Your license is up to date. No update necessary.",
        licenseUpdateUnsuccessful: "Could not update license.",
        licenseUpdated: "License has been successfully updated.",
        licensedOnDifferentComputer: "Produkten licensierades ursprungligen pÃ¥ en annan dator.",
        logFileArchiveDownloadComplete: "Loggarkivet har hÃ¤mtats.",
        loginError: "Ett ovÃ¤ntat fel uppstod vid inloggning.",
        logoutError: "Ett ovÃ¤ntat fel uppstod vid utloggning.",
        machineIsConnecting: "Maskinen ansluter. VÃ¤nta.",
        machineIsNotConnected: "Din maskin Ã¤r INTE ANSLUTEN till RCC. Kontrollera RCC-konfigurationen.",
        malformedFormula: "Formula is malformed.",
        matching: {
            correctionNotPossible: "Correction cannot be done, use reformulation.",
            forbidden: "Request '%{0}' failed: forbidden.",
            internalServerError: "Internal server error.",
            invalidBase: "Invalid base in product.",
            invalidBipp: "Invalid base in product package.",
            invalidColorantId: "Invalid colorant with ID: %{0}.",
            invalidColorantName: "Invalid colorant with name: %{0}.",
            invalidColorfile: "Invalid color file with ID: %{0} for product with ID: %{1}.",
            invalidIlluminant: "Invalid illuminant: %{0}",
            invalidProduct: "Invalid product with ID: %{0}.",
            invalidSpectralCurve: "Invalid spectral curve.",
            noColorfiles: "No color files defined for product with ID: %{0}.",
            notAuthorized: "Request '%{0}' failed: unauthorized.",
            notFound: "Request '%{0}' failed: not found.",
            reformulationNotPossible: "Reformulation cannot be done.",
            unknownError: "Unknown error.",
            validationError: "Request '%{0}' failed due to validation errors: %{0}."
        },
        maxFileSizeExceeded: "Maximum file size of %{0} MB exceeded",
        maxTabs: "Maximalt antal flikar uppnÃ¥s. StÃ¤ng en.",
        noTemplate: "Utskrift kan inte utfÃ¶ras eftersom inga mallar Ã¤r tillgÃ¤ngliga.",
        openNewTab: "Ãppna en ny receptflik fÃ¶r att lÃ¤sa in receptet med hjÃ¤lp av streckkod",
        orderAlreadyAcquired: "Ordern har redan tilldelats, men den mÃ¥ste slÃ¤ppas fÃ¶rst.",
        orderCreated: "Ordern har skickats.",
        passwordIsNotUnique: "Det nya lÃ¶senordet mÃ¥ste skilja sig frÃ¥n det gamla.",
        printCannotBeCarriedOut: "Utskrift kan inte utfÃ¶ras eftersom skrivarnamnet Ã¤r ogiltigt.",
        problemWithFileExport: "Ett fel uppstod nÃ¤r filen skulle sparas pÃ¥ disk.",
        productFileWarning: "Produktfilen Ã¤r endast tillgÃ¤nglig online.",
        productNotLicensed: "Produkten Ã¤r inte licensierad.",
        rccDefaultMessage: "Ett ovÃ¤ntat fel uppstod under den senaste RCC-Ã¥tgÃ¤rden.",
        rccError: "RCC-fel",
        rccNeedRestart: "Starta om RCC.",
        restoredSettings: "InstÃ¤llningarna har Ã¥terstÃ¤llts.",
        revokedLicense: "Licensen har Ã¥terkallats.",
        runningOutOfSpace: "The computer is running out of free space.",
        savedFormulaToHistory: "Receptet har sparats i brytningshistoriken.",
        savedLogArchive: "Loggarkivet har sparats i din katalog.",
        scanning: "PÃ¥gÃ¥ende skanning",
        serverError: "Serverfel",
        setClientIdentifier: "Ange klient-ID fÃ¶rst.",
        showLess: "Visa mindre",
        showMore: "Visa mer",
        spectroIsDisconnecting: "Spektrometern kopplas bort. VÃ¤nta.",
        spectroIsNotConnected: "Spektrometern Ã¤r INTE ANSLUTEN fÃ¶r nÃ¤rvarande. Kontrollera RCC-konfigurationen.",
        spectroIsNotSelected: "Spektrometer Ã¤r INTE VALD fÃ¶r nÃ¤rvarande. Kontrollera RCC-konfigurationen.",
        tmcNotAvailable: "%{tmc} is not available. Please check your %{collector}.",
        tmcNotConnected: "%{tmc} is not connected. Please start your %{collector} and restart server.",
        unknownError: "OkÃ¤nt fel: %{0}",
        userAlreadyLoggedIn: "Du Ã¤r redan inloggad.",
        versionNotAllowedByLicense: "Software version is too new and is not allowed for your license.",
        webApiConnectionError: "Det gick inte att ansluta till webb-API-servern.",
        webApiInternalError: "Webb-API-server â internt fel",
        webApiInvalidUser: "Webb-API-server â ogiltig anvÃ¤ndare",
        webApiNoLicenseAvailable: "Webb-API-server â ingen licens Ã¤r tillgÃ¤nglig",
        wrongDataSaved: "Wrong data was saved to XML file in the %{0} folder.",
        wrongHelpInput: "Fel format fÃ¶r inmatning av %{0}.",
        wrongRccVersion: "Kontrollera din version av RCC. Din klient Ã¤r endast kompatibel med RCC %{0}. "
    },
    footer: {
        aboutApplication: "Om ansÃ¶kan",
        activeUser: "Aktiv anvÃ¤ndare",
        logOut: "Logga ut",
        machineErrors: "Maskinfel"
    },
    formulaProperties: {
        exterior: "Exterior",
        interior: "Interior",
        invalid: "Invalid",
        solvent: "Solvent based",
        universal: "Universal",
        water: "Water based"
    },
    formulaSettings: {
        allUnits: "Alla enheter som finns tillgÃ¤ngliga i databasen",
        allowCustomFormulas: "TillÃ¥t anpassade recept",
        allowCustomPackageSize: "TillÃ¥t anpassad paketstorlek",
        allowFormulaAutomaticNaming: "TillÃ¥t automatiska namn",
        automaticNaming: "Automatiska receptnamn",
        basePanelSize: "Ange storlek pÃ¥ baspanelen",
        bippPanelSize: "StÃ¤ll in storleken pÃ¥ basen i produkt panelen",
        blendColorNameAndCode: "Blend color name and color code",
        buttonBellowMoreInfo: "Show button below formula notes",
        buttonInColorantPanel: "Show button in Colorants panel",
        colorCodePrimary: "Color code as primary",
        colorPanel: "KulÃ¶rpanel",
        colorPreviewAsImage: "FÃ¤rgexempel som bild",
        colorPreviewResizable: "Visning av fÃ¤rgÃ¤ndringar",
        competitiveColorSearch: "Konkurrerande kulÃ¶rsÃ¶kning",
        customFormula: "Custom formula",
        customFormulaForMasterProduct: "Allow create custom formulas for master product",
        customFormulaForMasterProductDefault: "Checked by default",
        customFormulas: "Anpassade recept",
        customPackageSettingsUnitGrav: "Anpassade produktinstÃ¤llningar gravimetriska enhet",
        customPackageSettingsUnitVol: "Anpassade produktinstÃ¤llningar volumetrisk enhet",
        customPackageSize: "Anpassad paketstorlek",
        customUnits: "VÃ¤lj specialenheter",
        dropDownCalculate: "Expand the drop down menu to the height of the window",
        editColorants: "Redigera brytpastor",
        editColorantsAllowed: "TillÃ¥t redigering av brytpasta",
        fandeckPanelSize: "StÃ¤ll in storlek pÃ¥ fÃ¤rgkort-panelen",
        favoriteFormulas: "Favoritrecept",
        formulaColorPreview: "FÃ¶rhandsgranskning av receptets kulÃ¶r",
        formulaDataSettings: "InstÃ¤llningar fÃ¶r receptdata",
        formulaPanel: "Receptpanel",
        formulaPanelSize: "Ange storlek pÃ¥ formelpanelen",
        formulaSettings: "ReceptinstÃ¤llningar",
        generateColorPreview: "Generera fÃ¶rhandsgranskning av fÃ¤rg",
        gravimetricOnly: "Endast gravimetriska enheter",
        hideAlternativeFormulas: "Hide alternative formulas",
        hideFormulaProperties: "Hide formula properties",
        hideHistoricalFormulas: "Hide historical formulas",
        imagesLocal: "AnvÃ¤nd endast bild frÃ¥n lokal databas",
        imagesOnline: "FÃ¶rsÃ¶k frÃ¤mst att Ã¶ppna onlinebild, om det misslyckas, Ã¶ppna lokal bild",
        infoPanelResizable: "StorleksÃ¤nderlig mer infopanel",
        numberOfColorants: "Number of shown colorants",
        orderByDistance: "Order of search results by the distance",
        productDependent: "Enheten Ã¤r beroende av den valda produkten",
        productFilesDialog: "Visa dialogruta fÃ¶r att Ã¶ppna lokal fil eller onlinefil",
        productFilesLocal: "AnvÃ¤nd endast produktfiler frÃ¥n lokal databas",
        productFilesOnline: "FÃ¶rsÃ¶k frÃ¤mst att Ã¶ppna online-produktfil, om den misslyckas, Ã¶ppna lokal fil",
        productPanelSize: "StÃ¤ll in storlek pÃ¥ produktpanelen",
        searchPanelQuickSelect: "Snabbval",
        setAdditionalFormulaPanel: "StÃ¤ll in ytterligare receptpanel",
        setCompetitiveColorSearch: "TillÃ¥t konkurrerande fÃ¤rgsÃ¶kning",
        setInitialFormulaPanel: "Ange inledande receptpanel ",
        setMaxToleranceForCompetitiveColors: "Ange maximal tolerans fÃ¶r att konkurrerande kulÃ¶rsÃ¶kning",
        setNumberOfCompetitiveColors: "Ange antal konkurrerande kulÃ¶rer",
        setSearchPanel: "StÃ¤ll in sÃ¶kpanel",
        setVisibilityAndOrder: "Ange synlighet och ordning fÃ¶r olika receptdata",
        setVisibleUnit: "Ange synliga enheter",
        showColorPreview: "Visa fÃ¶rhandsgranskningen av kulÃ¶r",
        showInFormulaStatusPanel: "Show in formula status panel",
        showInMoreInfoPanel: "Show in formula notes",
        sorting: "Sortering pÃ¥ fÃ¤rgpanelen",
        useBase: "AnvÃ¤nda ett urval fÃ¶r basen",
        useBaseInProductPackage: "AnvÃ¤nd ett urval fÃ¶r bas i produkten",
        useColorCode: "Use color code",
        useColorName: "Use color name",
        useFandeckGroups: "Use fandeck groups",
        useProduct: "AnvÃ¤nd ett urval fÃ¶r produkten",
        useProductCode: "AnvÃ¤nda produktkod",
        useProductGroups: "AnvÃ¤nda produktgrupper",
        volumetricOnly: "Endast volymetriska enheter"
    },
    general: {
        accepted: "Accepted",
        active: "Senaste aktivitet",
        actual: "Verklig",
        actualLevel: "Nuvarande nivÃ¥",
        add: "LÃ¤gg till",
        addColorant: "LÃ¤gg till brytpasta",
        addColorantForPackage: "Add colorant for package",
        addFile: "LÃ¤gg till fil",
        all: "Alla",
        amount: "MÃ¤ngd",
        applyNow: "Apply now",
        attachments: "Bilagor",
        automaticCorrection: "Automatic correction",
        automatically: "Automatiskt",
        available: "TillgÃ¤nglig",
        back: "Tillbaka",
        base: "Bas",
        baseInProductPackage: "Bas i produkt och paket",
        batchNumber: "Batch number",
        bottom: "LÃ¤ngst ned",
        buildingSite: "Building site",
        calculate: "BerÃ¤kna",
        can: "Burk/hink",
        canSize: "Storlek pÃ¥ burk/hink",
        cancel: "Avbryt",
        canister: "BehÃ¥llare ",
        canisterId: "BehÃ¥llar-ID",
        canisterIndex: "BehÃ¥llare index",
        canisters: "BehÃ¥llare",
        cap: "Lock",
        capacity: "Kapacitet",
        channels: "Kanaler",
        choose: "VÃ¤lj",
        city: "Ort",
        clean: "RengÃ¶r",
        clear: "Rensa",
        client: "Klient",
        close: "StÃ¤ng",
        closeAll: "StÃ¤ng alla",
        collapseAll: "DÃ¶lj alla",
        color: "KulÃ¶r",
        colorCode: "KulÃ¶rkod",
        colorFile: "Colorfile",
        colorName: "KulÃ¶rnamn",
        colorPreview: "FÃ¶rhandsgranskning av kulÃ¶r",
        colorant: "Brytpasta",
        colorantBatchNumber: "Colorant Batch number",
        colorantPackage: "Brytpastapaket",
        colorants: "Brytpastor",
        colors: "Colors",
        company: "FÃ¶retag",
        competitiveColor: "Competitive color",
        confirm: "BekrÃ¤fta",
        confirmDeletion: "Vill du ta bort den hÃ¤r artikeln permanent?",
        confirmHelpSettings: "Vill du spara det hÃ¤r formulÃ¤ret och lÃ¤mna fÃ¤ltet tomt?",
        connect: "Anslut",
        continue: "FortsÃ¤tt",
        correction: "Correction",
        country: "Land",
        created: "Skapat",
        creationDateOf: "Creation date of",
        criticalLevel: "Kritisk nivÃ¥",
        currency: "Valuta",
        currentBatchNumber: "Current batch number",
        currentUfiCode: "Current UFI code",
        custom: "Anpassat",
        customData: "Custom data",
        customFandeck: "Anpassade fÃ¤rgkartor",
        customFormula: "Anpassad formel",
        customPackage: "Anpassat",
        customPackageSettings: "Anpassade produktinstÃ¤llningar",
        customer: "Kund",
        customerVersion: "Kundversion",
        customers: "Kunder",
        database: "Databaser",
        date: "Datum",
        default: "StandardinstÃ¤llningar",
        delete: "Ta bort",
        deleteImportedData: "Delete imported records",
        delta: "Delta",
        description: "Beskrivning",
        disconnect: "Koppla bort",
        discount: "Rabatt",
        discover: "Identifiera",
        dispense: "Dosera",
        dispensing: "Dosera",
        doNotShowAgain: "Visa inte det hÃ¤r meddelandet igen.",
        downloadingFile: "HÃ¤mtar filer",
        edit: "Redigera",
        email: "E-post",
        enabled: "Aktiverat",
        error: "Fel",
        expandAll: "Expandera alla",
        exportData: "Exportera data",
        exportPdf: "Exportera pdf",
        fan: "FÃ¤rgkarta",
        fandeck: "FÃ¤rgkarta",
        fandeckCode: "Fandeck code",
        fandeckName: "Namn pÃ¥ fÃ¤rgkarta",
        fandecks: "FÃ¤rgkartor",
        favorite: "Favorit",
        fileTransfer: "FilÃ¶verfÃ¶ring",
        filling: "Fyllning",
        fillingDate: "Fyllningsdatum",
        find: "SÃ¶k",
        finish: "Avsluta",
        finishedCorrection: "Finished correction",
        formula: "Recept",
        formulas: "Formulas",
        frontdesk: "Frontdesk ",
        getQrCode: "HÃ¤mta QR-kod",
        gravimetric: "Gravimetrisk",
        historical: "Historical",
        history: "Historik",
        hours: "Hou.",
        id: "ID",
        images: "Bilder",
        in: "In",
        index: "Index",
        insertBarcode: "Infoga streckkod",
        install: "Installera",
        installed: "Installerat",
        instructions: "Instruktioner",
        internalNote: "Intern anteckning",
        interval: "Intervall",
        ip: "IP-adress",
        itemNumber: "Item no.",
        itemXOfY: "Item %{x}/%{y}",
        itemsCount: "Items count",
        later: "Later",
        limit: "GrÃ¤ns",
        load: "Last",
        loadFormula: "LÃ¤s in recept",
        localVersion: "Lokal version",
        machine: "Maskin",
        manualCorrection: "Manual correction",
        manually: "Manuellt",
        margin: "Marginal",
        markup: "PÃ¥slag",
        matching: "Matching",
        matchingFormula: "Matching formula",
        maxLevel: "Maximal nivÃ¥",
        maxValue: "Max.",
        maximum: "Maximalt",
        mayTakeAWhile: "This may take a while",
        measured: "Measured",
        metamarism: "Metamarism",
        minimum: "Minimalt",
        minutes: "Min.",
        missingItem: "Artikeln saknas",
        missingRequiredItems: "Alla obligatoriska fÃ¤lt (markerade med en asterisk) mÃ¥ste fyllas i",
        modified: "Modified",
        modifiedAutomaticCorrection: "Target color correction",
        modifiedCustomFormula: "Modified custom formula",
        modifiedStandardFormula: "Modified standard formula",
        moduleChange: "Module change",
        more: "Mer",
        moreInfo: "Mer information",
        moveDown: "Flytta nedÃ¥t",
        moveUp: "Flytta uppÃ¥t",
        myOrders: "Mina order",
        name: "Namn",
        nameTitle: "Titel",
        new: "Nytt",
        next: "NÃ¤sta",
        no: "Nej",
        noColorantsAvailable: "Ingen brytpasta Ã¤r tillgÃ¤nglig",
        noFormulas: "Inga recept Ã¤nnu",
        noPricesAvailable: "Inga priser tillgÃ¤ngliga",
        nominalAmount: "Nominell mÃ¤ngd",
        notAvailable: "Inte tillgÃ¤ngligt",
        note: "Anteckning",
        numberOfCanisters: "Antal behÃ¥llare",
        numberOfItemCount: "Number of '%{item}': %{count}",
        numberOfLabels: "Antal etiketter",
        numberOfPackages: "Antal paket",
        off: "Av",
        ok: "OKEJ",
        on: "PÃ¥",
        onFocus: "I fokus",
        open: "Ãppna",
        operator: "Operator",
        options: "Alternativ",
        order: "Order",
        other: "Ãvrigt",
        otherError: "Andra fel",
        out: "Ut",
        overwrite: "Overwrite",
        package: "Paket",
        packagePreview: "FÃ¶rhandsgranskning av paket",
        partialUpdates: "Partial updates",
        phone: "Telefon",
        pleaseWait: "SnÃ¤lla vÃ¤nta",
        previous: "Previous",
        price: "Pris",
        priceGroup: "Prisgrupp",
        print: "Skriv ut",
        printTask: "Skriva ut uppgift",
        processingStep: "Processing %{step}",
        product: "Produkt",
        productCode: "Produktkod",
        productName: "Produktnamn",
        products: "Produkter",
        pump1: "Pump 1",
        pump2: "Pump 2",
        purchasePrice: "InkÃ¶pspris",
        purge: "Rensa",
        qualityControl: "Quality control",
        quantity: "MÃ¤ngd",
        quantityQty: "QTY",
        quickTint: "Snabbrytning",
        rccIsNotAvailable: "RCC Ã¤r inte tillgÃ¤ngligt",
        rccIsNotConnected: "RCC Ã¤r inte anslutet",
        rccNotLicensed: "RCC Ã¤r inte licensierat",
        reconnect: "Ãteranslut",
        refill: "Fyll pÃ¥",
        refillManualLevelCorrection: "Manual correction",
        reformulation: "Reformulation",
        reloadTab: "Reload Tab",
        reset: "ÃterstÃ¤ll",
        restart: "Starta om",
        restore: "ÃterstÃ¤ll",
        retint: "Retint",
        revision: "Revision",
        safetySheet: "SÃ¤kerhetsblad",
        save: "Spara",
        saveAs: "Spara som",
        saveToDispensingHistory: "Spara i historik",
        searchResult: "Search result",
        searching: "Searching",
        seconds: "Sek.",
        select: "Select",
        selectAll: "Markera alla",
        selectChannels: "VÃ¤lj kanaler",
        selectColumns: "Select columns to work with",
        selectXFirst: "Select %{item} first",
        sellPrice: "SÃ¤lj pris",
        settings: "InstÃ¤llningar",
        shelf: "Hylla",
        showItem: "Show %{item}",
        showOptions: "Show another options",
        size: "Storlek",
        skip: "Hoppa Ã¶ver",
        smartPurge: "Smart rengÃ¶ring",
        softwareRestartInSeconds: "%{software} will be automatically restarted in %{seconds} seconds",
        sortResults: "Sort results",
        spectro: "Spektrometer",
        standardFormula: "Standardformel",
        status: "Status",
        street: "Gata",
        sum: "Sum",
        summary: "Sammanfattning",
        sync: "Synkronisera",
        technicalSheet: "Tekniskt blad",
        templates: "Mallar",
        threshold: "Threshold",
        ticketing: "Ticketing",
        tintometricSystem: "Tintometric system",
        toDispenseOrders: "Att dosera",
        top: "HÃ¶gst upp",
        total: "Totalt",
        totalAmount: "Totala",
        totalBaseAmount: "Total basmÃ¤ngd",
        totalColorantAmount: "Total brytfÃ¤rgsmÃ¤ngd",
        type: "Type",
        ufiCode: "UFI-kod",
        ufiThreshold: "UFI-trÃ¶skel",
        unableToSynchronize: "Unable to synchronize",
        undefined: "Undefined",
        unit: "Enhet",
        units: "Enheter",
        unknown: "Unknown",
        update: "Uppdatera",
        updated: "Uppdaterat",
        user: "AnvÃ¤ndare",
        value: "VÃ¤rde",
        vat: "Moms",
        verified: "Verified",
        version: "Version",
        versionId: "Versions-ID",
        versionStructure: "Versionsstruktur",
        volumetric: "Volymetriska",
        warning: "Varning",
        warningLevel: "VarningsnivÃ¥",
        withoutName: "(utan namn)",
        workingProperly: "Working properly",
        yes: "Ja",
        zoom: "Zooma"
    },
    help: {
        autotasks: {
            brushMaintenance:
                "StÃ¤ll in denna automatiska uppgift fÃ¶r att fÃ¥ %{name} att begÃ¤ra rengÃ¶ring av borstbehÃ¥llaren vid en viss tidpunkt. DispenseroperatÃ¶ren mÃ¥ste ta bort, rengÃ¶ra och sedan sÃ¤tta tillbaka borstbehÃ¥llaren manuellt.",
            capMaintenance:
                "StÃ¤ll in denna automatiska uppgift fÃ¶r att fÃ¥ %{name} att begÃ¤ra rengÃ¶ring av locket vid en viss tidpunkt. DispenseroperatÃ¶ren mÃ¥ste rengÃ¶ra autocapen manuellt nÃ¤r den Ã¶ppnas.",
            cleanAll:
                "StÃ¤ll in denna automatiska uppgift fÃ¶r att dispensern ska utfÃ¶ra automatisk rengÃ¶ring av samtliga kanaler vid en viss tidpunkt.",
            cleanChannels:
                "StÃ¤ll in denna automatiska uppgift fÃ¶r att dispensern ska utfÃ¶ra automatisk rengÃ¶ring av samtliga kanaler vid en viss tidpunkt.",
            computerReboot:
                "StÃ¤ll in denna automatiska uppgift fÃ¶r att datorn ska startas om automatiskt vid en viss tidpunkt.",
            computerShutdown:
                "StÃ¤ll in denna automatiska uppgift fÃ¶r att datorn ska stÃ¤ngas av automatiskt vid angivelse av tidsinstÃ¤llningar.",
            dispenserCleaning:
                "StÃ¤ll in denna automatiska uppgift fÃ¶r att fÃ¥ %{name} att begÃ¤ra rengÃ¶ring av dispensern vid en viss tidpunkt. DispenseroperatÃ¶ren mÃ¥ste rengÃ¶ra maskinen manuellt med en trasa.",
            humidifierWaterLevelMaintenance:
                "StÃ¤ll in denna automatiska uppgift fÃ¶r att fÃ¥ %{name} att begÃ¤ra pÃ¥fyllning av luftfuktaren vid en viss tidpunkt. DispenseroperatÃ¶ren mÃ¥ste manuellt kontrollera och fylla pÃ¥ vattnet i luftfuktaren.",
            purgeAll:
                "StÃ¤ll in denna automatiska uppgift fÃ¶r att dispensern ska rengÃ¶ra samtliga kanaler vid en viss tidpunkt.",
            purgeChannels:
                "StÃ¤ll in denna automatiska uppgift fÃ¶r att dispensern ska rengÃ¶ra vissa kanaler vid en viss tidpunkt.",
            recirculateAll:
                "StÃ¤ll in denna automatiska uppgift fÃ¶r att dispensern ska utfÃ¶ra Ã¥tervinning av samtliga kanaler vid en viss tidpunkt.",
            recirculateChannels:
                "StÃ¤ll in denna automatiska uppgift fÃ¶r att dispensern ska utfÃ¶ra Ã¥tervinning av vissa kanaler vid en viss tidpunkt.",
            refillAll:
                "Ange att den hÃ¤r autotask ska ha %{name} om du vill att Ã¥tgÃ¤rden ska fyllas i automatiskt vid den definierade tidpunkten. BrytmaskinsoperatÃ¶ren mÃ¥ste fylla pÃ¥ fÃ¤rgÃ¤mnen i alla behÃ¥llare manuellt.",
            refillCanisters:
                "Ange att den hÃ¤r autotask ska ha %{name} om du vill att Ã¥tgÃ¤rden ska fyllas i pÃ¥ vissa kanaler automatiskt vid den specifika tidpunkten. BrytmaskinsoperatÃ¶ren mÃ¥ste manuellt fylla pÃ¥ fÃ¤rgÃ¤mnen i behÃ¥llare som inte uppfyller pÃ¥fyllningskriteriet.",
            smartPurgeAll:
                "StÃ¤ll in denna automatiska uppgift fÃ¶r att dispensern automatiskt ska utfÃ¶ra smart rengÃ¶ring av samtliga kanaler vid en viss tidpunkt. RengÃ¶ringen utfÃ¶rs om inte reglerna fÃ¶r smart rengÃ¶ring har uppfyllts.",
            smartPurgeChannels:
                "StÃ¤ll in denna automatiska uppgift fÃ¶r att dispensern automatiskt ska utfÃ¶ra smart rengÃ¶ring av vissa kanaler vid en viss tidpunkt. RengÃ¶ringen utfÃ¶rs om inte reglerna fÃ¶r smart rengÃ¶ring har uppfyllts.",
            stirAll:
                "StÃ¤ll in denna automatiska uppgift fÃ¶r att dispensern ska utfÃ¶ra omrÃ¶rning av samtliga kanaler vid en viss tidpunkt.",
            stirCanisters:
                "StÃ¤ll in denna automatiska uppgift fÃ¶r att dispensern ska utfÃ¶ra omrÃ¶rning av vissa kanaler vid en viss tidpunkt.",
            switchPlateMaintenance:
                "StÃ¤ll in denna automatiska uppgift fÃ¶r att fÃ¥ %{name} att begÃ¤ra rengÃ¶ring av switch-plÃ¥ten en viss tidpunkt. DispenseroperatÃ¶ren mÃ¥ste ta bort, rengÃ¶ra och sedan sÃ¤tta tillbaka kontaktplÃ¥ten manuellt."
        },
        colorantBatchNumber: {
            batchNumberByPercentage:
                "The Batch number which prevails is used for printing considering its actual amount in the canister. Navigate to Canister settings to define the threshold for each canister.",
            batchNumberFromLastFilling:
                "The Batch from the last refill given by the operator is used for printing regardless the refilled amount.",
            enableBatchNumber: "With this setting on, refilled colorant batches are tracked."
        },
        connection: {
            add: "TillÃ¥t att en ny server lÃ¤ggs till manuellt om den inte hittas med identifieringsfunktionen.",
            clientIdentifier:
                "Med den hÃ¤r instÃ¤llningen kan du identifiera den hÃ¤r klienten om flera klienter Ã¤r anslutna till en server.",
            disconnect:
                "Information om den server som anvÃ¤nds fÃ¶r nÃ¤rvarande. FrÃ¥nkopplingsknappen lÃ¥ter dig lÃ¤mna servern och vÃ¤xla till en annan tillgÃ¤nglig server.",
            discover: "Identifierar eventuella tillgÃ¤ngliga servrar i nÃ¤tverket.",
            dropServers: "Ta bort alla tidigare identifierade servrar frÃ¥n listan.",
            dropServersNotAvailable: "Ingen server tillgÃ¤nglig",
            edit: "TillÃ¥ter manuell redigering av en redan hittad server.",
            editDisabled: "Ingen server har valts."
        },
        continue: "Vill du verkligen fortsÃ¤tta?",
        driverSettings: {
            alfaRestApi: {
                host: "Ange datorns vÃ¤rdnamn eller IP-adress.",
                machineType: "GÃ¤ller alla Alfa-maskiner. Windows sÃ¥ vÃ¤l som Linux."
            },
            corobDsProxy: {
                machineType:
                    "GÃ¤ller fÃ¶r generationerna Slave (D200, D600 ..), 4G (First One) och 5G (EvoFlx). DspProxy mÃ¥ste installeras. Endast Windows."
            },
            corobEvoDriver: {
                machineType:
                    "GÃ¤ller fÃ¶r generation 5G (EvoFlx). EVOservice mÃ¥ste installeras. Windows sÃ¥ vÃ¤l som Linux."
            },
            corobFlex500LLD: {
                dispenserConfigurationFile: "VÃ¤lj konfigurationsfil fÃ¶r dispensern. StandardinstÃ¤llning.",
                hldRootDir: "VÃ¤lj huvudmappen fÃ¶r HLD. StandardinstÃ¤llning.",
                machineType:
                    "GÃ¤ller fÃ¶r Corob Flex (500, 520, 540) = tidigare Lenteq. HLD mÃ¥ste installeras. Endast Windows."
            },
            corobNextDriver: {
                machineType:
                    "GÃ¤ller fÃ¶r generationerna Slave (D200, D600 ..), 4G (First One) och 5G (EvoFlx). NextDriver mÃ¥ste installeras. Endast Linux."
            },
            dromontDDrv: {
                databasePath: "SÃ¶kvÃ¤g till databasfilen med kalibreringsdata. StandardinstÃ¤llning.",
                driverPath: "DrivrutinssÃ¶kvÃ¤g (D_DRV.exe). StandardinstÃ¤llning.",
                machineType:
                    "Indirekt kommunikation med brytmaskin via angivna sÃ¶kvÃ¤gar. GÃ¤ller generationerna V1 och V2. D_SET mÃ¥ste installeras. Windows sÃ¥ vÃ¤l som Linux.",
                resultPath: "SÃ¶kvÃ¤g till resultatfilen som skapas nÃ¤r Ã¥tgÃ¤rden Ã¤r slutfÃ¶rd. StandardinstÃ¤llning.",
                serviceSoftwarePath: "SÃ¶kvÃ¤g till programvara fÃ¶r Dromont-tjÃ¤nsten (D_SET.exe). StandardinstÃ¤llning."
            },
            dromontDirect: {
                machineType:
                    "Direkt kommunikation med brytmaskin. GÃ¤ller generationerna V1 och V2. D_SET mÃ¥ste installeras. Windows sÃ¥ vÃ¤l som Linux.",
                rootDir: "VÃ¤lj huvudmappen Dromont. StandardinstÃ¤llning."
            },
            dromontMisura: {
                driverPath:
                    "SÃ¶kvÃ¤g till drivrutinen (MisuraRetail.exe) kanske Ã¤ndras beroende pÃ¥ versionen av Misura Retail. StandardinstÃ¤llning.",
                extensionPath: "SÃ¶kvÃ¤g till kommunikationsfil fÃ¶r serviceÃ¥tgÃ¤rder.",
                formulaPath: "SÃ¶kvÃ¤g till kommunikationsfilen fÃ¶r brytning.",
                machineType: "GÃ¤ller fÃ¶r generation V3. Dromont Misura mÃ¥ste installeras. Endast Windows."
            },
            fastAndFluidIDD: {
                machineType: "GÃ¤ller alla F&F-maskiner. Endast Windows.",
                path: "StÃ¶d fÃ¶r IDD2 (HA 450, HA 650, X-smart, etc.) â krÃ¤ver licens, IDD3 (HP 500, o.s.v.), IDD4 (HA 180, HA 480, HA 680, Xprotint, o.s.v.)"
            },
            fastAndFluidUIDD: {
                host: "Type in the computer host name or computer IP address.",
                machineType: "GÃ¤ller alla F&F-maskiner. Windows sÃ¥ vÃ¤l som Linux.",
                password: "Type in the user password.",
                port: "Select the port number.",
                user: "Type in the user name."
            },
            heroPCPDriver: {
                machineType: "GÃ¤ller alla Hero-maskiner. Endast Windows."
            },
            italtinto: {
                machineType:
                    "GÃ¤ller alla Italtinto-maskiner. Wcal eller ItaltintoCal mÃ¥ste installeras. Endast Windows.",
                path: "SÃ¶kvÃ¤g till den justerade Italtinto-konfigurationsfilen."
            },
            manualAdvanced: {
                machineType: "GÃ¤ller fÃ¶r alla manuella maskiner, med stÃ¶d fÃ¶r behÃ¥llare. Windows sÃ¥ vÃ¤l som Linux.",
                path: "SÃ¶kvÃ¤g till konfigurationsfilen med data om brytmaskinen och behÃ¥llarna."
            },
            manualSimple: {
                machineType: "GÃ¤ller fÃ¶r alla manuella maskiner. Windows sÃ¥ vÃ¤l som Linux.",
                path: "SÃ¶kvÃ¤g till konfigurationsfilen med data om brytmaskinen."
            },
            none: {
                machineType: "Ingen drivrutin fÃ¶r brytmaskinen har valts."
            },
            santintColorLink3: {
                machineType: "GÃ¤ller fÃ¶r alla Santint-maskiner. Endast Windows."
            },
            simulation: {
                machineType:
                    "GÃ¤ller fÃ¶r simulering av brytmaskin om det inte finns nÃ¥gon riktig brytmaskin ansluten till datorn.",
                path: "SÃ¶kvÃ¤g till simuleringskonfigurationsfilen som mÃ¥ste Ã¶verensstÃ¤mma med den infogade databasen."
            },
            udcp: {
                machineType: "UDCP-dispenser"
            }
        },
        environment: {
            activeServerPlugins: "Ãversikten Ã¶ver ytterligare plugin-programvara.",
            allowAutoCloseTab:
                "NÃ¤r instÃ¤llningen har aktiverats stÃ¤ngs varje receptflik automatiskt nÃ¤r doseringsprocessen har avslutats.",
            allowAutomaticClientStart: "Med den hÃ¤r instÃ¤llningen startar %{name} automatiskt nÃ¤r datorn har startats.",
            allowAutomaticPrint:
                "Etiketten skrivs ut automatiskt. KrÃ¤ver ytterligare instÃ¤llningar om utskrift fÃ¶re brytning, efter brytning eller bÃ¥de och.",
            allowBuildingSitePanel: "On Formula Panel, building site panel will be available.",
            allowCustomers: "PÃ¥ receptpanelen Ã¤r kundavsnittet tillgÃ¤ngligt.",
            allowDispensing:
                "PÃ¥ receptpanelen aktiveras knappen Bryt tillsammans med brytningsinstÃ¤llningar i maskininstÃ¤llningar.",
            allowFileTransfer:
                "Med den hÃ¤r instÃ¤llningen aktiverad Ã¤r automatisk dataimport och export nÃ¤r  filÃ¶verfÃ¶ring Ã¤r tillgÃ¤nglig.",
            allowFormulaModificationPanel: "On Formula Panel, Modification panel will be activated.",
            allowFormulaStatusPanel: "PÃ¥ formelpanelen aktiveras statuspanelen.",
            allowLight: "%{name} Ã¤r tillgÃ¤ngligt.",
            allowOrdering: "PÃ¥ receptpanelen aktiveras orderknappen Order.",
            allowPricing:
                "PÃ¥ receptpanelen kan priserna anvÃ¤ndas. Prissynlighet anges i tillgÃ¤ngliga priser. Priserna anges i PrisinstÃ¤llningar.",
            allowProductPreviewImage: "Produktbilden visas under brytning.",
            allowQualityControl: "Quality control will be activated.",
            allowSearchCheaperColors:
                "PÃ¥ Formelpanelen kommer funktionen att sÃ¶ka efter billigare fÃ¤rger att vara tillgÃ¤nglig.",
            allowSoundNotification: "Orderavisering. En melodi spelas upp nÃ¤r en order tas emot.",
            allowSpectro: "Spektrometer",
            allowTabs: "NÃ¤r det hÃ¤r alternativet Ã¤r aktiverat Ã¤r det mÃ¶jligt att arbeta med flera flikar samtidigt.",
            applyZoom:
                "Zoom fÃ¶rstorar eller fÃ¶rminskar upplÃ¶sningen. Kortkommandona CTRL + och CTRL - kan ocksÃ¥ anvÃ¤ndas.",
            automaticLogout: "StÃ¤ll in efter hur mÃ¥nga minuter den automatiska utloggningen ska aktiveras.",
            availableDatabases: "Med instÃ¤llningarna kan du vÃ¤xla mellan databaser om fler Ã¤n en Ã¤r tillgÃ¤nglig.",
            backupLocalDB: "Exports the local databse. The exported file can be used as database backup.",
            barcodeTesting:
                "Streckkodstester anvÃ¤nds fÃ¶r att kontrollera riktigheten hos den skannade streckkoden genom att jÃ¤mfÃ¶ra den med streckkoderna i databasen.",
            customBanner: "Ange din egen logotyp eller banner och dess position.",
            customCurrencyFormat: "Anpassat valutaformat kan Ã¥sidosÃ¤tta standardvalutaformat baserat pÃ¥ valt sprÃ¥k. ",
            customDateFormat: "Anpassat datumformat kan Ã¥sidosÃ¤tta standarddatumformat baserat pÃ¥ valt sprÃ¥k.",
            customNumberFormat: "Anpassat numeriskt format kan Ã¥sidosÃ¤tta standard numer-format baserat pÃ¥ valt sprÃ¥k.",
            customTimeFormat: "Anpassat tidsformat kan Ã¥sidosÃ¤tta standardtidsformat baserat pÃ¥ valt sprÃ¥k.",
            defaultPrinter:
                "Den valda skrivaren anvÃ¤nds fÃ¶r att skriva ut etiketter, sÃ¥vida detta inte Ã¤ndras i fÃ¶nstret Skrivaralternativ.",
            defaultTemplate:
                "Den valda mallen anvÃ¤nds fÃ¶r att skriva ut etiketter, sÃ¥vida detta inte Ã¤ndras i fÃ¶nstret Skrivaralternativ.",
            deleteImportedData:
                "Ta bort tidigare importerade anpassade data. Data kan Ã¥terimporteras efter borttagning.",
            diskSpaceNotification: "Checks the available disk space and notifies in case of insufficient space.",
            dispensingNotes: "PÃ¥ receptpanelen Ã¤r avsnittet brytningsanteckningar tillgÃ¤ngligt.",
            downloadListEmpty: "No downloads in progress",
            enableVirtualKeyboard: "I %{name} Ã¤r det virtuella tangentbordet tillgÃ¤ngligt.",
            exportLocalSettings: "Exporterar den hÃ¤r datorns lokala instÃ¤llningar.",
            exportStaticSql:
                "Exporterar den hÃ¤r datorns lokala instÃ¤llningar. Den exporterade filen kan anvÃ¤ndas fÃ¶r att skapa en databas med samma instÃ¤llningar.",
            exportTranslationKeys:
                "Exportera de senaste Ã¶versÃ¤ttningarna och skicka dem efter Ã¶versÃ¤ttning via e-post till din programvaruleverantÃ¶r fÃ¶r att fÃ¥ dem importerade.",
            favoriteButton: "Klicka hÃ¤r fÃ¶r att lÃ¤gga till recept som favorit",
            formulaNotes: "PÃ¥ receptpanelen Ã¤r avsnittet receptanteckningar tillgÃ¤ngligt.",
            helpSettings: "Informationen visas i hjÃ¤lpavsnittet pÃ¥ snabbÃ¥tkomstpanelen.",
            importCustomData: "Importerar lokala anpassade data baserat pÃ¥ det valda formatet.",
            importExcelFile: "Import the excel file with data to be added to database.",
            importsLocalSettings: "Importerar den hÃ¤r datorns lokala instÃ¤llningar.",
            internalNote: "PÃ¥ formelpanelen kommer det interna anteckningsavsnittet att vara tillgÃ¤ngligt.",
            lockComputer:
                "InstÃ¤llningarna sÃ¤kerstÃ¤ller att miljÃ¶n fÃ¶r %{name} inte kan lÃ¤mnas â det ger den ultimata helskÃ¤rmsupplevelsen av programmet. GÃ¤ller endast fÃ¶r Windows.",
            maxNumberTabs: "FlikbegrÃ¤nsning anger hur mÃ¥nga receptflikar som kan vara Ã¶ppna samtidigt.",
            memoryTabs: "Allow reopening of recently opened tabs after the software starts.",
            printAfterDispensing:
                "Den hÃ¤r instÃ¤llningen krÃ¤ver information om hur mÃ¥nga etikettkopior som ska skrivas ut efter brytningsprocessen.",
            printAsImage:
                "Skriv ut som bild kan lÃ¶sa problem nÃ¤r standardutskrift misslyckas. AnvÃ¤nd inte nÃ¤r standardutskriften fungerar. Endast kompatibelt med Linux.",
            printBeforeDispensing:
                "Den hÃ¤r instÃ¤llningen krÃ¤ver information om hur mÃ¥nga etikettkopior som ska skrivas ut fÃ¶re brytningsprocessen.",
            printEnabled:
                "Den hÃ¤r instÃ¤llningen gÃ¶r att du kan anvÃ¤nda skrivaren tillsammans med programvaran. Ytterligare instÃ¤llningar finns i Utskriftsalternativ.",
            printOnRequest: "PÃ¥ receptpanelen aktiveras knappen Skriv ut.",
            printTaskVariable:
                "Utskriftsuppgiften bearbetas endast om en given utskriftsvariabel Ã¤r tillgÃ¤nglig i utskriftsdata",
            quickTintTemplate: "Den valda mallen anvÃ¤nds nÃ¤r du skriver ut snabbrytningsetiketter.",
            restoreLocalSettings: "ÃterstÃ¤ller den hÃ¤r datorns lokala instÃ¤llningar.",
            runLightAtStartUp: "%{light} startas i stÃ¤llet fÃ¶r %{name}.",
            screenSaverTimeout: "Ange tidsgrÃ¤ns fÃ¶r skÃ¤rmslÃ¤ckare",
            selectCustomDataFormat:
                "VÃ¤lj format pÃ¥ originaldata som ska importeras. Varje format kan krÃ¤va ytterligare filer och instÃ¤llningar.",
            setCustomHomeButton: "Knappen Hem i %{name} omdirigerar till den valda panelen.",
            setFts: "FulltextsÃ¶kning mÃ¶jliggÃ¶r sÃ¶kning i fulltextrecept (Ã¤ven frÃ¥n mitten av ordet o.s.v.).",
            setKeyboardShortcuts: "Det gÃ¥r inte att ange samma kortkommando fÃ¶r tvÃ¥ olika Ã¥tgÃ¤rder.",
            setNumberOfDecimalPlaces:
                "Avrundning anger hur mÃ¥nga decimaler som ska anvÃ¤ndas fÃ¶r brytpastor i recepten.",
            setOrderSearchParameters:
                "OrdersÃ¶kning definierar vilka parametrar som ska anvÃ¤ndas vid sÃ¶kning bland order. Endast tillgÃ¤ngligt i %{name}.",
            setOverwriteLastTab:
                "NÃ¤r du vÃ¤ljer ett nytt recept via global sÃ¶kning och begrÃ¤nsningen fÃ¶r antalet receptfliken nÃ¥s, skrivs den senast inlÃ¤sta receptfliken Ã¶ver av det nya receptet.",
            setSearchPanel: "Ange synlighet och ordning fÃ¶r de objekt som anvÃ¤nds vid sÃ¶kning efter ett nytt recept.",
            setVisibilityAndOrder:
                "De valda navigeringsobjekten visas pÃ¥ snabbÃ¥tkomstpanelen. Den hÃ¶gsta positionen hÃ¤r definierar vÃ¤nsterpositionen i panelen. Den maximala mÃ¤ngden tillÃ¥tna navigeringsobjekt Ã¤r 6.",
            setYourLanguage: "Byte av sprÃ¥k krÃ¤ver att programvaran startas om.",
            settingsSearch: "SlÃ¥ upp olika instÃ¤llningar om du Ã¤r osÃ¤ker pÃ¥ var du hittar dem.",
            showNewOrderNotifications:
                "Orderavisering Ã¤r ett popup-fÃ¶nster som meddelar att en ny order har tagits emot.",
            sorting: "Snabbrytning kan ha behÃ¥llarna ordnade efter brytpastornas namn eller behÃ¥llar-ID.",
            turnOnKioskMode: "HelskÃ¤rmslÃ¤ge startas och aktivitetsfÃ¤ltet dÃ¶ljs.",
            windowClosingRules:
                "Den hÃ¤r instÃ¤llningen avgÃ¶r om snabbrytningsfÃ¶nstret stÃ¤ngs fÃ¶re eller efter det att brytningsprocessen inleds."
        },
        formulaSettings: {
            additionalFormulaTab: "InstÃ¤llningen avgÃ¶r vilken panel som visas nÃ¤r en ny receptflik Ã¶ppnas.",
            allowCustomFormulas: "Aktiverar mÃ¶jligheten att skapa och sÃ¶ka efter anpassade recept.",
            allowCustomPackageSize: "PÃ¥ receptpanelen aktiveras alternativet anpassad paketstorlek.",
            allowEditingColorants:
                "PÃ¥ receptpanelen aktiveras knappen Redigera brytpasta (visas nÃ¤r en kulÃ¶r har valts).",
            alternativeFormulasPosition: "Defines how to access alternative formulas.",
            basePanelSize: "Ange basstorlek pÃ¥ formelpanelen",
            bippPanelSize: "Ange basstorlek i produktpaket pÃ¥ formelpanelen",
            blendColorNameAndCode:
                "The setting joins together the search fields for Color name and code to create one search field only.",
            color: "PÃ¥ receptpanelen Ã¤r fÃ¶rhandsgranskningen av kulÃ¶r den enda synliga informationen.",
            colorCodePrimary: "Color code will be displayed first in the search field.",
            colorPreviewAsImage: "PÃ¥ formelpanelen representeras fÃ¤rgfÃ¶rhandsgranskningen av bilden.",
            colorPreviewResizable: "GÃ¶r det mÃ¶jligt att Ã¤ndra storlek pÃ¥ panelen fÃ¶r fÃ¶rhandsgranskning av fÃ¤rger.",
            colorantPanelLimit:
                "The settings sets the number of colorants that will be always visible before it hides under scroll bar.",
            colorantPanelOrderBy: "Formelpanelen kan ordna fÃ¤rgÃ¤mnena efter namn eller belopp.",
            customCanOption: "VÃ¤lj vilka mÃ¥ttenheter som kan anvÃ¤ndas fÃ¶r anpassad produktstorlek pÃ¥ formelpanelen.",
            customCanSettingsUnit:
                "VÃ¤lj vilken mÃ¥ttenhet som ska anvÃ¤ndas som standard fÃ¶r anpassade produktinstÃ¤llningar pÃ¥ formelpanelen.",
            customFormulaForMasterProduct:
                "Defines whether the option âFormula for master productâ is displayed when saving custom formula",
            customFormulaForMasterProductDefault:
                "Defines whether the option âFormula for master productâ is checked by default",
            deleteConfirmation:
                "Om du aktiverar det hÃ¤r alternativet visas popup-fÃ¶nster fÃ¶r att bekrÃ¤fta borttagning av ett objekt.",
            dropDownCalculate:
                "The drop-down menu to select the formula you are looking for will extend to the bottom of the window.",
            fandeckGroups: "The setting enables hierarchy with fandeck groups if available in the database.",
            fandeckPanelSize: "StÃ¤ll in storleken pÃ¥ fÃ¤rgkort pÃ¥ formelpanelen",
            favoriteFormulasInitial: "NÃ¤r du startar %{name} visas favoritpanelen.",
            formulaAutomaticNaming:
                "Ett Ã¤ndrat recept fÃ¥r ett namn automatiskt baserat pÃ¥ de Ã¤ndringar som gjorts av brytpastan.",
            formulaPanel: "NÃ¤r du Ã¶ppnar en ny flik visas receptpanelen.",
            formulaPanelInitial: "NÃ¤r du startar %{name} visas receptpanelen.",
            formulaPanelSize: "Ange formelstorlek pÃ¥ formelpanelen",
            formulaPropertiesPosition: "Defines how to access formula properties.",
            generateColorPreview:
                "Med den hÃ¤r instÃ¤llningen aktiverad genereras fÃ¤rgfÃ¶rhandsgranskningen automatiskt. Den resulterande fÃ¶rhandsgranskningen Ã¤r inte korrekt.",
            historicalFormulasPosition: "Defines how to access historical formulas.",
            image: "PÃ¥ receptpanelen visas produktbilden bredvid fÃ¶rhandsgranskningen av kulÃ¶ren med mÃ¶jlighet att Ã¶ppna panelen med mer info.",
            images: "InstÃ¤llningen definierar kÃ¤llan till bildfiler.",
            infoPanelResizable: "GÃ¶r det mÃ¶jligt att Ã¤ndra storlek pÃ¥ mer informationspanel.",
            initialFormulaTab: "Den hÃ¤r instÃ¤llningen avgÃ¶r vilken panel som visas nÃ¤r %{0} startar.",
            moreInfo:
                "PÃ¥ receptpanelen visas informationspanelen bredvid fÃ¶rhandsgranskningen av kulÃ¶ren och produktbilden.",
            orderByDistance: "With this setting on, the result of color search is ordered by special distance metric.",
            productCode:
                "Denna instÃ¤llning gÃ¶r att du kan anvÃ¤nda produktkoder tillsammans med produktnamn om informationen finns tillgÃ¤nglig i databasen.",
            productFiles: "InstÃ¤llningen definierar kÃ¤llan till produktfiler som Ã¤r tillgÃ¤ngliga pÃ¥ formelpanelen.",
            productGroups: "InstÃ¤llningen mÃ¶jliggÃ¶r hierarki med produktgrupper om den Ã¤r tillgÃ¤nglig i databasen.",
            productPanelSize: "Ange produktstorlek pÃ¥ formelpanelen",
            searchNewFormula:
                "NÃ¤r du Ã¶ppnar en ny flik visas SÃ¶k efter nytt recept (innehÃ¥ller information om senast brutna recept och favoritrecept).",
            searchNewFormulaInitial:
                "NÃ¤r du startar %{name} visas SÃ¶k efter nytt recept (innehÃ¥ller information om senast brutna recept och favoritrecept).",
            searchPanelFormulaItems: "Minst ett av formelobjekten mÃ¥ste markeras.",
            searchPanelProductItems: "Endast en av produktartiklarna kan vÃ¤ljas.",
            searchPanelQuickSelect:
                "No need to press the load formula button. You will be redirected directly to main formula tab just after formula selection.",
            setCompetitiveColorSearch:
                "NÃ¤r det hÃ¤r alternativet Ã¤r aktiverat Ã¤r funktionen konkurrerande kulÃ¶rsÃ¶kning pÃ¥ fÃ¤rgpanelen tillgÃ¤nglig.",
            setFormulaInfoInPreview: "PÃ¥ receptpanelen visas alltid den valda datatypen kulÃ¶rfÃ¶rhandsgranskningen.",
            setFormulaPreview:
                "Den hÃ¤r instÃ¤llningen Ã¤ndrar placering och visning av kulÃ¶rfÃ¶rhandsgranskning, paketbild och data om kulÃ¶ren.",
            setFormulaRGBPreviewVisibleInformation:
                "PÃ¥ receptpanelen visas alltid den valda datatypen i kulÃ¶rfÃ¶rhandsgranskningen.",
            setFormulaUnit:
                "PÃ¥ receptpanelen avgÃ¶r den hÃ¤r instÃ¤llningen brytpastaenhet som ska Ã¶ppnas nÃ¤r en kulÃ¶r har valts. GÃ¤ller Ã¤ven i snabbrytning.",
            setFormulaVisibilityAndOrder:
                "PÃ¥ receptpanelen visas valda data i avsnittet Mer info (gÃ¤ller endast om Ange fÃ¶rhandsgranskning av recept i ReceptinstÃ¤llning har stÃ¤llts in pÃ¥ Bild eller Mer info.)",
            setMaxToleranceForCompetitiveColors:
                "StÃ¤ll in den maximala Delta E-toleransen (CIE 2000) fÃ¶r konkurrerande kulÃ¶rsÃ¶kning.",
            setNumberOfCompetitiveColors:
                "Define how many competitive master colors should be offered after search. The defined number does not correspond to the number of results.",
            setVisibleUnit:
                "PÃ¥ receptpanelen avgÃ¶r den hÃ¤r instÃ¤llningen vilka brytpastor som visas nÃ¤r du har valt en kulÃ¶r. GÃ¤ller Ã¤ven i snabbrytning.",
            showColorPreview:
                "PÃ¥ receptpanelen visas smÃ¥ kulÃ¶rfÃ¶rhandsgranskningar bredvid kulÃ¶rnamnet nÃ¤r du sÃ¶ker efter ett nytt recept.",
            showSiblingProducts:
                "Defines whether the option âShow sibling productsâ is displayed when saving custom formula",
            useColorCode: "On Formula panel, shows the information about color code."
        },
        formulaValidation: {
            batchNumberInvalid: "Canister (%{colorants}) is filled with a defective batch of colorant.",
            batchNumberWarning: "Colorant (%{colorants}) with this batch number may be damaged.",
            bellowBaseLimit: "Summan av fÃ¤rgmÃ¤ngderna ligger under basgrÃ¤nsen.",
            checkColorantBaseRules: "The setting checks if used colorants and base can be used in this combination.",
            checkMinDosableAmount:
                "Den minimala brytbara mÃ¤ngden Ã¤r den minsta fÃ¤rgmÃ¤ngden som kan dispenseras enligt rekommendation av laboratoriet.",
            checkOverfill:
                "InstÃ¤llningen kontrollerar om det finns tillrÃ¤ckligt med utrymme i burken fÃ¶r brytfÃ¤rg omedelbart efter att mÃ¤ngderna har stÃ¤llts in.",
            checkTotalCntAmounts:
                "The setting checks if the limits for the minimal and maximal colorant amounts in product base package have been exceeted. These limits are defined in the database.",
            colorantBaseRules: "Colorant is not valid for selected base.",
            colorantMinAmount: "FÃ¤rgmÃ¤ngden Ã¤r lÃ¤gre Ã¤n den minimala brytfÃ¤rgsmÃ¤ngd",
            dispensingWithErrorsEnabled:
                "Om det Ã¤r tillÃ¥tet visas ett varningsmeddelande i hÃ¤ndelse av valideringsÃ¶vertrÃ¤delser, men det kommer att vara mÃ¶jligt att fortsÃ¤tta att bryta Ã¤ndÃ¥.",
            invalidBatchNumber: "Colorant has invalid or defective batch number",
            overBaseLimit: "Summan av fÃ¤rgmÃ¤ngderna Ã¤r Ã¶ver maximal brytfÃ¤rgsmÃ¤ngd",
            overfill: "Ãverfyllning har upptÃ¤ckts.",
            unifyColorantBatchForMultipleCans:
                "If allowed, an info refill to max modal will appear when amount of colorant is bigger than maximum of canister and canister is not filled on maximum level.",
            warningConfirmBtn: "Jag kÃ¤nner till riskerna, fortsÃ¤tt"
        },
        help: "HjÃ¤lp",
        helpLink: "HjÃ¤lpcenter",
        helper: {
            automaticallyCheckForUpdates:
                "Det gÃ¶rs en automatisk sÃ¶kning efter tillgÃ¤ngliga uppdateringar fÃ¶r %{name} eller databasen inom angivet tidsintervall.",
            automaticallyDownloadUpdates:
                "Om en uppdatering finns tillgÃ¤nglig hÃ¤mtas den automatiskt utan att nÃ¥gon bekrÃ¤ftelse krÃ¤vs.",
            automaticallyInstallNewDatabases:
                "Om en DB skickas som hittills har saknats, installeras den som en ny DB. DÃ¤refter kan den nya DB:n anvÃ¤ndas.",
            automaticallyInstallUpdates:
                "Om en uppdatering hÃ¤mtas installeras den automatiskt utan att nÃ¥gon bekrÃ¤ftelse krÃ¤vs.",
            canBrowseChangeLog: "Vid uppdatering av programvaran visas det i den officiella Ã¤ndringsloggen %{name}",
            forceInstall: "The update will be installed by force.",
            installDuringNight: "Uppdateringen installeras under natten om datorn kÃ¶rs."
        },
        licensing: {
            collect:
                "Loggfilerna hÃ¤mtas till den valda platsen. ProgramvaruleverantÃ¶ren behÃ¶ver loggfilerna fÃ¶r att tillhandahÃ¥lla felanalys.",
            company: "Det fÃ¶retag som levererade licensen.",
            computerID: "Licensidentifiering fÃ¶r att hjÃ¤lpa programvaruleverantÃ¶ren om assistans har begÃ¤rts.",
            email: "Licensinnehavarens e-postadress.",
            licenseUuid: "Licensidentifiering fÃ¶r att hjÃ¤lpa programvaruleverantÃ¶ren om assistans har begÃ¤rts.",
            name: "Namnet pÃ¥ licensinnehavaren.",
            openBugreport:
                "Meddela oss om det finns ett fel i programvaran och skicka en rapport med felbeskrivningen.",
            posInfoContactperson: "FÃ¶rsÃ¤ljningsstÃ¤llets information om Ã¤garen som ska skrivas ut pÃ¥ etiketten.",
            posInfoMachineInformation:
                "FÃ¶rsÃ¤ljningsstÃ¤llets information om brytmaskinen som ska skrivas ut pÃ¥ etiketten eller identifieras i nÃ¤tverket.",
            posInfoPos: "FÃ¶rsÃ¤ljningsstÃ¤llets information om platsen som ska skrivas ut pÃ¥ etiketten.",
            reactivation: "Ãteraktivering eller modifiering av den aktuella licensen.",
            refresh: "Downloads the newest license information.",
            refreshUnavailable: "License refresh unavailable because you are offline.",
            registrationContactperson: "Registreringsinformation fÃ¶r att identifiera Ã¤garen till licensen.",
            registrationMachineInformation: "Registreringsinformation fÃ¶r att identifiera brytmaskinen fÃ¶r licensen.",
            registrationPos: "Registreringsinformation fÃ¶r att identifiera platsen fÃ¶r licensen.",
            versionScope: "Programvarans giltighetsbegrÃ¤nsningar.",
            versionType: "Programvarans produkttyp."
        },
        machineIsBusy: "Fel kan inte nollstÃ¤llas eftersom maskinen Ã¤r upptagen.",
        machineSettings: {
            allowManualColorantAddition:
                "Om mÃ¤ngden brytpasta som begÃ¤rts Ã¶verskrider den maximala mÃ¤ngden fÃ¶r dosering gÃ¶r den hÃ¤r instÃ¤llningen det mÃ¶jligt att lÃ¤gga till den manuellt efter dosering.",
            autotasks:
                "Automatiska uppgifter Ã¤r automatiska underhÃ¥llshÃ¤ndelser pÃ¥ dator och maskin som kan stÃ¤llas in att utfÃ¶ras vid en viss tidpunkt eller med ett visst tidsintervall.",
            barcodeRefillValidation: "The setting turns on barcode validation on refill.",
            barcodeRefillValidationBaseAndColorant:
                "Barcode check is performed on canister and colorant package refilling.",
            barcodeRefillValidationColorant: "Barcode check is performed on colorant package refilling.",
            canisterBarcode:
                "Streckkoden tilldelas den behÃ¥llare som innehÃ¥ller brytpastan. Streckkoden behÃ¶vs fÃ¶r att sÃ¤kerstÃ¤lla korrekt pÃ¥fyllning av brytpasta.",
            checkCanBeforeDispense:
                "Maskinkonfigurationen jÃ¤mfÃ¶rs med databasen varje gÃ¥ng RCC startas om. Vid avvikelse skapas en avisering.",
            checkOverfill:
                "InstÃ¤llningen kontrollerar om det finns tillrÃ¤ckligt med utrymme i burken/hinken innan brytningen genomfÃ¶rs.",
            currentlySelectedMachine: "InnehÃ¥ller information om den maskin som fÃ¶r nÃ¤rvarande Ã¤r vald.",
            dispenseInvalidColorants:
                "Med den hÃ¤r instÃ¤llningen kan du dosera brytpastor som inte definierats i maskinkonfigurationen genom att begÃ¤ra manuellt tillsatt brytpasta.",
            dispenserConfigurationBackup:
                "HÃ¤mta och spara den aktuella maskinkonfigurationen fÃ¶r att underhÃ¥lla en sÃ¤kerhetskopia.",
            dispensingLogic:
                "Brytningslogiktyper kan sÃ¤kerstÃ¤lla olika beteenden fÃ¶r varje behÃ¥llare nÃ¤r mer brytpasta ska doseras Ã¤n vad som Ã¤r tillÃ¥tet eller Ã¶nskat. Ytterligare beteenden anges i BrytningsinstÃ¤llningar.",
            enableTmc: "Med det hÃ¤r alternativet kan du skicka data till TMC.",
            enableUserIdentification: "AnvÃ¤ndaren mÃ¥ste logga in innan brytning tillÃ¥ts.",
            machineUnit: "Maskinenhet definierar mÃ¥ttenheten fÃ¶r fÃ¤rgpastor i behÃ¥llarna.",
            minDispensedAmount:
                "Minsta doseringsmÃ¤ngd anger hur mycket brytpasta som mÃ¥ste ha doserats fÃ¶r att rensningen ska anses vara gjord (fÃ¶r att undvika ytterligare rensning).",
            minimalDispenseAmount:
                "Minsta doseringsmÃ¤ngd Ã¤r den minsta rekommenderade mÃ¤ngden brytpasta som kan doseras. Om grÃ¤nsen underskrids visas ett meddelande (dosering Ã¤r fortfarande mÃ¶jlig).",
            missingAutotaskCanisters: "Minst 1 behÃ¥llare mÃ¥ste vÃ¤ljas",
            missingAutotaskChannels: "Minst 1 kanal mÃ¥ste vÃ¤ljas",
            missingAutotaskChannelsValue: "Volym fÃ¶r alla valda kanaler mÃ¥ste anges",
            missingAutotaskCleanTime: "RengÃ¶ringstiden mÃ¥ste vara anges",
            missingAutotaskName: "Namn pÃ¥ automatiskt uppgift mÃ¥ste anges",
            missingAutotaskRecirculation: "Tid och hastighet fÃ¶r Ã¥tercirkulation mÃ¥ste anges",
            missingAutotaskStirring: "Tid och hastighet fÃ¶r omrÃ¶rning mÃ¥ste anges",
            missingAutotaskVolume: "Volym fÃ¶r rensning mÃ¥ste anges",
            placeCanSensor:
                "InstÃ¤llningen aktiverar sensor fÃ¶r placering av burk/hink â brytningen startar inte fÃ¶rrÃ¤n burken/hinken Ã¤r rÃ¤tt placerad.",
            placeCanSensorDelay:
                "Rekommenderad instÃ¤llning i samband med sensor. SÃ¤kerstÃ¤ller att brytningen endast startar efter den definierade tidsperioden dÃ¥ burken/hinken har placerats korrekt.",
            purgeVolume: "Rensningsvolym anger hur mycket fÃ¤rgpasta som rensas nÃ¤r smart rensning utfÃ¶rs.",
            rccUrl: "Redlike Control Center (RCC) ansvarar fÃ¶r kommunikationen med brytmaskinen.",
            refillThreshold:
                "If the amount of colorant in the canister with the given UFI or Batch number drops below this limit, such UFI or Batch number will be discarded.",
            refillThresholdBatch:
                "If the amount of colorant in the canister with the given Batch number drops below this limit, such Batch number will be discarded.",
            refillThresholdUfi:
                "If the amount of colorant in the canister with the given UFI drops below this limit, such UFI will be discarded.",
            removeCanSensor:
                "InstÃ¤llningen aktiverar sensorn fÃ¶r borttagning av burk/hink â brytningen anses inte vara slutfÃ¶rd fÃ¶rrÃ¤n burken/hinken tas bort.",
            removeCanSensorDelay:
                "Rekommenderad instÃ¤llning i samband med borttagningssensorn. SÃ¤kerstÃ¤ller att brytningen slutfÃ¶rs fÃ¶rst efter den definierade tidsperioden nÃ¤r burken/hinken tagits ut.",
            skipPlaceCanDialog:
                "NÃ¤r den hÃ¤r instÃ¤llningen Ã¤r aktiverad vÃ¤ntar inte brytmaskinen tills knappen OK trycks in nÃ¤r en burk/hink placeras, utan brytningsprocessen startar automatiskt.",
            skipRemoveCanDialog:
                "NÃ¤r den hÃ¤r instÃ¤llningen Ã¤r aktiverad vÃ¤ntar inte brytmaskinen tills knappen OK trycks in nÃ¤r en burk/hink tas bort, utan brytningsprocessen anses automatiskt vara slutfÃ¶rd.",
            smartPurgeType:
                "Typen av rensning kan antingen Ã¶vervÃ¤ga endast dosering eller dosering plus andra rensningshÃ¤ndelser nÃ¤r kontroll gÃ¶rs om smart rensning behÃ¶vs.",
            splitFormula:
                "Om mÃ¤ngden brytpasta som krÃ¤vs Ã¶verstiger den maximala doseringsmÃ¤ngden, kan instÃ¤llningen gÃ¶ra det mÃ¶jligt att dosera en mÃ¤ngd brytpasta, fylla pÃ¥ behÃ¥llaren och sedan dosera resten.",
            tintometricSystem:
                "Tintometric system (set of available colorants) defines what colorants and formulas will be available in the application and application settings.",
            validateBarcodeBaseCan:
                "Basens burk/hink mÃ¥ste valideras med streckkod innan brytning tillÃ¥ts. Den hÃ¤r instÃ¤llningen sÃ¤kerstÃ¤ller att rÃ¤tt bas anvÃ¤nds.",
            validateColorantsDuringInit:
                "Maskinkonfigurationen jÃ¤mfÃ¶rs med databasen varje gÃ¥ng RCC startas om. Vid avvikelse skapas en avisering."
        },
        matchingSettings: {
            matchingInformation: "On matching result panel, %{item} will be available.",
            matchingOptionsColorants: "On matching options panel, colorants panel will be available.",
            matchingOptionsColorfile: "On matching options panel, colorfile selectbox will be available.",
            matchingOptionsSortResults: "On matching options panel, sort results selectbox will be available.",
            matchingRowCount: "Defines how many results should be offered after matching."
        },
        navigation: {
            barcodeScan: "Ãppnar ett fÃ¶nster med mÃ¶jlighet att ange streckkoden manuellt.",
            canisterBarcodes:
                "Ãppnar ett fÃ¶nster med en Ã¶versikt Ã¶ver behÃ¥llarnas streckkoder och mÃ¶jlighet att ange behÃ¥llarstreckkod.",
            canisterLevel:
                "Ãppnar ett fÃ¶nster med en Ã¶versikt Ã¶ver behÃ¥llarnas nivÃ¥er och mÃ¶jlighet att ange behÃ¥llarnivÃ¥.",
            canisters: "Ãppnar en panel med en Ã¶versikt Ã¶ver behÃ¥llarnas nivÃ¥er och mÃ¶jlighet att ange behÃ¥llarnivÃ¥.",
            clean: "Open a window with the possibility to clean machine channels",
            colorPanel: "Ãppnar en panel med mÃ¶jlighet att sÃ¶ka efter ett nytt recept i en elektronisk fÃ¤rgkarta.",
            colorSearchTab: "Opens a panel with possibility to search all colors in all fandecks.",
            colorantRefillHistory: "Ãppnar ett fÃ¶nster med en Ã¶versikt Ã¶ver genomfÃ¶rda behÃ¥llarpÃ¥fyllningar.",
            customFormula: "Ãppnar en panel med mÃ¶jlighet att skapa ett nytt, anpassat recept",
            customers:
                "Ãppnar en panel med en Ã¶versikt Ã¶ver kunder och mÃ¶jligheten att lÃ¤gga till/redigera/ta bort dem.",
            dispensingHistory: "Ãppnar en panel med en Ã¶versikt Ã¶ver utfÃ¶rda brytningar.",
            favorites: "Ãppnar en panel med mÃ¶jlighet att vÃ¤lja ett favoritrecept.",
            help: "Ãppnar ett fÃ¶nster fÃ¶r kundtjÃ¤nstinformation om leverantÃ¶ren tillhandahÃ¥ller det.",
            hideItems: "Ãppnar ett fÃ¶nster med mÃ¶jlighet att markera produkter och fÃ¤rgkartor som Ã¤r dolda.",
            historyOfOrders: "GÃ¤ller endast %{name}: Ã¶ppnar en panel med en Ã¶versikt Ã¶ver order som brutits.",
            machineReset: "Startar Ã¥terstÃ¤llning av brytmaskinen.",
            matching: "Opens a panel with the possibility to match new color with a spectro.",
            myOrders: "Ãppnar en panel med en Ã¶versikt Ã¶ver skickade order.",
            purge: "Ãppnar ett fÃ¶nster med mÃ¶jlighet att stÃ¤lla in behÃ¥llarrensning.",
            quickTint: "Ãppnar ett fÃ¶nster med mÃ¶jlighet att utfÃ¶ra manuell brytning.",
            searchFormula: "Ãppnar en panel med mÃ¶jlighet att sÃ¶ka efter ett nytt recept.",
            spectro: "Ãppnar en panel med mÃ¶jlighet att mÃ¤ta med en spektrometer.",
            stir: "Ãppnar ett fÃ¶nster med mÃ¶jlighet att stÃ¤lla in omrÃ¶rning av behÃ¥llare.",
            ticketing: "Opens a ticketing system panel.",
            toDispense: "Ãppnar en panel med en Ã¶versikt Ã¶ver mottagna order."
        },
        noHelpForLicense: "Det finns ingen hjÃ¤lp tillgÃ¤nglig fÃ¶r din licens, be din leverantÃ¶r att lÃ¤gga till den.",
        posInfo: {
            sync: "Synkroniserar data med avsnittet Registrering"
        },
        poweredByDeso: "Drivs av %{name}",
        priceSettings: {
            VatPrice: "MomsvÃ¤rde fÃ¶r brytpasta i %",
            VatPriceProduct: "Produktmomsen Ã¤r densamma fÃ¶r alla brytpastor. Anges i %.",
            basePurchase: "InkÃ¶pspris fÃ¶r bas (inklusive endast bas).",
            basePurchasePriceProduct: "InkÃ¶pspriset fÃ¶r produkten i given bas. Anges i den valda valutan.",
            baseSell: "FÃ¶rsÃ¤ljningspriset fÃ¶r bas endast (inklusive bas och marginal/pÃ¥slag).",
            baseSellFull: "Sell full price for base.",
            cntName: "Anger till vilken brytpasta priset Ã¤r kopplat.",
            cntPurchase: "InkÃ¶pspris fÃ¶r brytpastor (inklusive endast brytpastor).",
            cntPurchaseByName: "InkÃ¶pspris fÃ¶r brytpastor, individuellt berÃ¤knat (inklusive endast brytpastor).",
            cntPurchasePricePerLiter: "Kostnad fÃ¶r brytpastan per liter (utan marginal eller pÃ¥slag).",
            cntSell: "FÃ¶rsÃ¤ljningspriset endast fÃ¶r brytpasta (inklusive brytpasta och marginal/pÃ¥slag).",
            cntSellByName:
                "FÃ¶rsÃ¤ljningspriset fÃ¶r alla brytpastor som anvÃ¤nds i produkten, individuellt berÃ¤knade (inklusive brytpasta och marginal/pÃ¥slag).",
            cntSellFull: "Sell full price for colorants.",
            cntSellFullByName: "Sell full price for colorants by name.",
            cntSellPricePerLiter:
                "FÃ¶rsÃ¤ljningspriset fÃ¶r fÃ¤rganten per liter (inkl. fÃ¤rgant exklusivt). Anges i den valda valutan.",
            cntVat: "Moms fÃ¶r brytpasta angiven i %.",
            colorants:
                "De allmÃ¤nna priserna fÃ¶r brytpasta Ã¤r desamma fÃ¶r alla brytpastor. Den hÃ¤r funktionen Ã¤r sÃ¤rskilt anvÃ¤ndbar fÃ¶r att ange moms.",
            colorantsPosCoeficient: "The generic colorant coeficient for POS.",
            colorantsSellPrice:
                "The generic colorant prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            currencyCodeNew: "Valutakod mÃ¥ste anges i det officiella trebokstavsformatet, till exempel EUR.",
            currencyNameNew: "Valutans namn, till exempel Euro.",
            currencyRateNew:
                "VÃ¤xelkursen mot huvudvalutan, till exempel 25,855 CZK fÃ¶r 1 EUR. Kursen mÃ¥ste redigeras kontinuerligt fÃ¶r att vara uppdaterad.",
            currencyRoundingNew:
                "Avrundning anger minsta mÃ¶jliga vÃ¤rde fÃ¶r valutan. Till exempel har EUR avrundningen 0,01 eftersom det minsta mÃ¶jliga vÃ¤rdet Ã¤r 1 cent.",
            currencySymbolNew: "Den officiella symbolen fÃ¶r valutan, till exempel â¬ fÃ¶r EUR.",
            defaultPrice: "Pris fÃ¶r brytpasta anges i den valda databasen (utan moms).",
            defaultPriceGroup: "Pris fÃ¶r brytpasta fÃ¶r prisgrupp anges i den valda databasen (utan moms).",
            defaultVatPrice: "Moms pÃ¥ brytpasta anges i den valda databasen.",
            discountHeader: "Rabatten dra av det faststÃ¤llda vÃ¤rdet frÃ¥n inkÃ¶pspriset pÃ¥ brytpastan. Anges i %.",
            discountHeaderProduct: "Rabatten drar av det faststÃ¤llda vÃ¤rdet frÃ¥n priset pÃ¥ brytpastan. Anges i %.",
            export: "Exportera en fil med de priser som Ã¤r angivna fÃ¶r nÃ¤rvarande. Den kan importeras igen sedan priserna har Ã¤ndrats.",
            import: "Importera en korrekt formaterad (exporterad) fil fÃ¶r att ange eller Ã¤ndra priser.",
            localPrices:
                "Local prices change suggested prices from the main database and are present solely locally on this particular computer.",
            margin: "VÃ¤lj vilken prisutrÃ¤kning som ska anvÃ¤ndas fÃ¶r faststÃ¤llande av slutgiltigt pris. Marginal och pÃ¥lÃ¤gg lÃ¤ggs till medan rabatten dras av frÃ¥n det givna fÃ¶rsÃ¤ljningspriset.",
            marginAll: "Priset fÃ¶r marginal/pÃ¥slag fÃ¶r flera paket (inklusive marginal/pÃ¥slag).",
            marginHeader: "Marginal lÃ¤gger pÃ¥ det faststÃ¤llda vÃ¤rdet till brytpastans inkÃ¶pspris. Anges i %.",
            marginHeaderProduct: "Marginal lÃ¤gger pÃ¥ det faststÃ¤llda vÃ¤rdet till produktens inkÃ¶pspris. Anges i %.",
            marginPerPkg: "Priset fÃ¶r marginal/pÃ¥slag fÃ¶r ett paket (inklusive marginal/pÃ¥slag).",
            markupHeader: "PÃ¥lÃ¤gg lÃ¤gger pÃ¥ det faststÃ¤llda vÃ¤rdet till brytpastans inkÃ¶pspris. Anges i %.",
            markupHeaderProduct: "PÃ¥lÃ¤gg lÃ¤gger pÃ¥ det faststÃ¤llda vÃ¤rdet till produktens inkÃ¶pspris. Anges i %.",
            packagePricing: "Ytterligare tillÃ¤ggsavgifter anges individuellt fÃ¶r varje paketstorlek.",
            packageSurcharge: "De allmÃ¤nna paketpriserna Ã¤r desamma fÃ¶r varje pakettillÃ¤gg.",
            priceDefinition: "InstÃ¤llningen definierar vilka pristyper som anvÃ¤nds vid berÃ¤kning av slutpriser.",
            priceGroupNumber:
                "InstÃ¤llningen definierar hur mÃ¥nga prisgrupper som ska anvÃ¤ndas. Intervallet fÃ¶r enskilda prisgrupper kan anges i StandardvÃ¤rden.",
            priceGroupPricePerLiter: "Priset fÃ¶r brytpasta som anvÃ¤nds vid berÃ¤kning av prisgruppspriset.",
            priceGroups:
                "Prisgrupper visar numret pÃ¥ den relevanta prisgruppen (grÃ¤nserna anges i databasen eller i de allmÃ¤nna priserna).",
            priceGroupsEnabled:
                "Med instÃ¤llningen kan du arbeta med prisgrupper. Definiera intervallet i StandardvÃ¤rden och individuella priser i FÃ¤rgsÃ¤ttning.",
            priceGroupsGeneric:
                "Prisgrupper Ã¤r prisklasser fÃ¶r den slutliga fÃ¤rgen baserat pÃ¥ priset fÃ¶r receptets brytpasta.",
            productBasePackageSellPrice: "SÃ¤lj pris fÃ¶r paketet fÃ¶r den angivna basen. Anges i vald valuta.",
            productBaseSellPrice:
                "SÃ¤ljpris fÃ¶r bas berÃ¤knat per liter (exklusivt inkl. bas). Anges i den valda valutan.",
            productBaseVat: "Momsen fÃ¶r den givna fÃ¶rpackningen anges i %.",
            productName: "FaststÃ¤ller till vilken bas av vilken produkt priset Ã¤r kopplat.",
            productPosCoeficient: "The generic product coeficient for POS.",
            productPricing: "InkÃ¶pspriset fÃ¶r alla paket anvÃ¤nds vid brytning av anpassade paket.",
            productSize: "FaststÃ¤ller till vilken fÃ¶rpackning den angivna basen och produktpriset Ã¤r kopplat.",
            productVat: "Moms fÃ¶r denna produktbas angiven i %.",
            products:
                "De allmÃ¤nna produktpriserna Ã¤r desamma fÃ¶r varje produkt. Den hÃ¤r funktionen Ã¤r sÃ¤rskilt anvÃ¤ndbar fÃ¶r att ange moms.",
            productsSellPrice:
                "The generic product prices will be the same for every colorant. Sell price is recommended to by modified by discount. Set in selected currency.",
            sellPriceAll:
                "FÃ¶rsÃ¤ljningspriset fÃ¶r flera paket (inklusive bas, brytpastor, tillÃ¤ggsavgift och marginal/pÃ¥slag).",
            sellPricePerKg:
                "Produktens fÃ¶rsÃ¤ljningspris per kilogram (inklusive bas, brytpastor, tillÃ¤ggsavgift och marginal/pÃ¥slag).",
            sellPricePerL:
                "Produktens fÃ¶rsÃ¤ljningspris per liter (inklusive bas, brytpastor, tillÃ¤ggsavgift och marginal/pÃ¥slag).",
            sellPricePerPkg:
                "FÃ¶rsÃ¤ljningspriset fÃ¶r ett paket (inklusive bas, brytpastor, tillÃ¤ggsavgift och marginal/pÃ¥slag).",
            setPriceTypesVisibilityAndOrder:
                "PÃ¥ receptpanelen visas de valda priserna i prisavsnittet. Den hÃ¶gsta positionen hÃ¤r definierar positionen lÃ¤ngst till vÃ¤nster i avsnittet.",
            surchargeAll: "Priset fÃ¶r en tillkommande avgift fÃ¶r flera paket (inklusive tillÃ¤ggsavgift).",
            surchargePerPkg: "Priset fÃ¶r en tillkommande avgift fÃ¶r ett paket (inklusive tillÃ¤ggsavgift).",
            tintPurchaseAll:
                "InkÃ¶pspriset fÃ¶r hela brytningsprocessen fÃ¶r flera paket (inklusive brytpasta och tillÃ¤gg).",
            tintPurchasePerPkg:
                "InkÃ¶pspriset fÃ¶r hela brytningsprocessen fÃ¶r ett paket (inklusive brytpasta och tillÃ¤gg).",
            tintSellFullAll: "Tint sell full price for all packages.",
            tintlSellFullAllPerPackage: "Tint sell full price per package.",
            totalPurchaseAll: "Produktens totala inkÃ¶pspris fÃ¶r flera paket (inklusive bas och brytpastor).",
            totalPurchasePerKg: "Produktens totala inkÃ¶pspris per kilogram (inklusive bas och brytpastor).",
            totalPurchasePerL: "Produktens totala inkÃ¶pspris per liter (inklusive bas och brytpastor).",
            totalPurchasePerPkg: "Produktens totala inkÃ¶pspris fÃ¶r ett paket (inklusive bas och brytpastor).",
            totalSellFullAll: "Total sell full price for all packages.",
            totalSellFullPerKg: "Total sell full price per kilogram.",
            totalSellFullPerLiter: "Total sell full price per liter.",
            totalSellFullPerPackage: "Total sell full price per package.",
            withAndWithoutVat: "PÃ¥ receptpanelen visas priset i bÃ¥da varianterna samtidigt, med och utan moms.",
            withVat: "PÃ¥ receptpanelen visas alla priser endast inklusive moms.",
            withoutVat: "PÃ¥ receptpanelen visas alla priser endast exklusive moms."
        },
        qualityControlSettings: {
            colorDifference: "Color difference model for quality control.",
            deltaA: "Defines tolerance limit for delta A in quality control.",
            deltaB: "Defines tolerance limit for delta B in quality control.",
            deltaE: "Defines tolerance limit for delta E in quality control.",
            deltaL: "Defines tolerance limit for delta L in quality control.",
            deltaMetamerism: "Defines tolerance limit for metamerism delta in quality control."
        },
        registration: {
            sync: "Synkroniserar data med avsnittet med POS-information"
        },
        searchingPleaseWait: "VÃ¤nta, den bÃ¤sta matchningen sÃ¶ks efter",
        setupSteps: {
            customData: "SpecialframstÃ¤llda data",
            machineType: "Maskintyp",
            userPreferences: "AnvÃ¤ndarinstÃ¤llningar "
        },
        spectroSettings: {
            ColorixNanoUseProfiledValues:
                "NÃ¤r du anvÃ¤nder profilvÃ¤rden omberÃ¤knas de uppmÃ¤tta resultaten fÃ¶r att ta bort filtereffekten. TillÃ¥t det hÃ¤r alternativet fÃ¶r universell spektrometermÃ¤tning.",
            XRiteModelRM400: "Inga drivrutiner krÃ¤vs.",
            datacolorDiagnosticTile: "DatakulÃ¶r anvÃ¤nder diagnostikplatta",
            datacolorSilent: "DatakulÃ¶r tyst",
            measureModes: "VÃ¤lj glansnivÃ¥er som stÃ¶ds.",
            model: "Modell",
            simulationPath: "SimuleringssÃ¶kvÃ¤g",
            spectroType: "Spektrometertyp",
            spectroTypeCom:
                "Officiell drivrutin fÃ¶r spektrometern mÃ¥ste installeras. Observera vilken COM-port som anvÃ¤nds. Windows samt Linux.",
            spectroTypeDataColorReader:
                "Datorn mÃ¥ste ha en Bluetooth-anslutning. Spektrometern mÃ¥ste parkopplas till datorn. Windows 10 med hÃ¶stuppdatering 2018 krÃ¤vs.",
            spectroTypeMinolta2XXXd:
                "Officiell drivrutin fÃ¶r spektrometern mÃ¥ste installeras. Observera vilken COM-port som anvÃ¤nds. Windows samt Linux.",
            spectroTypeNotSelected: "VÃ¤lj din spektrometermodell.",
            spectroTypeRM400: "Inga drivrutiner krÃ¤vs.",
            spectroTypeSimulation:
                "LaboratorievÃ¤rden som krÃ¤vs fÃ¶r att erhÃ¥lla simuleringsresultat. Windows samt Linux.",
            spectroTypeXRite: "Bara i Windows."
        },
        ufiCode: {
            baseUfiCodeValidation: "Base can UFI-kod mÃ¥ste valideras via streckkod innan dispensering Ã¤r tillÃ¥ten.",
            enableUfiCodes: "UFI-koder anvÃ¤nds i EU och ger information om hur farlig en produkt Ã¤r fÃ¶r miljÃ¶n.",
            invalidUfi: "Invalid UFI code",
            printUfiCode:
                "Om ett fÃ¤rgant i en formel Ã¶verskrider den angivna grÃ¤nsen skrivs dess UFI-kod ut pÃ¥ utskriftsetiketten.",
            printUfiCodePercentage:
                "Om ett fÃ¤rgant i en formel Ã¶verskrider den angivna grÃ¤nsen skrivs dess UFI-kod ut pÃ¥ utskriftsetiketten tillsammans med dess procentuella representation.",
            ufiCodesByPercentage:
                "UFI-koden som gÃ¤ller anvÃ¤nds fÃ¶r utskrift med tanke pÃ¥ dess faktiska mÃ¤ngd i behÃ¥llaren. Navigera till behÃ¥llarens instÃ¤llningar fÃ¶r att definiera trÃ¶skelvÃ¤rdet fÃ¶r varje behÃ¥llare.",
            ufiCodesFromDatabase: "UFI-koden frÃ¥n databasadministratÃ¶rens huvuddatabas anvÃ¤nds fÃ¶r utskrift.",
            ufiCodesFromLastFilling:
                "UFI-koden frÃ¥n den senaste pÃ¥fyllningen som anges av operatÃ¶ren anvÃ¤nds fÃ¶r utskrift oavsett pÃ¥fyllningsbelopp."
        },
        userManagement: {
            add: "Med den hÃ¤r instÃ¤llningen lÃ¤gger du till en ny anvÃ¤ndare som kan logga in i programvaran. AnvÃ¤ndaren kan tilldelas en streckkod och kan stÃ¤llas in att loggas in automatiskt nÃ¤r programvaran startas.",
            assignedGroups:
                "Detta definierar vilka anvÃ¤ndargrupper anvÃ¤ndaren tillhÃ¶r. Olika anvÃ¤ndargrupper har olika behÃ¶righeter.",
            availableGroups:
                "Detta definierar vilka anvÃ¤ndargrupper som Ã¤r tillgÃ¤ngliga fÃ¶r anvÃ¤ndaren. Olika anvÃ¤ndargrupper har olika behÃ¶righeter.",
            loggedUserDelete: "Det gÃ¥r inte att ta bort den anvÃ¤ndare som Ã¤r inloggad fÃ¶r tillfÃ¤llet."
        },
        visit: "Eller besÃ¶k",
        visitNoLicense: "FÃ¶r mer information, besÃ¶k"
    },
    helpSettings: {
        customHelpLink: "Anpassad lÃ¤nk till hjÃ¤lpcenter",
        helpSettings: "HjÃ¤lpalternativ",
        message: "Meddelande"
    },
    helper: {
        automaticallyCheckForUpdates: "SÃ¶k efter uppdateringar automatiskt",
        automaticallyDownloadUpdates: "HÃ¤mta uppdateringar automatiskt",
        automaticallyInstallNewDatabases: "Installera nya DB automatiskt",
        automaticallyInstallUpdates: "Installera uppdateringar automatiskt",
        bugReport: "Felrapport fÃ¶r programvara",
        canBrowseChangeLog: "Visa Ã¤ndringslogg fÃ¶r %{name} online",
        collect: "Samla in",
        collectLogFiles: "Samla in loggfiler",
        component: "Komponent",
        content: "InnehÃ¥ll",
        contentSize: "InnehÃ¥llsstorlek",
        download: "HÃ¤mta",
        downloadLogFiles: "HÃ¤mta loggfiler",
        downloadingData: "HÃ¤mtar data",
        everyHours: "Varje %{interval} timmar",
        forceInstall: "Force to update",
        installDuringNight: "PÃ¥ natten (23:00â05:00)",
        newVersion: "Ny version",
        notConnected: "HjÃ¤lp Ã¤r inte ansluten",
        openBugReport: "Ãppna felrapport",
        packageSize: "Paketstorlek",
        pleaseWait: "Det hÃ¤r kan ta lite tid.",
        send: "Skicka",
        sendBugReportToCustomerService: "Skicka felrapport",
        sendingReport: "Skickar",
        subject: "Ãmne"
    },
    helperDialog: {
        1: "Du kan sÃ¶ka efter programvaru- eller databasuppdateringar.",
        2: "Vill du fortsÃ¤tta att hÃ¤mta uppdateringspaketen?",
        3: "Vill du fortsÃ¤tta med installationen av hÃ¤mtade uppdateringspaket?",
        10: "SÃ¶ker efter programvaru- och databasuppdateringar. VÃ¤nta...",
        11: "Det finns en uppdatering fÃ¶r datorn. Vill du hÃ¤mta den?",
        12: "Det finns inga uppdateringar fÃ¶r datorn.",
        14: "Ett fel uppstod vid sÃ¶kningen efter uppdateringar. %{0}",
        15: "Synkroniserar zondatabaser. VÃ¤nta...",
        20: "HÃ¤mtar uppdateringspaket. VÃ¤nta...",
        21: "Uppdateringspaketet som hÃ¤mtades kontrolleras nu. VÃ¤nta...",
        22: "Det gick inte att hÃ¤mta uppdateringspaketet. Vill du fÃ¶rsÃ¶ka igen?",
        23: "Det gick inte att hÃ¤mta uppdateringspaketet (filen Ã¤r felaktigt formaterad). Vill du fÃ¶rsÃ¶ka igen?",
        24: "FortsÃ¤tt med uppdateringsinstallationen?",
        25: "Installationen av automatisk uppdatering startar om %{0}",
        26: "Det finns en uppdatering fÃ¶r datorn. Vill du hÃ¤mta den?",
        27: "FortsÃ¤tt med uppdateringsinstallationen?",
        40: "Stoppar program och tjÃ¤nster. VÃ¤nta...",
        41: "Kopierar nya filer. VÃ¤nta...",
        42: "Startar program och tjÃ¤nster. VÃ¤nta...",
        43: "SlutfÃ¶r uppdateringen av programvara. VÃ¤nta...",
        44: "Din programvara har uppdaterats.",
        45: "Vill du fÃ¶rsÃ¶ka installera igen? Kontrollera i sÃ¥ fall att programvarukomponenterna inte anvÃ¤nds fÃ¶r tillfÃ¤llet.",
        46: "Datorn mÃ¥ste startas om fÃ¶r att Ã¤ndringar ska verkstÃ¤llas. Omstart sker om %{0}",
        999: "Internt fel uppstod: %{0}",
        automaticInstallation: "Automatisk installation av uppdateringar",
        btnAbort: "Koppla bort",
        btnCancel: "Avbryt",
        btnCheckUpdate: "SÃ¶k efter uppdateringar",
        btnContinue: "FortsÃ¤tt",
        btnDownloadUpdate: "HÃ¤mta uppdatering",
        btnInstallUpdate: "Installera uppdatering",
        btnOk: "OK",
        btnRetry: "FÃ¶rsÃ¶k igen",
        btnSkip: "Hoppa Ã¶ver",
        checkingForUpdates: "SÃ¶ker efter uppdateringar",
        downloadingFailed: "HÃ¤mtningen misslyckades",
        downloadingPackage: "HÃ¤mtar uppdateringspaket. VÃ¤nta...",
        finishingUpdate: "SlutfÃ¶r uppdatering",
        installingUpdate: "Installerar uppdatering",
        internalError: "Internt fel",
        rebootRequired: "Omstart krÃ¤vs",
        startingComponents: "Startar programvarukomponenter",
        stoppingComponents: "Avslutar programvarukomponenter",
        synchronizingDatabases: "Synkroniserar databaser",
        updateAvailable: "Uppdatering finns tillgÃ¤nglig, vÃ¤lj vilka komponenter som ska uppdateras",
        updateDownloaded: "Uppdateringen har hÃ¤mtats",
        updateFailed: "Uppdateringsprocessen misslyckades",
        updateInstalled: "Uppdateringen har installerats",
        verificationFailed: "Kontrollen av uppdateringspaketet misslyckades",
        verifyingPackage: "Kontrollerar hÃ¤mtat paket",
        yourSoftwareIsUpToDate: "Din programvara Ã¤r uppdaterad",
        yourSoftwareVersion: "Programvarans version: %{0}"
    },
    importData: {
        abortImportingData: "Avbryt import",
        aborted: "Importen avbrÃ¶ts",
        backupLocalDB: "Backup local database",
        confirmRestore: "Vill du verkligen Ã¥terstÃ¤lla alla lokala instÃ¤llningar?",
        dataMissing: "Importen misslyckades eftersom kÃ¤llfilen inte innehÃ¶ll nÃ¥gra data.",
        deleteImportedData: "Ta bort importerade data",
        encodingFile: "Filkodning",
        exportLocalSettings: "Export Local Settings",
        exportStaticSql: "Export Static SQL",
        fileDamaged: "Importen misslyckades eftersom kÃ¤llfilen verkar vara skadad.",
        fileMissing: "Importen misslyckades eftersom kÃ¤llfilen inte finns.",
        format: "Format",
        formatPath: "FormatsÃ¶kvÃ¤g",
        headerMissing: "Importen misslyckades eftersom filhuvudet saknas.",
        import: "Importera",
        importAborted: "Importen avbrÃ¶ts",
        importAborting: "Importen avbryts",
        importFailed: "Importen misslyckades pÃ¥ grund av ett ovÃ¤ntat fel",
        importLocalSettings: "Import Local Settings",
        importPrices: "Importera priser",
        imported: "Importerat",
        importedWithErrors: "Importing has finished with errors. Error lines have been skipped.",
        importing: "Importerar",
        noFormatAvailable: "Inget format Ã¤r tillgÃ¤ngligt",
        processing: "Bearbetar",
        processingCustomFormulas: "Bearbetar anpassade recept",
        processingCustomers: "Bearbetar kunder",
        productsFile: "Produktfil",
        restoreLocalSettings: "Restore Local Settings",
        underProgress: "Import pÃ¥gÃ¥r",
        unknownFormat: "Importen misslyckades eftersom kÃ¤llfilen Ã¤r av okÃ¤nt format",
        userFormulasFile: "AnvÃ¤ndarreceptsfil"
    },
    infoType: {
        baseDensity: "Basens densitet",
        baseMass: "Basens massa",
        baseUfiCode: "UFI-baskod",
        baseVolume: "Basens volym",
        batchNumbersTable: "Batch numbers table",
        bfsGrade: "BFS-grad",
        colorLab: "KulÃ¶rlabb",
        colorRgb: "KulÃ¶r RGB",
        colorRgbHex: "KulÃ¶r RGB Hex",
        colorXyz: "KulÃ¶r xyz",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantMass: "Brytpastans massa",
        colorantUfiCodes: "UFI-koder fÃ¶r fÃ¤rgfÃ¤rg",
        colorantVolume: "Brytpastans volym",
        formulaDate: "Formeldatum",
        formulaDatetime: "Formula datetime",
        formulaMoreInfo: "Formel mer info",
        formulaMoreInfoInternal: "Formel mer info intern",
        formulaMoreInfoPrint: "Formel mer info skriv ut",
        hbw: "HBW (HBW)",
        isPackageGravimetric: "Ãr paketet gravimetriskt",
        maxColorantMass: "StÃ¶rsta tillÃ¥tna massa fÃ¶r brytpasta",
        maxColorantVolume: "StÃ¶rsta tillÃ¥tna volym fÃ¶r brytpasta",
        nominalMass: "Paketets nominella massa",
        nominalVolume: "Paketets nominella volym",
        overfillDetected: "Ãverfyllning upptÃ¤ckt",
        totalPaintDensity: "Total paint density",
        totalPaintMass: "Total fÃ¤rgmassa",
        totalPaintVolume: "Total fÃ¤rgvolym",
        ufiCodesTable: "UFI-koder tabell",
        verifiedFormula: "Verifierad formel",
        yValue: "Y-vÃ¤rde"
    },
    initialTab: {
        favoriteFormulas: "Favoritrecept",
        lastDispensedFormulas: "Senaste brutna recept",
        searchNewFormula: "SÃ¶k nytt recept"
    },
    invalidBatchNumbersModal: {
        header: "Check colorants Batch number",
        info: "At least one canister is filled with (possibly) defective batch of colorant. Please do not use this batch. Empty the canister using Quick tint.",
        unknownStatus: "Unknown Batch status"
    },
    keyWords: {
        action: "Ã¥tgÃ¤rd",
        add: "lÃ¤gg till",
        addition: "tillÃ¤gg",
        additional: "ytterligare",
        address: "adress",
        admin: "admin",
        advanced: "Avancerat",
        after: "efter",
        afterDispensing: "efter dosering",
        alfa: "Alfa",
        all: "alla",
        allow: "tillÃ¥t",
        alphabetically: "alfabetisk",
        amount: "mÃ¤ngd",
        api: "api",
        ask: "frÃ¥ga",
        autocap: "autocap",
        autotask: "automatisk uppgift",
        availablePrice: "tillgÃ¤ngligt pris",
        backup: "backup",
        banner: "banner",
        barcode: "streckkod",
        barcodes: "streckkoder",
        base: "bas",
        before: "tidigare",
        begin: "bÃ¶rja",
        bfs: "BFS",
        bottom: "grund",
        brand: "mÃ¤rke",
        brush: "borste",
        bug: "fel",
        button: "knapp",
        buy: "kÃ¶pa",
        cC3: "CC3",
        cM: "CM",
        calibration: "kalibrering",
        can: "hink",
        canHandling: "hinkhantering",
        canister: "behÃ¥llare",
        canisterFilling: "pÃ¥fyllning av behÃ¥llare",
        canisterLevels: "behÃ¥llarnivÃ¥",
        canisters: "behÃ¥llare",
        cap: "lÃ¥g",
        center: "Center",
        centre: "Centrum",
        change: "Ã¤ndring",
        changelog: "Ãndringslogg",
        channels: "kanaler",
        check: "kontrollera",
        chunk: "del",
        chunks: "delar",
        city: "ort",
        clean: "ren",
        cleaning: "rengÃ¶ring",
        clientIdentifier: "klient-ID",
        close: "tillsluten",
        closest: "tÃ¤thetstest",
        code: "kod",
        collect: "samla in",
        color: "fÃ¤rg",
        colorLink3: "ColorLink3",
        colorPanel: "FÃ¤rgpalett",
        colorReader: "ColorReader",
        colorant: "brytpasta",
        colorantConsumption: "fÃ¶rbrukning av brytpasta",
        colorantPrice: "pris fÃ¶r brytpasta",
        colorants: "brytpastor",
        colorix: "Colorix",
        colour: "fÃ¤rg",
        communication: "kommunikation",
        compare: "jÃ¤mfÃ¶r",
        competitive: "konkurrenskraftiga",
        computer: "dator",
        config: "konfigurera",
        configuration: "konfiguration",
        confirm: "bekrÃ¤fta",
        confirmation: "bekrÃ¤ftelse",
        connection: "anknytning",
        contactPerson: "kontaktperson",
        control: "Kontroll",
        copies: "kopiera",
        corob: "Corob",
        cost: "kostnader",
        country: "land",
        create: "skapa",
        currency: "valuta",
        current: "nuvarande",
        custom: "Specialtillverkad",
        customers: "kunder",
        daily: "daglig",
        dark: "Dark",
        data: "data",
        database: "databas",
        datacolor: "Datacolor",
        date: "datum",
        decimals: "decimaler",
        default: "standard",
        delay: "fÃ¶rsening",
        delete: "ta bort",
        deletion: "borttagning",
        deltaE: "delta e",
        device: "enhet",
        devices: "enheter",
        diagnosticTile: "diagnostiseringsfÃ¤lt",
        dialog: "dialog",
        direct: "direkt",
        disconnect: "avbryt",
        discount: "rabatt",
        dispense: "dosera",
        dispenser: "brytmaskin",
        dispensing: "dosering",
        down: "ned",
        download: "nedladdning",
        driver: "drivrutin",
        dromont: "Dromont",
        dspProxy: "DspProxy",
        edit: "redigera",
        editor: "editor",
        email: "E-post",
        error: "fel",
        evoDriver: "EvoDriver",
        evoService: "EvoService",
        excel: "Excel",
        expiration: "gÃ¥r ut",
        export: "exportera",
        eyeOne: "Eye-One",
        fF: "F&F",
        fandeck: "fÃ¤rgkarta",
        fastFluid: "Fast & Fluid",
        file: "fil",
        fill: "fyll",
        fillToMax: "fyll till max.",
        find: "hitta",
        first: "fÃ¶rsta",
        flex: "Flex",
        folder: "mapp",
        formula: "recept",
        formulas: "recept",
        from: "frÃ¥n",
        fts5: "FTS5",
        fullScreen: "helskÃ¤rm",
        fullText: "fullstÃ¤ndig text",
        fulltext: "fullstÃ¤ndig text",
        g: "g",
        genericPricing: "generisk prissÃ¤ttning",
        hLD: "HLD",
        hard: "hÃ¥rt",
        hbw: "hbw",
        help: "hjÃ¤lp",
        helpCenter: "hjÃ¤lpcentral",
        hero: "Hero",
        history: "historik",
        home: "hem",
        host: "host",
        humidifier: "luftfuktare",
        iDD: "IDD",
        identification: "identifiering",
        image: "bild",
        impGallon: "imp. gallon",
        impQuart: "imp. quart",
        import: "importera",
        individually: "Individuell",
        info: "info",
        information: "information",
        initial: "initial",
        initialization: "initialisering",
        initialize: "initiera",
        insert: "infoga",
        install: "Installera",
        intellyPurge: "smart rengÃ¶ring",
        invalid: "ogiltig",
        ipAddress: "IP-adress",
        italtinto: "Italtinto",
        items: "fÃ¶remÃ¥l",
        keyboard: "tangentbord",
        kg: "Kg",
        kiosk: "helskÃ¤rm",
        kioskMode: "helskÃ¤rmslÃ¤ge",
        l: "L",
        lLD: "LLD",
        lab: "Lab",
        label: "etikett",
        labels: "etikett",
        language: "sprÃ¥k",
        largo: "Largo",
        last: "senaste",
        lenteq: "Lenteq",
        levels: "nivÃ¥er",
        license: "licens",
        light: "ljus",
        limit: "grÃ¤ns",
        link: "lÃ¤nk",
        linux: "Linux",
        load: "lÃ¤sa in",
        lock: "lÃ¥s",
        logFiles: "loggfiler",
        logic: "logik",
        logo: "logo",
        lower: "lÃ¤gre",
        machine: "maskin",
        machineConfiguration: "konfiguration av maskin",
        machineManagement: "maskinhantering",
        machineName: "maskinnamn",
        main: "primÃ¤ra",
        maintenance: "underhÃ¥ll",
        manual: "manuell",
        manualAddition: "manuellt tillÃ¤gg",
        manualDispensing: "manuell dosering",
        manualScan: "manuell skanning",
        margins: "marginaler",
        markups: "pÃ¥lÃ¤gg",
        mass: "vikt",
        match: "matcha",
        measure: "mÃ¥tt",
        measurement: "mÃ¤tning",
        measurementUnits: "mÃ¥ttenheter",
        melody: "melodi",
        message: "meddelande",
        minimal: "minimal",
        minolta: "Minolta",
        minus: "minus",
        minutes: "minuter",
        misura: "Misura",
        ml: "ml",
        mode: "lÃ¤ge",
        model: "modell",
        modification: "Ã¤ndring",
        modify: "Ã¤ndra",
        monthly: "mÃ¥natliga",
        moreInfo: "mer information",
        movableTable: "rÃ¶rligt bord",
        move: "flytta",
        music: "musik",
        myOrders: "mina order",
        name: "namn",
        naming: "namngivning",
        nano: "Nano",
        navigation: "navigation",
        new: "nya",
        nextDriver: "NextDriver",
        night: "natt",
        nixPro: "Nix Pro",
        notes: "anteckningar",
        notification: "notifikation",
        number: "nummer",
        off: "off",
        open: "Ã¶ppna",
        order: "bestÃ¤ll",
        ordering: "bestÃ¤llning",
        overfill: "Ã¶verfyllning",
        overview: "Ã¶versikt",
        overwrite: "skriva Ã¶ver",
        own: "egna",
        pCPDriver: "PCPDriver",
        package: "fÃ¶rpackning",
        packagePrice: "fÃ¶rpackningspris",
        packages: "fÃ¶rpackningar",
        panels: "Paneler",
        parameter: "Parameter",
        path: "Sti",
        pc: "Pc",
        phone: "telefon",
        phoneNumber: "telefonnummer",
        picture: "bild",
        place: "placera",
        placement: "placering",
        plug: "plug",
        plugger: "plugger",
        plugging: "plugging",
        plugin: "plugin",
        plus: "plus",
        pointOfSale: "fÃ¶rsÃ¤ljningsplatsen",
        popUp: "pop-up",
        pos: "POS",
        present: "nuvarande",
        preview: "fÃ¶rhandsgranskning",
        price: "pris",
        priceExport: "prisexport",
        priceGroup: "prisgrupp",
        priceImport: "prisimport",
        prices: "priser",
        pricing: "prissÃ¤ttning",
        primaryCurrency: "primÃ¤r valuta",
        print: "skriv ut",
        printer: "skrivare",
        printing: "skriver ut",
        problem: "problem",
        product: "produkt",
        productPrice: "produktpris",
        profiledValues: "profilbestÃ¤mda vÃ¤rden",
        punch: "punch",
        puncher: "puncher",
        punching: "punching",
        purge: "rengÃ¶ra",
        purgeType: "rengÃ¶ringstyp",
        purgeVolume: "rengÃ¶ringsvolym",
        quality: "kvalitet",
        quick: "snabb",
        quickTint: "snabbrytning",
        rM: "RM",
        raise: "lyft",
        rcc: "RCC",
        reader: "Reader (Colorix Reader Pro)",
        reboot: "omstart",
        receive: "ta emot",
        recirculate: "Ã¥tervinn",
        recirculation: "Ã¥tervinning",
        redlike: "Redlike",
        refill: "fyll pÃ¥",
        registration: "registrering",
        regular: "regelbunden",
        removal: "borttagning",
        remove: "ta bort",
        report: "rapport",
        reset: "nollstÃ¤ll",
        resolution: "upplÃ¶sning",
        restart: "omstart",
        rgb: "RGB",
        rights: "rÃ¤ttigheter",
        rounding: "avrundning",
        rules: "regler",
        sanTint: "SanTint",
        save: "dÃ¶lj",
        scale: "skala",
        scan: "skanna",
        scope: "omfattning",
        screen: "skÃ¤rm",
        screensaver: "skÃ¤rmslÃ¤ckare",
        search: "sÃ¶k",
        secondaryCurrency: "sekundÃ¤r valuta",
        select: "vÃ¤lj",
        selectedFormula: "Selected formula",
        sell: "sÃ¤lja",
        sensor: "sensor",
        serialNumber: "serienummer",
        server: "server",
        servers: "servrar",
        service: "service",
        serviceAction: "serviceÃ¥tgÃ¤rd",
        serviceActions: "serviceÃ¥tgÃ¤rder",
        serviceSoftware: "serviceprogramvara",
        serviceWindow: "servicefÃ¶nster",
        settings: "instÃ¤llningar",
        shelf: "hylla",
        shortcuts: "genvÃ¤gar",
        shot: "shot",
        show: "visa",
        shutDown: "stÃ¤ng ned",
        shutdown: "stÃ¤ngning",
        silent: "lugn",
        simple: "enkel",
        simulation: "simulering",
        size: "storlek",
        skip: "hoppa Ã¶ver",
        smartPurge: "smart rengÃ¶ring",
        software: "programvara",
        softwareSupplier: "programvaruleverantÃ¶r",
        sort: "sortera",
        sound: "ljud",
        spectro: "spektro",
        spectrophotometer: "spektrofotometer",
        speed: "hastighet",
        split: "delar",
        start: "start",
        startup: "uppstart",
        statistics: "statistik",
        status: "status",
        stir: "rÃ¶r",
        stirring: "omrÃ¶rning",
        street: "gata",
        support: "support",
        surcharge: "tillÃ¤gg",
        tab: "flik",
        tabs: "flikar",
        task: "uppgift",
        template: "schablon",
        testing: "test",
        time: "tidpunkt",
        tintingManagementCenter: "hanteringscenter fÃ¶r brytning",
        to: "fÃ¶r",
        toDispense: "att dosera",
        tolerance: "tolerans",
        top: "topp",
        total: "samlade",
        translation: "Ã¶versÃ¤ttning",
        turnOff: "stÃ¤ng av",
        turntable: "Vridbord",
        type: "typ",
        uIDD: "UIDD",
        uSGallon: "Amerikansk gallon",
        uSQuart: "Amerikansk quart",
        unit: "enhet",
        up: "upp",
        update: "uppdatering",
        url: "Webbadress",
        user: "anvÃ¤ndare",
        userGroups: "anvÃ¤ndargrupper",
        v1: "v.Â 1",
        v2: "v.Â 2",
        v3: "v.Â 3",
        vAT: "moms",
        validate: "validera",
        validation: "validering",
        version: "version",
        virtual: "virtuella",
        volume: "volym",
        weekly: "veckovis",
        window: "fÃ¶nster",
        windows: "fÃ¶nster",
        with: "med",
        without: "utan",
        xRite: "X-Rite",
        xrite: "Xrite",
        yValue: "y-vÃ¤rde",
        zipCode: "postnummer",
        zoom: "zoom"
    },
    languages: {
        bg: "Bulgariska",
        cs: "Tjeckiska",
        da: "Danska",
        de: "Tyska",
        el: "Grekiska",
        en: "Engelska",
        es: "Spanska",
        fr: "Franska",
        hr: "Kroatiska",
        hu: "Ungerska",
        id: "Indonesiska",
        is: "Ãsland (storbritannien)",
        it: "Italienska",
        lt: "Litauiska",
        lv: "Lettiska",
        ms: "Malajiska",
        nl: "NederlÃ¤ndska",
        no: "Norge",
        pl: "Polska",
        pt: "Portugisiska",
        ro: "RumÃ¤nska",
        ru: "Ryska",
        sk: "Slovakiska",
        sr: "Serbiska",
        sv: "Sverige",
        zh: "Kinesiska"
    },
    license: {
        activateLicense: "Aktivera licens",
        activateNewLicense: "Aktivera ny licens",
        checkLicenseKey: "Kontrollera licensnyckel",
        companyId: "FÃ¶retags-ID",
        contactPerson: "Kontaktperson",
        copy: "Kopiera",
        country: "Land",
        emptyCity: "Ort Ã¤r obligatorisk information",
        emptyCountry: "Land Ã¤r obligatorisk information",
        emptyName: "Butiksnamn Ã¤r obligatorisk information",
        enterIdentificationKeys: "Ange identifieringsnycklar",
        expirationDate: "Sista giltighetsdatum %{dateTime}",
        fillRegistration: "Fyll i registreringsdata (rulla nedÃ¥t fÃ¶r att se mer)",
        insertLicense: "Infoga genererad nyckel fÃ¶r offlineaktivering",
        invalidEmail: "Angiven e-post Ã¤r ogiltig",
        invalidPhone: "Angivet telefonnummer Ã¤r ogiltigt",
        itemsMarkedasterisk: "(fÃ¤lt som Ã¤r markerade med en asterisk mÃ¥ste fyllas i)",
        lastUpdate: "Last change %{dateTime}",
        leasedLicense: "Leasad licens",
        licenseActivated: "Licensen Ã¤r redan aktiverad",
        licenseStatus: "Licensstatus",
        licenseWillExpire: "Din licens upphÃ¶r att gÃ¤lla om %{dayCount} dagar",
        licenseWillExpireOneDay: "Din licens upphÃ¶r att gÃ¤lla om %{dayCount} dagar",
        machineInformation: "Maskininformation",
        noLicenseAvailable: "Ingen licens Ã¤r tillgÃ¤nglig",
        noProductsForKey: "Inga produkter finns tillgÃ¤ngliga fÃ¶r de angivna identifieringsnycklarna.",
        pointOfSale: "FÃ¶rsÃ¤ljningsstÃ¤lle (POS)",
        producer: "Producent",
        reactivate: "Ãteraktivera",
        reactivateLicense: "Reactivate license",
        region: "Region",
        registerLicense: "Kopiera aktiveringsbegÃ¤ran och gÃ¥ till:",
        registrationForm: "Registrering",
        selectProduct: "VÃ¤lj produkt",
        serialNumber: "Serienummer",
        skipNewLicense: "Om du vill aktivera en ny licens senare kan du klicka pÃ¥ Hoppa Ã¶ver",
        unlimitedLicense: "ObegrÃ¤nsad licens",
        userId: "AnvÃ¤ndar-ID",
        uuid: "Licens-UUID",
        versionDetails: "Versionsinformation",
        versionScope: "Versionens omfattning",
        versionType: "Versionstyp",
        zip: "Postnummer"
    },
    login: {
        authenticate: "Styrka",
        logIn: "Logga in",
        loginAs: "Logga in som en annan anvÃ¤ndare",
        messages: {
            incorrectUsername: "AnvÃ¤ndarnamn eller lÃ¶senord Ã¤r felaktigt "
        },
        password: "LÃ¶senord",
        username: "AnvÃ¤ndarnamn"
    },
    machineActionHistory: {
        actionHistory: "ÃtgÃ¤rdshistorik"
    },
    machineErrors: {
        channel: "Kanaler",
        code: "Kod",
        machineErrors: "Maskinfel",
        noMachineErrors: "Det finns fÃ¶r nÃ¤rvarande inget maskinfel",
        resetErrors: "NollstÃ¤llningsfel"
    },
    machineSettings: {
        action: "ÃtgÃ¤rd",
        addAutotask: "LÃ¤gg till automatisk uppgift",
        autoCanisterIn: "BehÃ¥llare in automatiskt",
        autoCanisterOut: "BehÃ¥llare ut automatiskt",
        automaticRefill: "Automatisk pÃ¥fyllning",
        autotaskSettings: "InstÃ¤llningar fÃ¶r automatiska uppgifter",
        backupConfiguration: "SÃ¤kerhetskopia av brytmaskinens konfiguration",
        brushMaintenance: "BorstunderhÃ¥ll",
        capMaintenance: "LockunderhÃ¥ll",
        checkCanisterBeforeDispense: "Kontrollera behÃ¥llare fÃ¶r brytning",
        checkColorantBaseRules: "Check colorant base rules",
        checkMinDosableAmount: "Kontrollera den minimala brytfÃ¤rgsmÃ¤ngden",
        checkOverfill: "Check kan fyllas Ã¶ver",
        checkTotalCntAmounts: "Kontrollerar den total brytfÃ¤rgsmÃ¤ngden fÃ¶r basen",
        cleanAll: "RengÃ¶r alla",
        computerReboot: "Omstart av datorn",
        computerShutdown: "AvstÃ¤ngning av datorn",
        connectMachine: "Anslut maskin",
        days: "Dagar",
        daysOfMonth: "Dagar i mÃ¥naden",
        devices: "Enheter",
        disabled: "Inaktiverad",
        dispenseAndPurge: "Bryt och rensa",
        dispenseOnly: "Bryt endast",
        dispenserCleaning: "RengÃ¶ring av brytmaskin",
        dispensingWithErrorsEnabled: "TillÃ¥t dispensering trots valideringsfelen",
        editAutotask: "Redigera automatisk uppgift",
        firstRun: "First run",
        hours: "Timmar",
        humidifier: "Luftfuktare",
        humidifierWaterLevelMaintenance: "UnderhÃ¥ll av luftfuktarens vattennivÃ¥",
        machineConfigurationNoCanisters: "Maskinkonfigurationen innehÃ¥ller ingen behÃ¥llare.",
        machineName: "Maskinnamn",
        machineSettings: "MaskininstÃ¤llningar",
        manualPuncher: "Manuell stansning",
        minDispensedAmount: "Minsta doseringsmÃ¤ngd",
        minutes: "Minuter",
        nextRun: "NÃ¤sta kÃ¶rning",
        noAutotasksSet: "Inga automatiska uppgifter har angetts",
        noDataAvailable: "Inga data tillgÃ¤ngliga",
        noMachine: "Ingen maskin Ã¤r ansluten",
        onStart: "Vid start",
        plugger: "Plugg",
        postpone: "FÃ¶rdrÃ¶jning",
        puncher: "Stansare",
        purgeAll: "Rensa alla",
        purgeOnly: "Endast rensning",
        recirculateAll: "Ãtercirkulera alla",
        recirculateChannels: "Ãtercirkulera kanaler",
        recirculationSpeed: "Hastighet fÃ¶r Ã¥tercirkulation",
        recirculationTime: "Ãtercirkulationstid",
        refillAll: "Fyll pÃ¥ alla",
        refillCanisters: "Fyll pÃ¥ behÃ¥llarna",
        runAt: "Dagligen kl.",
        runDefinedDaysAt: "Angivna dagar kl.",
        runEvery: "KÃ¶r varje",
        runInDays: "KÃ¶r i dagar",
        serialNum: "Serienummer",
        settingsMachine: "InstÃ¤llningsmaskin",
        smartPurgeAll: "Smart rensning av alla",
        smartPurgeChannels: "Smart rensning av kanaler",
        smartPurgeRules: "Regler fÃ¶r smart rensning",
        startType: "Starttyp",
        stirAll: "RÃ¶r om alla",
        stirCanisters: "RÃ¶r om behÃ¥llare",
        stirringSpeed: "OmrÃ¶rningshastighet",
        stirringTime: "OmrÃ¶rningstid",
        switchPlateMaintenance: "UnderhÃ¥ll av kontaktplattan",
        theCurrentlySelectedMachine: "Aktuell vald maskin",
        threshold: "TrÃ¶skelvÃ¤rde",
        turntable: "Vridbord",
        unifyColorantBatchForMultipleCans: "Unify colorant batch for multiple cans dispensings",
        volume: "MÃ¤ngd",
        weekdays: "Vardagar"
    },
    mainTab: {
        acceptedFormula: "Accepterad formel",
        addBuildingSite: "Add building site",
        addToFavorites: "LÃ¤gg till i favoriter",
        alternativeFormulas: "Alternative formulas",
        alternativeValidFormulas: "Alternative valid formulas",
        buildingSiteSpecification: "Building site specification",
        colorantsAreInvalid: "En eller flera brytpastor Ã¤r ogiltiga",
        dispensedPackages: "Brutna paket",
        dispensingInProgress: "Brytning pÃ¥gÃ¥r",
        dispensingIsAborted: "Brytning avbryts",
        dispensingIsNotAvailable: "Brytning Ã¤r inte tillgÃ¤ngligt",
        dispensingProgress: "%{done} av %{all}",
        editColorant: "Redigera brytpasta",
        editNote: "Redigera anteckning",
        findCompetitiveColor: "Try to find the competitive color",
        forceDispensing: "Tvinga brytning",
        formulaInvalidColorants: "Receptet innehÃ¥ller ogiltiga brytpastor: %{colorants}",
        formulaOutOfDate: "Formula may be out of date",
        formulaProperties: "Formula properties",
        hiddenFandecks: "Dolda fÃ¤rgkartor",
        hiddenProducts: "Dolda produkter",
        historicalFormulas: "Historiska recept",
        lowerDeltaNumber: "LÃ¤gre delta nummer mer exakt matchning",
        machineError: "Maskinfel",
        machineIsBusy: "Maskinen Ã¤r upptagen",
        machineNotConnected: "Maskinen Ã¤r inte ansluten",
        manualColorantAddition: "Manuell tillsats av brytpasta",
        modifiedFormula: "Receptet har Ã¤ndrats",
        modifiedFormulaInLab: "Formula modified in laboratory",
        newColorAfterScaling: "Ny fÃ¤rg efter skalning",
        newRgbNotAccuratelyMeasured: "Nya RGB mÃ¤ts inte exakt, det Ã¤r bara vÃ¤gledande",
        noBaseAvailable: "Ingen bas tillgÃ¤nglig",
        noBuildingSiteAvailable: "No building site info is available",
        noColorantForCorrection: "No additional colorants for correction selected",
        noColorants: "Ingen brytpasta",
        noCustomer: "Inga kunder",
        noCustomers: "Inga kunder tillgÃ¤ngliga",
        noDispenseNotesAvailable: "Inga anteckningar fÃ¶r brytning Ã¤r tillgÃ¤ngliga",
        noFormulaAvailable: "You have selected a combination with no formula!",
        noFormulaSelected: "Inget recept har valt",
        noInternalNotesAvailable: "Inga interna anteckningar Ã¤r tillgÃ¤ngliga",
        noNotesAvailable: "Inga anteckningar Ã¤r tillgÃ¤ngliga",
        noPackageAvailable: "No package is available",
        noPackageSelected: "Inget paket har valts",
        noProductAvailable: "No product is available",
        noResultsFound: "Inga resultat hittades",
        openLocalFile: "Ãppna frÃ¥n lokal databas",
        openOnlineFile: "Ãppet frÃ¥n Internet",
        order: "Ordning",
        orderingIsNotAvailable: "Ordern Ã¤r inte tillgÃ¤nglig",
        originalColor: "Ursprunglig fÃ¤rg",
        overAvailableLevel: "Ãver den tillgÃ¤ngliga nivÃ¥n",
        package: "Paket",
        packageIsRequired: "FÃ¶rpackning krÃ¤vs",
        packaging: "Emballage",
        partialUpdateReload: "Partial updates may have affected this formula. Reload this tab to see an updated data.",
        printIsNotAvailable: "Utskrift Ã¤r inte tillgÃ¤ngligt",
        productFiles: "Produktfiler",
        productFilesViewer: "Visningsvisare fÃ¶r produktfiler",
        productNotAvailable: "Product '%{productName}' is not available.",
        properties: "Properties",
        regularPrice: "AllmÃ¤nt pris",
        resetFormulaData: "Nytt recept",
        rgbOnlyIndicative: "RGB endast vÃ¤gledande!",
        saveAsCustom: "Spara som",
        saveToStatsIsNotAvailable: "Det gÃ¥r inte att spara i historiken",
        searchForCheaper: "SÃ¶k efter billigare",
        selectFromCompetitive: "You can select color from the competitive colors.",
        specialPrice: "Specialpris",
        specialPriceVip: "Specialpris VIP",
        splitFormula: "Dela upp recept",
        withVAT: "med moms",
        withoutVAT: "utan moms"
    },
    marginSettings: {
        allBases: "Alla baser",
        allProducts: "Alla produkter",
        editMargin: "Redigera marginal",
        marginAndDiscountWarning: "Du mÃ¥ste ange prisberÃ¤kningsalternativ fÃ¶r att anvÃ¤nda marginaler och rabatter.",
        marginSettings: "MarginalinstÃ¤llningar",
        marginsFor: "Marginaler fÃ¶r",
        markupColorants: "PÃ¥slag pÃ¥ brytpasta",
        sizeOfPackage: "Paketstorlek",
        valueBase: "BasvÃ¤rde",
        valueColorant: "VÃ¤rde fÃ¶r brytpasta"
    },
    matching: {
        actualColor: "Actual color",
        allCorrections: "All corrections",
        allTillItems: "All till the items",
        auto: "Auto",
        autoSelectAll: "Auto all",
        canStartCorrection: "Then you can start correction.",
        canStartMatching: "Then you can start matching.",
        cannotBeUsed: "Matching cannot be used.",
        changeProductAndColorants: "Try change product or colorants",
        checkConfig: "Please check the matching configuration.",
        colorCorrection: "Color correction",
        colorIsIndicative: "Color preview is only indicative.",
        colorNotAccurate: "Color may not be accurately displayed, it always depends on your monitor settings.",
        colorantInDispensedFormula: "Colorants in dispensed formula",
        confirmDispensing: "Confirm dispensing",
        connectionProblem: "Connection problem",
        correctionHistory: "Correction history",
        correctionRunning: "Correction is running",
        draftFormula: "Draft formula",
        exclude: "Exclude",
        excludeAll: "Exclude all",
        include: "Include",
        includeAll: "Include all",
        invalidProduct: "It is not possible to do the matching for product %{productName}",
        itemOnly: "Item only",
        manualColorCorrection: "Manual color correction",
        matchFormula: "Match formula",
        matchingInformation: "Matching information",
        matchingResult: "Matching result",
        matchingRunning: "Matching is running",
        matchingSearchOptions: "Matching search options",
        measurement: "Measurement",
        noCorrection: "No correction found",
        noSpectralCurveProvided:
            "The connected device cannot be used for matching because it doesn't provide spectral curve",
        notAvailableForMatching: "Not available for matching",
        originalFormula: "Original formula",
        reformulate: "Reformulate",
        reformulationRunning: "Reformulation is running",
        resultColor: "Result color",
        saveAsCustomFormula: "Save as custom formula",
        searchInProgress: "Search in progress, please wait",
        selectColorfile: "Please select colorfile.",
        selectRequiredItems: "Please select product, base, colorants and package.",
        selectedResult: "Selected result",
        spectralDataNotAvailable: "Spectral data is not available",
        startCorrection: "Start correction",
        startMatching: "Start matching",
        targetColor: "Target color",
        unsavedDraft: "Unsaved draft",
        unsavedDraftWarning: "Once you are satisfied with formula â do not forget to save your result.",
        usedForMatching: "Used for matching"
    },
    modal: {
        changeColorantUnit: "Byt enhet fÃ¶r brytpasta",
        payAttention: "Observera!"
    },
    module: {
        productGroups: "Product groups"
    },
    navigation: {
        globalSearch: {
            fandeckFilter: "FÃ¤rgkartefilter",
            formulasOverLimit: "UngefÃ¤r %{count} resultat. Prova att skriva fler tecken.",
            foundFormulas: "%{count} recept hittades",
            help: "HjÃ¤lp:",
            helpText:
                "Skriv till exempel â%{filter}â om du vill sÃ¶ka efter recept som bÃ¶rjar med â%{formula}â, produkter som bÃ¶rjar med â%{product}â och fÃ¤rgkartor â%{fandeck}â.",
            productFilter: "Produktfilter",
            searchInFormulas: "SÃ¶k i recept",
            typeMore: "Skriv fler tecken."
        },
        menu: {
            actionHistory: "ÃtgÃ¤rdshistorik",
            additionalFormulaTab: "Extra receptflik",
            advancedSettings: "Avancerade instÃ¤llningar",
            autotaskSettings: "Automatiska Ã¥tgÃ¤rder",
            availableDatabases: "TillgÃ¤ngliga databaser",
            availablePrices: "TillgÃ¤ngliga priser",
            bugReport: "Felrapport",
            canisterBarcodes: "BehÃ¥llarstreckkoder",
            canisterDispensingLogic: "Brytningslogik",
            canisterFilling: "BehÃ¥llarpÃ¥fyllning",
            canisterSettings: "InstÃ¤llningar fÃ¶r behÃ¥llare",
            clientServerSettings: "Klientâserver-anslutning",
            closing: "StÃ¤nger",
            color: "KulÃ¶r",
            colorModification: "KulÃ¶rfÃ¶rÃ¤ndring",
            colorPanel: "InstÃ¤llningar fÃ¶r kulÃ¶rpanelen",
            colorRepresentation: "KulÃ¶rrepresentation och data",
            colorSearch: "KulÃ¶rsÃ¶kning",
            colorant: "Brytpasta",
            colorantConsumption: "FÃ¶rbrukning av brytpasta",
            colorantPricing: "Priser fÃ¶r brytpasta",
            colorantRefillHistory: "Historik Ã¶ver pÃ¥fyllning av brytpasta",
            competitiveSearch: "Konkurrerande kulÃ¶rsÃ¶kning",
            connections: "Anslutningar",
            currency: "ValutainstÃ¤llningar",
            customData: "SpecialframstÃ¤llda data",
            database: "Databaser",
            databaseCheck: "Databaskontroll",
            databaseConnection: "Databasanslutning",
            defaultValues: "StandardvÃ¤rden",
            devices: "Enheter",
            dispensingHistory: "Brytningshistorik",
            dispensingSettings: "BrytningsinstÃ¤llningar",
            driverSettings: "InstÃ¤llningar fÃ¶r drivrutin",
            environment: "MiljÃ¶",
            environmentConfiguration: "MiljÃ¶instÃ¤llningar",
            environmentalSettings: "MiljÃ¶instÃ¤llningar",
            favorites: "Favoriter",
            fileTransfer: "DESO File Transfer",
            formatting: "Formatering",
            formula: "Formula",
            formulaData: "Data",
            formulaModification: "Formula modification",
            formulaPanels: "Receptpanel",
            formulaSettings: "ReceptinstÃ¤llningar",
            formulaUnit: "Receptenhet",
            generalSearch: "AllmÃ¤n sÃ¶kning",
            globalSettingsSearch: "SÃ¶ka efter globala instÃ¤llningar",
            helpItems: "HjÃ¤lpalternativ",
            importAndExport: "Import och export",
            importAndExportData: "Importera anpassade data",
            importCustomData: "Importera anpassade data",
            initialFormulaTab: "Inledande receptflik",
            interfaceSettings: "InstÃ¤llningar fÃ¶r grÃ¤nssnitt",
            keyboardShortcuts: "Kortkommandon",
            language: "SprÃ¥k",
            languageSettings: "SprÃ¥kinstÃ¤llningar",
            layout: "Layout",
            license: "Licens",
            licenseData: "Licensdata",
            licenseIdentification: "Licensidentifiering",
            licenseStatus: "Licensstatus",
            licenseSupplier: "LicensleverantÃ¶r",
            licenseVersion: "Licensversion",
            localData: "Lokala data",
            machine: "Maskininformation",
            machineActions: "MaskinÃ¥tgÃ¤rder",
            machineAndDevices: "Maskin och enheter",
            machineManagement: "Maskinhantering",
            machineSettings: "MaskininstÃ¤llningar",
            mainSettings: "HuvudinstÃ¤llningar",
            maintenance: "UnderhÃ¥ll",
            marginAndDiscount: "Marginal och rabatt",
            matchingSearchResult: "Matching search result",
            matchingSettings: "Matching Settings",
            navigationItems: "Navigeringsobjekt",
            newFormulaWindow: "Recept",
            orderSearch: "OrdersÃ¶kning",
            orderSettings: "InstÃ¤llningar fÃ¶r order",
            packageSurcharge: "FÃ¶rpackningstillÃ¤gg",
            popUps: "Popup",
            posInfo: "Information om fÃ¶rsÃ¤ljningsstÃ¤lle (POS)",
            price: "PrisinstÃ¤llningar",
            priceManagement: "Prisadministration",
            priceSettings: "PrisinstÃ¤llningar",
            pricingOptions: "PrisinstÃ¤llningar",
            printSettings: "UtskriftsinstÃ¤llningar",
            productPricing: "Produktpriser",
            qualityControlSettings: "Quality Control Settings",
            quickTint: "InstÃ¤llningar fÃ¶r snabbrytning",
            rccConfig: "RCC-instÃ¤llningar",
            rccConnection: "RCC-anslutning",
            rccSettings: "RCC-instÃ¤llningar",
            refillSettings: "Refill Settings",
            refillingLogic: "Fylla pÃ¥ logik",
            registration: "Registrering",
            searchSettings: "SÃ¶kinstÃ¤llningar",
            serverPlugins: "Plugin-program fÃ¶r server",
            serviceActions: "ServiceÃ¥tgÃ¤rder",
            settings: "InstÃ¤llningar",
            simplifiers: "FÃ¶renklingar",
            singleActions: "Enskilda Ã¥tgÃ¤rder",
            smartPurgeRules: "Regler fÃ¶r smart rensning",
            softwareOptions: "Alternativ fÃ¶r programvara",
            spectroSettings: "InstÃ¤llningar fÃ¶r spektrometer",
            statistics: "Statistik",
            switchToFrontdesk: "Byt till reception",
            switchToFullRedlike: "Byt till %{name}",
            switchToLight: "Byt till %{name}",
            switchToMachine: "Byt till maskin",
            tabs: "Flikar och popup-fÃ¶nster",
            testBarcodes: "Streckkodstestning",
            updateOptions: "Uppdateringsalternativ",
            userManagemenet: "AnvÃ¤ndarhantering",
            visibleUnits: "Synliga enheter"
        },
        navBar: {
            barcode: "Streckkod",
            help: "HjÃ¤lp",
            hideItems: "DÃ¶lj produkter / fÃ¤rgkartor"
        },
        notificationPanel: {
            noNotifications: "Inga nya aviseringar"
        },
        tabBar: {
            closeActive: "StÃ¤ng aktiv",
            closeAll: "StÃ¤ng alla",
            closeAllExceptActive: "StÃ¤ng alla utom aktiva",
            customFormula: "Custom Formula",
            dispensingHistory: "Brytningshistorik",
            favorites: "Favoriter",
            formulaSearch: "Formula search",
            rewriteSettings: "Re-write local settings"
        }
    },
    ordering: {
        assign: "Tilldela",
        assignment: "Arbetsuppgift",
        createdDate: "Skapat, datum",
        finishDispensing: "SlutfÃ¶r brytning",
        foundInOrders: "Hittat i order",
        inactiveDatabase: "Receptet kommer frÃ¥n en inaktiv eller okÃ¤nd databas, %{0}",
        inactiveUnknownDatabase: "Receptet kommer frÃ¥n en inaktiv eller okÃ¤nd databas",
        newOrderReceived: "Du har fÃ¥tt en ny order!",
        noOrderSelected: "Ingen order har valts",
        release: "SlÃ¤pp",
        status: {
            accepted: "accepterat",
            canceled: "annullerat",
            created: "skapat",
            done: "klart",
            partlyDone: "delvis klart",
            preparing: "fÃ¶rbereder",
            unknown: "okÃ¤nt"
        }
    },
    partialUpdates: {
        applying: "Applying partial updates",
        cantBeUsedForYourDbVersion: "Updates can't be used for this database. Please update via Helper.",
        newVersionWillBeInstalled: "It will install the new version including all available partial updates.",
        noPartialUpdatesAvailable: "No partial updates available",
        outOfDate: "out of date!",
        partialUpdates: "Partial updates",
        partialUpdatesArePreparing: "Partial updates are preparing",
        partialUpdatesAvailable: "Partial updates available!",
        preparedUpdatesMessage: "The following partial updates are prepared to be applied",
        remindMeLater: "Remind me later (after %{time} minutes)",
        swOutOfDate: "The current version of the software is",
        updateAutomatically: "If you do not response, update will start automatically in: %{time} s",
        updateToNewVersion: "Update to the newest version",
        updateWillTakeMoreTime: "The update will take more time.",
        updatesApplied: "Partial updates were successfully applied.",
        updating: "Updating"
    },
    posInfo: {
        address: "Adress",
        contactName: "Namn pÃ¥ kontakt",
        contactPerson: "Kontaktperson",
        identification: "Identifikation",
        machineInformation: "Maskininformation",
        pos: "FÃ¶rsÃ¤ljningsstÃ¤lle (POS)",
        secondAddress: "Annan adress",
        shopIdentification: "Butiksidentifikation",
        shopName: "Butikens namn",
        url: "URL",
        zipCode: "Postnummer"
    },
    priceTypeList: {
        priceBasePurchase: "Kostnad fÃ¶r bas",
        priceBaseSell: "FÃ¶rsÃ¤ljningspris fÃ¶r bas",
        priceBaseSellFull: "FÃ¶rsÃ¤ljningspris fÃ¶r bas",
        priceCntPurchase: "Kostnad fÃ¶r brytpasta",
        priceCntPurchaseByColorantName: "Kostnad fÃ¶r %{0} brytpasta",
        priceCntPurchaseByName: "Kostnad fÃ¶r brytpasta efter namn",
        priceCntSell: "FÃ¶rsÃ¤ljningspris fÃ¶r brytpasta",
        priceCntSellByColorantName: "FÃ¶rsÃ¤ljningspris fÃ¶r %{0} brytpasta",
        priceCntSellByName: "FÃ¶rsÃ¤ljningspris fÃ¶r brytpasta efter namn",
        priceCntSellFull: "FÃ¶rsÃ¤ljningspris fÃ¶r brytpastor",
        priceCntSellFullByColorantName: "FÃ¶rsÃ¤ljningspris fÃ¶r brytpasta %{0}",
        priceCntSellFullByName: "FÃ¶rsÃ¤ljningspris fÃ¶r brytpastor efter namn",
        priceGroupBarcode: "Streckkod fÃ¶r prisgrupp",
        priceMarginAll: "Marginal fÃ¶r alla paket",
        priceMarginPerPkg: "Marginal fÃ¶r ett paket",
        priceSellPriceAll: "FÃ¶rsÃ¤ljningspris fÃ¶r alla paket",
        priceSellPricePerKg: "FÃ¶rsÃ¤ljningspris per kilogram",
        priceSellPricePerL: "FÃ¶rsÃ¤ljningspris per liter",
        priceSellPricePerPkg: "FÃ¶rsÃ¤ljningspris fÃ¶r ett paket",
        priceSurchargeAll: "TillÃ¤ggsavgift fÃ¶r alla paket",
        priceSurchargePerPkg: "TillÃ¤ggsavgift fÃ¶r ett paket",
        priceTintPurchaseAll: "Brytningskostnad fÃ¶r alla paket",
        priceTintPurchasePerPkg: "Brytningskostnad fÃ¶r ett paket",
        priceTintSellFullAll: "FÃ¶rsÃ¤ljningspris fÃ¶r brytning av alla fÃ¶rpackningar",
        priceTintSellFullAllPerPackage: "FÃ¶rsÃ¤ljningspris fÃ¶r brytning per fÃ¶rpackning",
        priceTotalPurchaseAll: "Total kostnad fÃ¶r alla paket",
        priceTotalPurchasePerKg: "Total kostnad fÃ¶r per kilogram",
        priceTotalPurchasePerL: "Total kostnad fÃ¶r per liter",
        priceTotalPurchasePerPkg: "Total kostnad fÃ¶r ett paket",
        priceTotalSellFullAll: "Totalt fÃ¶rsÃ¤ljningspris fÃ¶r alla fÃ¶rpackningar",
        priceTotalSellFullPerKg: "Totalt fÃ¶rsÃ¤ljningspris per kg",
        priceTotalSellFullPerLiter: "Totalt fÃ¶rsÃ¤ljningspris per liter",
        priceTotalSellFullPerPackage: "Totalt fÃ¶rsÃ¤ljningspris per fÃ¶rpackning"
    },
    pricing: {
        allBases: "Alla baser",
        allPackages: "Alla paket",
        backup: "Backup",
        basesOfProduct: "Baser av %{productName}",
        colorantPricing: "Priser fÃ¶r brytpasta",
        export: "Exportera",
        import: "Importera",
        packagePricing: "Paketpriser",
        packageSurcharge: "TillÃ¤ggsavgift fÃ¶r paket",
        packages: "Paket",
        packagesOfProduct: "FÃ¶rpackningar av %{productName}",
        posCoeficient: "POS coeficient",
        priceGroupPricePerLiter: "Prisgruppspris per liter",
        priceGroups: "Prisgrupper",
        pricePerLiter: "Pris per liter",
        productPricing: "Produktpriser",
        purchasePrice: "InkÃ¶pspris",
        purchasePricePerLiter: "InkÃ¶pspris per liter",
        sellPrice: "FÃ¶rsÃ¤ljningspris",
        surcharge: "TillÃ¤ggsavgift"
    },
    print: {
        adminRightsRequired: "AdministratÃ¶rsrÃ¤ttigheter krÃ¤vs fÃ¶r att redigera eller skapa en ny mall.",
        allowAutomaticPrint: "Automatisk utskrift",
        allowPrintAfterDispensing: "TillÃ¥t utskrift efter brytning",
        allowPrintBeforeDispensing: "TillÃ¥t utskrift fÃ¶re brytning",
        automaticPrint: "Skriv ut automatiskt",
        choosePrinter: "Skrivare",
        chooseSettings: "Ãndra instÃ¤llningar",
        chooseTemplate: "Mall",
        copies: "Kopior",
        createTemplate: "Skapa mall",
        createTemplateHint: "Skapa en ny mall frÃ¥n grunden. Spara den i mallmappen och starta om RCC.",
        defaultPrinter: "Standardskrivare",
        defaultSettings: "StandardinstÃ¤llningarna",
        defaultTemplate: "Standardmall",
        editTemplate: "Redigera mall",
        editTemplateHint: "Redigera %{name}. Ãndringar visas efter omstart av RCC.",
        noEditTemplate: "Ingen mall att redigera",
        noPrinterSelected: "Ingen skrivare har valts",
        noPrintersAvailable: "Ingen skrivare Ã¤r tillgÃ¤nglig",
        noTemplateSelected: "Ingen mall har valts",
        noTemplatesAvailable: "Ingen mall Ã¤r tillgÃ¤nglig",
        numberOfCopies: "Antal kopior",
        openTemplateEditor: "Ãppna mallredigeraren",
        printAfterDispensing: "Skriv ut efter brytning",
        printAsImage: "Skriv ut som bild",
        printBeforeDispensing: "Skriv ut fÃ¶re brytning",
        printOnRequest: "Skriv ut pÃ¥ begÃ¤ran",
        printOptions: "Utskriftsalternativ",
        printPagesAfterDispensing: "Antal etikettkopior",
        printPagesBeforeDispensing: "Antal etikettkopior",
        printPreview: "FÃ¶rhandsgranska",
        printSettings: "UtskriftsinstÃ¤llningar",
        printTaskLinkVariable: "LÃ¤nk till en variabel",
        printVariable: "Variabel fÃ¶r utskrift",
        printerName: "Skrivarnamn",
        printerOptions: "Alternativ fÃ¶r skrivare",
        printerSettings: "SkrivarinstÃ¤llningar",
        quickTintTemplate: "Snabbrytningsmall",
        setDefaultPrinter: "Ange standardskrivare",
        setDefaultTemplate: "Ange standardmall",
        setQuickTintTemplate: "Ange snabbrytningsmall",
        showPreviewDialogBeforePrint: "Visa fÃ¶rhandsgranskningsdialogruta fÃ¶re utskrift",
        template: "Mall",
        templateName: "Mallens namn",
        templateSettings: "MallinstÃ¤llningar "
    },
    printTemplate: {
        baseCode: "Baskod",
        baseName: "Basnamn",
        bfs: "BFS",
        colorantType: "Colorant type",
        customerCity: "Kundens ort",
        customerEmail: "Kundens e-post",
        customerName: "Kundens namn",
        customerPhone: "Kundens telefonnummer",
        customerStreet: "Kundens gatuadress",
        customerZipCode: "Kundens postnummer",
        destinationOfUse: "Destination of use",
        infoBfsGrade: "BFS-grad",
        orderQrCode: "QR-kod",
        packageOrderCount: "Antal paketorder",
        posAddress: "Adress fÃ¶r fÃ¶rsÃ¤ljningsstÃ¤lle",
        posAddressSecond: "Adress 2 fÃ¶r fÃ¶rsÃ¤ljningsstÃ¤lle",
        posCity: "FÃ¶rsÃ¤ljningsstÃ¤lle, ort",
        posContact: "Kontaktperson pÃ¥ fÃ¶rsÃ¤ljningsstÃ¤lle",
        posEmail: "FÃ¶rsÃ¤ljningsstÃ¤lle, e-post",
        posPhone: "FÃ¶rsÃ¤ljningsstÃ¤lle, telefon",
        posUrl: "FÃ¶rsÃ¤ljningsstÃ¤lle, URL",
        posZipCode: "FÃ¶rsÃ¤ljningsstÃ¤lle, postnummer",
        priceBasePurchaseWithTax: "Kostnad fÃ¶r bas inklusive moms",
        priceBaseSellWithTax: "FÃ¶rsÃ¤ljningspris fÃ¶r bas inklusive moms",
        priceCntPurchaseWithTax: "Kostnad fÃ¶r brytpasta inklusive moms",
        priceCntTotalSellWithTax: "FÃ¶rsÃ¤ljningspris fÃ¶r brytpasta inklusive moms",
        priceMarginAllWithTax: "Marginal fÃ¶r alla paket inklusive moms",
        priceMarginPerPkgWithTax: "Marginal fÃ¶r ett paket inklusive moms",
        priceSellPriceAllWithTax: "FÃ¶rsÃ¤ljningspris fÃ¶r alla paket inklusive moms",
        priceSellPricePerKgWithTax: "FÃ¶rsÃ¤ljningspris per kilogram inklusive moms",
        priceSellPricePerLWithTax: "FÃ¶rsÃ¤ljningspris per liter inklusive moms",
        priceSellPricePerPkgWithTax: "FÃ¶rsÃ¤ljningspris fÃ¶r ett paket inklusive moms",
        priceSurchargeAllWithTax: "TillÃ¤ggsavgift fÃ¶r alla paket inklusive moms",
        priceSurchargePerPkgWithTax: "TillÃ¤ggsavgift fÃ¶r ett paket inklusive moms",
        priceTintPurchaseAllWithTax: "Brytningskostnad fÃ¶r alla paket inklusive moms",
        priceTintPurchasePerPkgWithTax: "Brytningskostnad fÃ¶r ett paket inklusive moms",
        priceTotalPurchaseAllWithTax: "Total kostnad fÃ¶r alla paket inklusive moms",
        priceTotalPurchasePerKgWithTax: "Total kostnad fÃ¶r per kilogram inklusive moms",
        priceTotalPurchasePerLWithTax: "Total kostnad fÃ¶r per liter inklusive moms",
        priceTotalPurchasePerPkgWithTax: "Total kostnad fÃ¶r ett paket inklusive moms",
        productAltName: "Produkt",
        recipeInline: "Recept"
    },
    products: {
        bases: "Bas",
        numberOfProducts: "Antal produkter",
        packagesFor: "Paket fÃ¶r",
        sizeOfPackage: "Paketstorlek"
    },
    purgeModal: {
        purgeAll: "Rensa alla",
        purgeAllChannels: "Rensa alla kanaler",
        purgeVolume: "Rensningsvolym",
        startPurge: "Starta rensning"
    },
    qualityControl: {
        darker: "Darker",
        dispensedMeasuredFormula: "Dispensed (measured) formula",
        lighter: "Lighter",
        measureDispensedFormula: "Measure dispensed formula to calculate delta E",
        moreBlue: "More blue",
        moreGreen: "More green",
        moreRed: "More red",
        moreYellow: "More yellow",
        pleaseContinueToFormulaCorrection: "Please continue to formula correction",
        qualityControlFailed: "Quality control failed!",
        qualityControlPassed: "Quality control passed"
    },
    quickTint: {
        dispensingInProgress: "Brytning pÃ¥gÃ¥r",
        dispensingIsNotAvailable: "Brytning Ã¤r inte tillgÃ¤ngligt",
        machineNotConnected: "Ingen maskin Ã¤r ansluten",
        noColorantsSelected: "Ingen brytpasta har valts",
        noPrinterAvailable: "Utskriften kan inte utfÃ¶ras eftersom ingen skrivare Ã¤r tillgÃ¤nglig.",
        noTemplateAvailable: "Utskriften kan inte utfÃ¶ras eftersom ingen mall Ã¤r tillgÃ¤nglig.",
        overMaxCanisterSize: "En eller flera brytpastor Ã¤r ogiltiga"
    },
    quickTintSettings: {
        alphabetically: "Alfabetisk",
        byCanister: "Efter behÃ¥llare",
        closeAfterDispensing: "StÃ¤ng efter brytning",
        closeBeforeDispensing: "StÃ¤ng fÃ¶re brytning",
        quickTintSettings: "InstÃ¤llningar fÃ¶r snabbrytning",
        sorting: "Sortering",
        windowClosingRules: "Regler fÃ¶r stÃ¤ngning av fÃ¶nster"
    },
    rccButtons: {
        abort: "stoppa",
        all: "alla",
        cancel: "avbryt",
        continue: "fortsÃ¤tt",
        help: "hjÃ¤lp",
        ignore: "ignorera",
        no: "nej",
        noToAll: "nej till alla",
        ok: "OK",
        postpone: "skjut upp",
        resume: "Ã¥teruppta",
        retry: "fÃ¶rsÃ¶k igen",
        skip: "hoppa Ã¶ver",
        yes: "ja",
        yesToAll: "ja till alla"
    },
    rccDialog: {
        98: "Kontrollera basen %{0} med streckkoden",
        99: "SÃ¤tt i basen %{0} och bekrÃ¤fta (tryck pÃ¥ OK)",
        100: "Brytmaskinen Ã¤r i fellÃ¤ge, nollstÃ¤ll fel?",
        101: "Brytmaskinen Ã¤r i fellÃ¤ge och kan dÃ¤rfÃ¶r inte fortsÃ¤tta",
        102: "ÃterstÃ¤llningen misslyckades, kan inte fortsÃ¤tta",
        103: "Receptet innehÃ¥ller ogiltig brytpasta: %{0}",
        104: "Receptet innehÃ¥ller ogiltiga brytpastor: %{0}",
        105: "Brytpasta: %{0} Ã¤r under varningsnivÃ¥",
        106: "Brytpastor: %{0} Ã¤r under varningsnivÃ¥",
        107: "Brytpasta: %{0} Ã¤r under kritisk nivÃ¥",
        108: "Brytpastor: %{0} Ã¤r under kritisk nivÃ¥",
        109: "Placera burk/hink",
        110: "Placera bas: %{0} fÃ¶r recept: %{1}",
        111: "Ta bort burk/hink",
        112: "FÃ¶rslut burk/hink?",
        113: "ÃterstÃ¤ller fel. VÃ¤nta",
        114: "Flyttar hylla. VÃ¤nta",
        115: "FÃ¶rsluter burken/hinken. VÃ¤nta",
        116: "Bryter receptet %{0}, vÃ¤nta | Paket: %{1} av %{2} | Produkt: %{3} | Bas: %{4} | Storlek pÃ¥ burk/hink: %{5}",
        117: "Bryter receptet %{0}, vÃ¤nta | Paket: %{1} av %{2} | Produkt: %{3} | Bas: %{4} | Storlek pÃ¥ burk/hink: %{5}",
        118: "Bryter, vÃ¤nta. Paket: %{0} av %{1}",
        119: "Bryter, vÃ¤nta. Paket: %{0} av %{1}",
        120: "Avbryter brytning, vÃ¤nta",
        121: "Kontrollera streckkoden pÃ¥ burken",
        122: "Kontrollera basens streckkod | Produkt: %{0} | Bas: %{1} | Storlek pÃ¥ burk/hink: %{2}",
        123: "Brytningsprocessen har avbrutits. Vill du Ã¥teruppta brytningen?",
        124: "Brytmaskinsfel uppstod %{0} : %{1}. Vill du Ã¥teruppta brytningen?",
        125: "Se till att samma burk som sist anvÃ¤nds",
        126: "Se till att anvÃ¤nda en ny burk/hink eftersom brytningsprocessen bÃ¶rjar om frÃ¥n bÃ¶rjan",
        127: "Brytpasta: %{0} Ã¤r under den minsta doseringsmÃ¤ngden. Vill du fortsÃ¤tta trots denna varning?",
        128: "Brytpasta: %{0} Ã¤r under den minsta doseringsmÃ¤ngden. Vill du fortsÃ¤tta trots denna varning?",
        129: "Det valda receptet strider mot Ã¶verfyllningsregeln, den totala mÃ¤ngden brytpastor: %{0} %{1}, hÃ¶gsta tillÃ¥tna mÃ¤ngd brytpastor: %{2} %{3}. Vill du fortsÃ¤tta trots denna varning?",
        130: "Brytmaskinen Ã¤r i fellÃ¤ge, vill du Ã¥terstÃ¤lla felen?",
        131: "Brytmaskinen Ã¤r i fellÃ¤ge och kan dÃ¤rfÃ¶r inte fortsÃ¤tta",
        132: "ÃterstÃ¤llningen misslyckades, kan inte fortsÃ¤tta",
        133: "Rensningsreceptet Ã¤r tomt, kan inte fortsÃ¤tta",
        134: "Rensningsreceptet innehÃ¥ller delar som inte kan rensas. Vill du fortsÃ¤tta?",
        135: "Placera burk fÃ¶r rensning",
        136: "Ta bort burk fÃ¶r rensning",
        137: "ÃterstÃ¤ller fel. VÃ¤nta",
        138: "Flyttar hylla. VÃ¤nta",
        139: "Rensar. VÃ¤nta",
        140: "Rensar. VÃ¤nta",
        141: "Avbryter rensning. VÃ¤nta",
        142: "Burk fÃ¶r rensning saknas, kontrollera att burken Ã¤r korrekt placerad",
        143: "Rensningsreceptet innehÃ¥ller delar som inte kan rensas. Vill du fortsÃ¤tta?",
        144: "Placera burk fÃ¶r rensning",
        145: "FÃ¶rbereder. VÃ¤nta",
        146: "SlutfÃ¶r. VÃ¤nta",
        150: "RengÃ¶r. VÃ¤nta",
        151: "RengÃ¶r. VÃ¤nta",
        152: "Avbryter rengÃ¶ring. VÃ¤nta",
        160: "Ãtercirkulerar. VÃ¤nta",
        161: "Ãtercirkulerar. VÃ¤nta",
        162: "Avbryter Ã¥tercirkulation. VÃ¤nta",
        170: "RÃ¶r om. VÃ¤nta",
        171: "RÃ¶r om. VÃ¤nta",
        172: "Avbryter omrÃ¶rning. VÃ¤nta",
        180: "Initierar anslutning till brytmaskin. VÃ¤nta",
        181: "Det gick inte att ansluta till brytmaskinen %{0}: %{1}",
        182: "Det gick inte att ansluta till brytmaskinen. Se loggfiler fÃ¶r mer information",
        183: "Brytmaskinen saknar brytpasta: %{0} som Ã¤r definierad i din databas",
        184: "Brytmaskinen saknar brytpastor: %{0} som Ã¤r definierade i din databas",
        185: "StÃ¤nger anslutningen till brytmaskinen. VÃ¤nta",
        190: "StÃ¤ng servicefÃ¶nstret fÃ¶r att fortsÃ¤tta",
        200: "ÃterstÃ¤ller. VÃ¤nta",
        201: "HÃ¥rd Ã¥terstÃ¤llning. VÃ¤nta",
        202: "Initierar. VÃ¤nta",
        203: "ÃterstÃ¤ller fel. VÃ¤nta",
        205: "Ãppnar Autocap. VÃ¤nta",
        206: "StÃ¤nger Autocap. VÃ¤nta",
        207: "Flyttar Autocap. VÃ¤nta",
        210: "FÃ¶rsluter. VÃ¤nta",
        211: "Pluggar igen. VÃ¤nta",
        215: "Flytta hyllan uppÃ¥t. VÃ¤nta",
        216: "Flytta hyllan nedÃ¥t. VÃ¤nta",
        217: "Flyttar hylla. VÃ¤nta",
        220: "Flyttar bord till pÃ¥fyllningsposition: %{0}. VÃ¤nta",
        221: "Flyttar bord till startposition. VÃ¤nta",
        222: "Flyttar bord. VÃ¤nta",
        230: "Brytmaskinen Ã¤r upptagen. VÃ¤nta",
        240: "Fyll pÃ¥ behÃ¥llaren %{0}",
        241: "Fyll pÃ¥ behÃ¥llaren %{0}",
        242: "Placera behÃ¥llare: %{0} (%{1}) i pÃ¥fyllningsposition",
        243: "Fyll pÃ¥ behÃ¥llaren %{0} med hjÃ¤lp av streckkod",
        244: "Fyll pÃ¥ behÃ¥llaren %{0} med hjÃ¤lp av streckkod",
        250: "Ta bort borstbehÃ¥llaren, rengÃ¶r den och fyll den med vatten enligt instruktionerna",
        251: "SÃ¤tt tillbaka borstbehÃ¥llaren",
        254: "Ãppnar autocap",
        255: "RengÃ¶r autocap enligt instruktionerna",
        256: "BekrÃ¤fta nÃ¤r rengÃ¶ringen Ã¤r klar och autocap sitter pÃ¥ plats igen",
        257: "StÃ¤nger autocap",
        260: "Ta bort kontaktplattan och rengÃ¶r den",
        261: "SÃ¤tt tillbaka kontaktplattan",
        265: "RengÃ¶r maskinen med en trasa och ta bort eventuell spilld brytpasta eller annan vÃ¤tska",
        266: "BekrÃ¤fta nÃ¤r det Ã¤r klart",
        270: "Fyll pÃ¥ luftfuktarens vattentank och bekrÃ¤fta nÃ¤r det Ã¤r klart",
        271: "Fyll pÃ¥ luftfuktarens vattentank och bekrÃ¤fta nÃ¤r det Ã¤r klart",
        272: "VattennivÃ¥n Ã¤r fortfarande lÃ¥g, kontrollera den igen",
        273: "VattennivÃ¥n Ã¤r fortfarande lÃ¥g, kontrollera den igen",
        274: "Kontrollera vattennivÃ¥n i luftfuktarens vattentank och fyll pÃ¥ om det behÃ¶vs",
        275: "VÃ¤nta",
        280: "Starta om datorn",
        281: "StÃ¤nger av dator",
        300: "Bas saknas, kontrollera att burken Ã¤r rÃ¤tt placerad",
        301: "FÃ¶rbereder. VÃ¤nta",
        302: "SlutfÃ¶r. VÃ¤nta",
        303: "Receptet kan inte brytas eftersom det innehÃ¥ller brytpasta: %{0}, vilket Ã¤r Ã¶ver den maximala doseringsmÃ¤ngden som definierats fÃ¶r behÃ¥llaren",
        304: "Receptet kan inte brytas eftersom det innehÃ¥ller brytpastor: %{0}, vilket Ã¤r Ã¶ver de maximala doseringsmÃ¤ngderna som definierats fÃ¶r behÃ¥llarna",
        305: "Brytpasta: %{0} kan inte doseras pÃ¥ en gÃ¥ng. Vill du dela upp receptet?",
        306: "Brytpastorna: %{0} kan inte doseras pÃ¥ en gÃ¥ng. Vill du dela upp receptet?",
        307: "Brytpasta: %{0} doseras inte av brytmaskinen, vill du fortsÃ¤tta och lÃ¤gga till den manuellt?",
        308: "Brytpastorna: %{0} doseras inte av brytmaskinen, vill du fortsÃ¤tta och lÃ¤gga till dem manuellt?",
        309: "Det valda receptet Ã¤r tomt, anvÃ¤nd basen som den Ã¤r",
        310: "Inga brytpastor kan doseras. FÃ¶rbered basburk fÃ¶r manuell tillsats av brytpasta",
        311: "Ta bort basburken och fÃ¶rbered den fÃ¶r manuell dosering av brytpasta",
        312: "Dosera manuellt %{0} %{1} av brytpasta: %{2}, bekrÃ¤fta nÃ¤r det har slutfÃ¶rts",
        313: "Dosera receptet manuellt",
        314: "Det valda receptet strider mot Ã¶verfyllningsregeln, den totala mÃ¤ngden brytpasta: %{0} %{1}, hÃ¶gsta tillÃ¥tna mÃ¤ngd brytpasta: %{2} %{3}. Vill du fortsÃ¤tta trots denna varning?",
        315: "Skanna eller skriv UFI-kod fÃ¶r bas kan",
        316: "Skanna eller skriv UFI-kod fÃ¶r bas kan| Produkt: %{0}| Bas: %{1}| Kan storlek: %{2}",
        317: "Prepare colorant: %{0} for manual addition, confirm when done",
        318: "Prepare colorants: %{0} for manual addition, confirm when done",
        319: "Add manually colorant: %{0}, confirm when done",
        320: "Add manually colorants: %{0}, confirm when done",
        400: "Automatisk rensning kommer att startas",
        401: "Automatisk rensning kommer att startas",
        405: "BorstbehÃ¥llaren mÃ¥ste underhÃ¥llas",
        406: "BorstbehÃ¥llaren mÃ¥ste underhÃ¥llas",
        410: "Automatiskt lockunderhÃ¥ll kommer att startas",
        411: "Automatiskt lockunderhÃ¥ll kommer att startas",
        415: "Kontaktplattan mÃ¥ste rengÃ¶ras",
        416: "Kontaktplattan mÃ¥ste rengÃ¶ras",
        420: "Brytmaskinen mÃ¥ste rengÃ¶ras",
        421: "Brytmaskinen mÃ¥ste rengÃ¶ras",
        425: "PÃ¥fyllning av behÃ¥llare kommer att startas",
        426: "PÃ¥fyllning av behÃ¥llare kommer att startas",
        430: "Omstart av datorn har schemalagts",
        431: "Omstart av datorn har schemalagts",
        435: "AvstÃ¤ngning av datorn har schemalagts",
        436: "AvstÃ¤ngning av datorn har schemalagts",
        440: "RengÃ¶ring av brytmaskinen har schemalagts",
        441: "RengÃ¶ring av brytmaskinen har schemalagts",
        445: "Ãtercirkulation av brytmaskinen har schemalagts",
        446: "Ãtercirkulation av brytmaskinen har schemalagts",
        450: "OmrÃ¶rning av brytmaskinen har schemalagts",
        451: "OmrÃ¶rning av brytmaskinen har schemalagts",
        990: "Brytmaskinsfel uppstod %{0}: %{1}. Vill du fÃ¶rsÃ¶ka utfÃ¶ra uppgiften igen?",
        991: "Internt fel uppstod: %{0}",
        200000001: "Placera burk/hink",
        200000002: "Ta bort burk/hink",
        200000003: "MÃ¤ngden fÃ¶r %{0} Ã¤r under minsta doseringsmÃ¤ngd. Vill du fortsÃ¤tta pÃ¥ egen risk?",
        200000004: "Fyll pÃ¥ %{0}"
    },
    rccDriverSettings: {
        databasePath: "SÃ¶kvÃ¤g till databas",
        dispenser: "Brytmaskin",
        dispenserConfigurationFile: "Konfigurationsfil fÃ¶r brytmaskin",
        driverPath: "SÃ¶kvÃ¤g fÃ¶r drivrutin",
        extensionPath: "SÃ¶kvÃ¤g fÃ¶r tillÃ¤gg",
        folder: "Mapp",
        formulaPath: "ReceptsÃ¶kvÃ¤g",
        host: "VÃ¤rd",
        iddPath: "IDD-konfigurationsfil",
        italtintoPath: "KonfigurationssÃ¶kvÃ¤g fÃ¶r Italtinto",
        lldPath: "HLD-rotkatalog",
        machineType: "Maskintyp",
        noMachineAvailable: "Ingen maskin Ã¤r tillgÃ¤nglig",
        protocolVersion: "Protokollversion",
        rccDriverSettings: "DrivrutinsinstÃ¤llningar",
        resultPath: "ResultatsÃ¶kvÃ¤g",
        save: "Spara instÃ¤llningar",
        saveSettingsWarning: "Varning! Ãndringar i detta avsnitt kan leda till att brytmaskinen inte fungerar.",
        serviceSwPath: "SÃ¶kvÃ¤g till serviceprogramvara",
        simulationPath: "SimuleringssÃ¶kvÃ¤g"
    },
    rccMachineSettings: {
        allowManualColorantAddition: "TillÃ¥t manuell dosering av brytpasta",
        ask: "FrÃ¥ga",
        canHandlingOptions: "Alternativ fÃ¶r burkhantering",
        checkCanBeforeDispense: "Kontrollera burken fÃ¶re brytning",
        checkOverfill: "Kontrollera Ã¶verfyllning",
        colorantBatchNumbers: "Colorant batch numbers",
        colorantPackageValidation: "Endast kontroll av brytpastapaket",
        disable: "Inaktivera",
        dispenseInvalidColorants: "Dosera ogiltiga brytpastor",
        dispensingOptions: "BrytningsinstÃ¤llningar",
        enable: "Aktivera",
        enableUserIdentification: "AnvÃ¤ndaridentifiering",
        fullValidation: "FullstÃ¤ndig kontroll",
        machineAccuracyWarning: "Varning fÃ¶r maskinens noggrannhet",
        machineOptions: "MaskininstÃ¤llningar",
        machineUnit: "Maskinenhet",
        minimalDispenseAmount: "Minsta doseringsmÃ¤ngd",
        placeCanSensor: "Sensor fÃ¶r placering av burk/hink",
        placeCanSensorDelay: "FÃ¶rdrÃ¶jning pÃ¥ sensor fÃ¶r placering av burk/hink",
        rccMachineSettings: "MaskininstÃ¤llningar",
        refillBarcodeValidation: "Refill barcode validation",
        refillBarcodeValidationCanisterAndColorant: "Validate Canister and Colorant package",
        refillBarcodeValidationColorant: "Validate only colorant package",
        refillSettings: "Refill settings",
        removeCanSensor: "Sensor fÃ¶r borttagning av burk/hink",
        removeCanSensorDelay: "FÃ¶rdrÃ¶jning pÃ¥ sensor fÃ¶r borttagning av burk/hink",
        save: "Spara instÃ¤llningar",
        sec: "sekunder",
        skipPlaceCanDialog: "Hoppa Ã¶ver dialogruta om placering av burk/hink",
        skipRemoveCanDialog: "Hoppa Ã¶ver dialogruta om borttagning av burk/hink",
        splitFormula: "Dela upp receptet",
        tmcEnabled: "Aktivera TMC",
        ufiCode: "UFI code",
        validateBarcodeBaseCan: "Kontrollera streckkod pÃ¥ basburk/-hink",
        validateBarcodeRefill: "Kontrollera streckkod pÃ¥ behÃ¥llaren fÃ¶re pÃ¥fyllning",
        validateColorantsDuringInit: "Kontrollera brytpasta under initiering"
    },
    rccPanel: {
        actionsRunningOnDispenser: "ÃtgÃ¤rder kÃ¶rs pÃ¥ maskinen",
        addLevel: "LÃGG TILL NIVÃ",
        addManually: "LÃ¤gg till manuellt",
        barcodeNotSet: "BehÃ¥llare %{colorantName} (%{canisterName}) har inte tilldelats nÃ¥gon streckkod.",
        cancel: "AVBRYT",
        dispenseFormula: "Recept",
        dispenserIdle: "Maskinen Ã¤r inaktiv",
        dispenserIsBusy: "Maskinen Ã¤r upptagen",
        dispenserIsIdle: "Maskinen Ã¤r inaktiv",
        dispenserIsReady: "Maskinen Ã¤r redo fÃ¶r ytterligare uppgifter",
        dispensingFormula: "Recept",
        errorCode: "Felkod",
        explanation: "FÃ¶rklaring",
        fillToMax: "Fyll maximalt",
        finished: "Klar",
        inProgress: "IgÃ¥ng",
        machineIsReady: "Maskinen Ã¤r klar",
        moveToFill: "Flytta till fyllning",
        noMachineDialog: "Ingen maskin Ã¤r ansluten",
        of: "av",
        packageSize: "Paketstorlek",
        placeBaseCan: "Placera basburk/-hink",
        pleaseCheckYourMachineConnection: "Kontrollera maskinanslutningen",
        pleaseRefill: "Fyll pÃ¥",
        solution: "LÃ¶sning",
        subErrors: "Fel",
        timeToEnd: "Tid till mÃ¥l",
        tintingFormula: "Recept",
        tintingPleaseWait: "Bryter. VÃ¤nta",
        validateBaseCan: "Kontrollera basburk/-hink",
        waiting: "VÃ¤ntar"
    },
    rccSettigns: {
        rccSettigns: "RCC-anslutning",
        rccUrl: "URL fÃ¶r RCC"
    },
    rccSpectroDialog: {
        100: "Ansluter till enheten via Bluetooth. Kontrollera att du har Bluetooth aktiverat och att ditt instrument har startats.",
        101: "Instrumentet hittades inte. Vill du fÃ¶rsÃ¶ka igen?",
        110: "Kontrollera att Nano Ã¤r anslutet och tryck pÃ¥ instrumentknappen fÃ¶r att starta initieringen",
        111: "Nano hittades inte. Vill du fÃ¶rsÃ¶ka igen?",
        112: "Koppla bort Nano, vÃ¤nta 10 sekunder, anslut igen och fortsÃ¤tt",
        120: "Ansluter enheten. VÃ¤nta",
        121: "Instrumentet hittades inte. Vill du fÃ¶rsÃ¶ka igen?",
        200: "Placera instrumentet pÃ¥ den svarta plattan och fortsÃ¤tt eller tryck pÃ¥ instrumentknappen",
        201: "Placera instrumentet pÃ¥ den svarta plattan och fortsÃ¤tt",
        202: "Placera instrumentet pÃ¥ den svarta plattan och tryck pÃ¥ instrumentknappen",
        205: "Placera instrumentet pÃ¥ den vita plattan och fortsÃ¤tt eller tryck pÃ¥ instrumentknappen",
        206: "Placera instrumentet pÃ¥ den vita plattan och fortsÃ¤tt",
        207: "Placera instrumentet pÃ¥ den vita plattan och tryck pÃ¥ instrumentknappen",
        210: "Placera instrumentet pÃ¥ diagnostikplattan och fortsÃ¤tt eller tryck pÃ¥ instrumentknappen",
        211: "Placera instrumentet pÃ¥ diagnostikplattan och fortsÃ¤tt",
        212: "Placera instrumentet pÃ¥ diagnostikplattan och tryck pÃ¥ instrumentknappen",
        215: "StÃ¤ng instrumentluckan och fortsÃ¤tt eller tryck pÃ¥ instrumentknappen",
        216: "StÃ¤ng instrumentluckan och fortsÃ¤tt",
        217: "StÃ¤ng instrumentluckan och tryck pÃ¥ instrumentknappen",
        220: "Placera instrumentet pÃ¥ nollplattan och fortsÃ¤tt eller tryck pÃ¥ instrumentknappen",
        221: "Placera instrumentet pÃ¥ nollplattan och fortsÃ¤tt",
        222: "Placera instrumentet pÃ¥ nollplattan och tryck pÃ¥ instrumentknappen",
        224: "Placera instrumentet pÃ¥ kalibreringsplattan och fortsÃ¤tt eller tryck pÃ¥ instrumentknappen",
        225: "Placera instrumentet pÃ¥ kalibreringsplattan och fortsÃ¤tt",
        226: "Placera instrumentet pÃ¥ kalibreringsplattan och tryck pÃ¥ instrumentknappen",
        227: "Placera instrumentet pÃ¥ kalibreringsplattan och tryck pÃ¥ instrumentknappen",
        295: "Avsluta kalibreringen i drivrutinsfÃ¶nstret",
        296: "Instrumentet Ã¤r inte anslutet, vill du Ã¶ppna anslutningen till det?",
        297: "FÃ¶rbereder fÃ¶r kalibreringssteg. VÃ¤nta",
        298: "Kalibrerar. VÃ¤nta",
        299: "Avslutar kalibreringssteg. VÃ¤nta",
        300: "Placera instrumentet pÃ¥ provet och fortsÃ¤tt eller tryck pÃ¥ instrumentknappen",
        301: "Placera instrumentet pÃ¥ provet och fortsÃ¤tt",
        302: "Placera instrumentet pÃ¥ provet och tryck pÃ¥ instrumentknappen",
        303: "Instrument kalibreras inte, vill du fortsÃ¤tta med kalibrering?",
        304: "Instrumentet Ã¤r inte anslutet, vill du Ã¶ppna anslutningen till det?",
        390: "VÃ¤lj mÃ¤tlÃ¤ge",
        395: "Avsluta mÃ¤tningen i drivrutinsfÃ¶nstret",
        397: "FÃ¶rbereder mÃ¤tning. VÃ¤nta",
        398: "MÃ¤ter. VÃ¤nta",
        399: "SlutfÃ¶r mÃ¤tning. VÃ¤nta",
        498: "HÃ¤mtar mÃ¥tt. VÃ¤nta",
        499: "HÃ¤mtar alla mÃ¥tt. VÃ¤nta",
        900: "Instrumentfel uppstod %{0}: %{1}. Vill du fÃ¶rsÃ¶ka utfÃ¶ra uppgiften igen?",
        901: "Instrumentfel uppstod: %{0}"
    },
    rccSpectroSettings: {
        DatacolorColorReader:
            "Datorn mÃ¥ste ha en Bluetooth-anslutning. Spektrometern mÃ¥ste parkopplas till datorn. Windows 10 med hÃ¶stuppdatering 2018 krÃ¤vs.",
        DatacolorSilent:
            "NÃ¤r du anvÃ¤nder tyst lÃ¤ge visas Datacolor-fÃ¶nstren direkt i %{name}. I dessa fÃ¶nster kan spektrometerns parametrar inte Ã¤ndras.",
        DatacolorUseDiagnosticTile: "AnvÃ¤ndning av diagnostikplatta fÃ¶rbÃ¤ttrar mÃ¤tkvaliteten.",
        comPort: "Com-port",
        diagnosticTile: "DatakulÃ¶r anvÃ¤nder diagnostikplatta",
        measureModes: "MÃ¤t lÃ¤gen",
        measureModesOrder: "Ordning pÃ¥ mÃ¤tlÃ¤gen",
        model: "Modell",
        noSpectroAvailable: "Ingen spektrometer Ã¤r tillgÃ¤nglig",
        rccSpectroSettings: "InstÃ¤llningar fÃ¶r spektrometer",
        save: "Spara instÃ¤llningar",
        silent: "DatakulÃ¶r tyst",
        simulationPath: "SimuleringssÃ¶kvÃ¤g",
        spectroType: "Spektrometertyp",
        useProfiledValues: "AnvÃ¤nd profilvÃ¤rden"
    },
    recirculateChannels: {
        recirculateAllChannels: "Ãtercirkulera alla kanaler",
        recirculateChannels: "Ãtercirkulera kanaler",
        recirculatingSpeed: "Hastighet fÃ¶r Ã¥tercirkulation",
        recirculatingTime: "Ãtercirkulationstid",
        startRecirculating: "Starta Ã¥tercirkulation"
    },
    redlikeLight: {
        finishPreviousSteps: "SlutfÃ¶r fÃ¶regÃ¥ende steg",
        searchBySpectro: "SÃ¶k med spektrometer",
        searchFormula: "SÃ¶k nytt recept",
        selectBase: "VÃ¤lj bas",
        selectColor: "VÃ¤lj kulÃ¶r",
        selectCustomer: "VÃ¤lj kund",
        selectFandeck: "VÃ¤lj fÃ¤rgkarta",
        selectPackage: "VÃ¤lj paket",
        selectProduct: "VÃ¤lj produkt",
        startSelectFandeck: "BÃ¶rja med att vÃ¤lja en fÃ¤rgkarta",
        startSelectProduct: "BÃ¶rja med att vÃ¤lja en produkt",
        stepByStepProgress: "Du kan gÃ¥ vidare steg fÃ¶r steg",
        typeHereToSearch: "Skriv hÃ¤r fÃ¶r att sÃ¶ka",
        typeToFilter: "Filtertyp"
    },
    restartModal: {
        computerNeedsRestart: "Datorn mÃ¥ste startas om",
        notCompletelyTranslated:
            "Byte av sprÃ¥k krÃ¤ver att programvaran startas om. Vissa delar av programvaran kanske inte Ã¤r helt Ã¶versatta fÃ¶r nÃ¤rvarande.",
        restartIsRequired: "Omstart av programvara krÃ¤vs efter att Ã¤ndringarna har gjorts.",
        softwareNeedsRestart: "%{name} behÃ¶ver startas om!"
    },
    searchPanel: {
        basePlaceholder: "eller skriva ett basnamn",
        baseStartPlaceholder: "Skriva ett basnamn",
        colorCodeNamePlaceholder: "eller skriv receptkod/-namn",
        colorCodeNameStartPlaceholder: "BÃ¶rja med att skriva ett receptkod/-namn",
        colorCodePlaceholder: "eller ange en receptkod",
        colorCodeStartPlaceholder: "BÃ¶rja med att ange en receptkod",
        colorNameCodePlaceholder: "eller skriv receptnamn/-kod",
        colorNameCodeStartPlaceholder: "Ange formelnamn/kod",
        colorNamePlaceholder: "eller ange ett receptnamn",
        colorNameStartPlaceholder: "Ange ett receptnamn",
        colorPreviewIsNotAvailable: "Color preview is not available. Select a fandeck to see relevant color preview.",
        fandeckPlaceholder: "eller ange en fÃ¤rgkarta",
        fandeckStartPlaceholder: "BÃ¶rja med att ange en fÃ¤rgkarta",
        formulaByColor: "Recept efter kulÃ¶r",
        noResultsFound: "Inga resultat hittades",
        packagePlaceholder: "eller skriva ett produktnamn",
        packageStartPlaceholder: "Skriva ett produktnamn",
        productPlaceholder: "eller ange ett produktnamn",
        productStartPlaceholder: "BÃ¶rja med att ange ett produktnamn",
        standard: "Standard",
        typeFandeckToFilter: "SÃ¶k efter fÃ¤rgkarta",
        typeProductToFilter: "SÃ¶k efter produktnamn"
    },
    sendOrderModal: {
        customNote: "Anpassad anteckning",
        noCompatibleServers: "Inga kompatibla servrar finns tillgÃ¤ngliga i ditt nÃ¤tverk",
        orderOverview: "Ordersammanfattning",
        selectTargetMachine: "VÃ¤lj mÃ¥lmaskin",
        sendOrder: "Skicka order",
        sendOrderTo: "Dina order skickas till %{serverName}",
        targetMachine: "MÃ¥lmaskin"
    },
    server: {
        computerId: "Dator-ID",
        ip: "IP",
        selectServer: "VÃ¤lj en av de tillgÃ¤ngliga servrarna",
        server: "Server"
    },
    serverDialog: {
        1: "There is an error in the brand definition for your license. Please check with your provider.",
        2: "Could not process data for %{0}: %{1}",
        3: "Invalid network path.",
        4: "Invalid path type (only %{0} and %{1} types are supported)",
        5: "Error writing tinting file.",
        6: "Tinting file was created successfully.",
        7: "Could not find colorant with name: '%{0}' on row '%{1}'",
        8: "Could not find package with name: '%{0}' on row '%{1}'",
        9: "Could not find base in product with product name: '%{0}' and base name: '%{1}' on row '%{2}'",
        10: "Could not find base in product package with product name: '%{0}', base name: '%{1}' and package name: '%{2}' on row '%{3}'",
        11: "Could not parse price value: '%{0}' on row '%{1}' in sheet '%{2}'",
        12: "Preparing bases data, please wait",
        13: "Preparing bases in products data, please wait",
        14: "Preparing base packages data, please wait",
        15: "Preparing colors data, please wait",
        16: "Preparing colors in fandecks data, please wait",
        17: "Preparing fandecks data, please wait",
        18: "Preparing data for global search, please wait",
        19: "Preparing products data, please wait",
        30: "Partial updates can't be applied on database '%{0}'. Update your software to the latest version. Minimal required version is '%{1}'.",
        31: "Partial updates can't be applied on database '%{0}'. Database versions doesn't match. Contact your technical support.",
        32: "Partial updates can't be applied on database '%{0}'. Database structure version doesn't match. Contact your technical support.",
        33: "Partial updates can't be applied on database '%{0}'. The update is corrupted. Contact your technical support.",
        34: "Unknown error occurred during partial update. If this error repeats contact your technical support.",
        35: "No partial updates available. Please check your internet connection or contact your technical support.",
        36: "Prepared partial updates for database '%{0}' are for newer version of Redlike. Update your Redlike to the latest version. Minimal required version is '%{1}'.",
        37: "Partial updates can't be prepared. There is not enough space on the drive. Minimal required space is 20 GB.",
        38: "Partial updates can't be applied on database '%{0}'. The update is invalid. Contact your technical support.",
        39: "Partial updates can't be applied on database '%{0}'. The update can't be downloaded. Contact your technical support.",
        40: "Partial updates can't be applied on database '%{0}'. Downloaded file is corrupted. Contact your technical support."
    },
    serverPlugins: {
        activeServerPlugins: "Aktiva plugin-program fÃ¶r server",
        currentlyActive: "De fÃ¶r nÃ¤rvarande aktiva plugin-programmen",
        plugin: "Plugin-program",
        pluginName: "Namn pÃ¥ plugin-program",
        statusActive: "Aktivera",
        statusInactive: "Inaktivera"
    },
    serviceActionsSettings: {
        canisterLevel: "BehÃ¥llarnivÃ¥er",
        capClose: "StÃ¤ng",
        capMiddle: "Mitten",
        capOpen: "Ãppna",
        cleanAllChannels: "RengÃ¶r alla",
        cleanChannels: "RengÃ¶r kanaler",
        computer: "Dator",
        computerReboot: "Omstart av datorn",
        computerShutdown: "AvstÃ¤ngning av datorn",
        connectMachine: "Anslut maskin",
        general: "AllmÃ¤nt",
        initialize: "Initiera",
        noMachineIsConnected: "Ingen maskin Ã¤r ansluten",
        plug: "Plugga igen",
        plugger: "Plugg",
        punch: "FÃ¶rslut",
        puncher: "FÃ¶rslutare",
        purgeChannels: "Rensa kanaler",
        recirculate: "Ãtercirkulera",
        recirculateAllChannels: "Ãtercirkulera alla",
        recirculateChannels: "Ãtercirkulera kanaler",
        serviceActions: "ServiceÃ¥tgÃ¤rder",
        setCanisterLevel: "Ange behÃ¥llarnivÃ¥er",
        shelfDown: "Hylla ner",
        shelfUp: "Hylla upp",
        showServiceWindow: "Visa servicefÃ¶nster",
        smartPurgeAllChannels: "Smart rengÃ¶ring av samtliga kanaler",
        smartPurgeChannels: "Smart rengÃ¶ring av kanaler",
        startErrorReset: "Starta felÃ¥terstÃ¤llning",
        startHardReset: "Starta hÃ¥rd Ã¥terstÃ¤llning",
        startReset: "Starta Ã¥terstÃ¤llning",
        stirAllCanisters: "RÃ¶r om alla",
        stirCanisters: "RÃ¶r om",
        stirCanistersMore: "RÃ¶r om behÃ¥llarna"
    },
    spectroMode: {
        eggshell: "Ãggskal",
        flat: "Flat",
        gloss: "Glans",
        matt: "Matt",
        matte: "Matte",
        pearl: "PÃ¤rla",
        satin: "Satin",
        selectGlossLevel: "JÃ¤mfÃ¶r fÃ¤rgexempla med glansskalan och vÃ¤lj glansnivÃ¥",
        semiGloss: "Halvglans"
    },
    spectroTab: {
        bestMatch: "The best match",
        calibrate: "Kalibrera",
        calibrateInstrument: "Kalibrera instrument",
        connectDevice: "Anslut enhet",
        connectedTo: "Ansluten till",
        connectingDevice: "Ansluter enheten",
        deselectAll: "Avmarkera alla",
        deviceCalibrated: "Your device has been calibrated and you can start measuring",
        deviceIsNotCalibrated: "Din enhet Ã¤r inte kalibrerad",
        eraseResult: "Ta bort resultat",
        filter: "Filter",
        foundInFormulas: "Hittades i recept",
        inactiveSpectro: "The Spectro function is inactive for selected brand.",
        instrumentCalibration: "Dina instrument mÃ¥ste kalibreras.",
        manualInput: "Manuell inmatning",
        measure: "MÃ¥tt",
        measurementResult: "LÃ¤s in recept",
        noFilters: "Inga filter tillgÃ¤ngliga",
        noFormulas: "Inga recept hittades",
        noSelectedSpectro: "Ingen spektrometer har valts",
        notSelected: "Inte markerat",
        pressConnectButton: "Kontrollera att enheten Ã¤r ansluten och tryck pÃ¥ anslutningsknappen",
        searchFormulas: "SÃ¶k nytt recept",
        selectSpectro: "VÃ¤lj spektrometer",
        showDetails: "Visa detaljer",
        skipCalibration: "Hoppa Ã¶ver kalibrering",
        spectroIsConnected: "Spektrometern Ã¤r ansluten",
        spectroIsReady: "Spektrometern Ã¤r redo",
        spectroReady: "Enheten Ã¤r redo fÃ¶r ytterligare uppgifter",
        startCalibrateNow: "BÃ¶rja kalibrera nu",
        startMeasureText: "Din enhet Ã¤r kalibrerad och du kan bÃ¶rja mÃ¤ta",
        tolerance: "Delta E (CIE 2000)",
        toleranceOfDevitation: "Tolerans fÃ¶r Delta E (CIE 2000)"
    },
    statisticsTab: {
        allRecords: "All records",
        customPackageName: "Anpassat %{1} %{2}",
        deleteSelectedRecords: "Ta bort markerade poster",
        exportHistory: "Exportera historik",
        finishFormula: "SlutfÃ¶r recept",
        foundInFormulas: "Hittades i recept",
        hideHiddenRecords: "Visa inte dolda poster",
        hideSelectedRecord: "DÃ¶lja den markerade posten",
        historicalFormula: "Historisk formel",
        onlyFiltered: "Only filtered",
        restoreSelectedRecord: "ÃterstÃ¤ll markerad post",
        showAllRecords: "Visa alla poster",
        standardFormula: "Standard formula",
        unknownFormula: "OkÃ¤nd formel"
    },
    stirCanisters: {
        selectCanisters: "VÃ¤lj behÃ¥llare",
        startStirring: "Starta omrÃ¶rning",
        stirAllCanisters: "RÃ¶r om alla behÃ¥llare",
        stirCanisters: "RÃ¶r om behÃ¥llare",
        stirringSpeed: "OmrÃ¶rningshastighet",
        stirringTime: "OmrÃ¶rningstid "
    },
    stock: {
        addColorant: "Add colorant...",
        addColorantPackagesToStock: "Add colorant packages to stock",
        addPackagesToStock: "Add packages to stock",
        addedToStock: "Added to stock",
        allDatabases: "All databases",
        checkStockPackageInventory: "If you used package from stock, please check if your stock inventory is valid.",
        clearAllItems: "Clear all items",
        colorantInventory: "Colorant inventory",
        colorantsStockInventory: "Colorants stock inventory",
        confirmSendingOrder: "Confirm sending order",
        consumptionPrediction: "Consumption prediction for the next %{weeks} weeks",
        createOrder: "Create order (%{sum})",
        expirationDate: "Expiration date",
        inDelivery: "In delivery",
        manualOrder: "Manual order",
        manualOrderProgress: "Step %{step}/%{total}",
        noPackagesFoundInStockForColorant: "There are no packages in stock for this colorant.",
        onStock: "In stock",
        orderSummary: "Order summary",
        prediction: "Prediction",
        removePackageFromStock: "Remove %{colorantName} package from stock",
        removePackageNameFromStock: "Would you like to remove one %{packageName} package from stock?",
        scanBarcodeOrSelectColorant: "Scan barcode from package or select colorant",
        selectPackageToRemove: "Select package to remove",
        sendConfirmed: "Send confirmed",
        setAmountsByPrediction: "Set amounts by prediction",
        sortByColorantName: "Sort by colorant name",
        sortByOrderNeed: "Sort by need to order",
        sortByStockLevel: "Sort by stock level",
        toOrder: "To order"
    },
    testBarcode: {
        noItemAssigned: "Inget objekt har tilldelats streckkoden %{code}",
        pleaseScanBarcode: "Skanna streckkoden fÃ¶r bas, produkt, paket eller andra objekt",
        testBarcodes: "Testa streckkoder"
    },
    ticketing: {
        answer: "Answer",
        answered: "Answered",
        chooseType: "Choose type",
        closeRequest: "Close request",
        comment: "Comment",
        create: "Create",
        createNewTicket: "Create new ticket",
        formulaAttached: "The requested formula is attached to the answer. Click the %{loadFormula} button to open it.",
        formulaClaim: "Formula claim",
        formulaRequest: "Formula request",
        formulaUnrealizable: "The requested formula is unrealizable.",
        newTicket: "New ticket",
        noPosInfoFound: "POS information (name, city) not found",
        noTicketSelected: "No ticket selected",
        openTicket: "Open ticket",
        posName: "POS name",
        posted: "Posted",
        request: "Request",
        requestDate: "Request date",
        requestId: "Request ID",
        resolvedBy: "Resolved by",
        responseDate: "Response date",
        saveToCustomFormula: "Save to custom formula",
        sending: "Sending",
        service: "Service",
        successfulCreation: "Ticket successfully created. Sending...",
        ticketAnswered: "A ticket has been answered.",
        ticketDelivered: "A ticket has been delivered.",
        ticketId: "Ticket ID",
        ticketType: "Ticket type",
        waitingForAnswer: "Waiting for answer"
    },
    tutorial: {
        last: "Senaste",
        next: "NÃ¤sta"
    },
    ufiCodeModal: {
        currentStatus: "Aktuell status",
        detailedInfoForColorant: "Detaljerad information fÃ¶r fÃ¤rgning %{colorantName}",
        userSetUfiCode: "AnvÃ¤ndaruppsÃ¤ttning UFI-kod, aktuellt vÃ¤rde"
    },
    ufiCodeSettings: {
        baseUfiCodeValidation: "Basvalidering av UFI-kod",
        confirmColorantRefilling: "BekrÃ¤fta fÃ¤rgÃ¥terfyllning",
        enableUfiCodes: "Aktivera UFI-koder",
        printUfiCode: "Skriv ut om mÃ¤ngden fÃ¤rgant Ã¤r Ã¶ver",
        printUfiCodePercentage: "Skriv ut procent om mÃ¤ngden fÃ¤rgning Ã¤r Ã¶ver",
        scanOrTypeUfiCode: "Skanna eller skriv UFI-kod",
        scanOrTypeUfiCodeOfBase: "Skanna eller skriv UFI-kod fÃ¶r bas kan",
        ufiCodesByPercentage: "AnvÃ¤nda UFI-koder i procent",
        ufiCodesFromDatabase: "AnvÃ¤nda UFI-koder frÃ¥n databasen",
        ufiCodesFromLastFilling: "AnvÃ¤nd UFI-koder frÃ¥n den senaste fyllningen"
    },
    userSettings: {
        addUser: "LÃ¤gg till anvÃ¤ndare",
        assignedUserGroups: "Tilldelade anvÃ¤ndargrupper",
        availableUserGroups: "TillgÃ¤ngliga anvÃ¤ndargrupper",
        barcode: "Streckkod",
        confirmNewPassword: "BekrÃ¤fta lÃ¶senord",
        editPassword: "Redigera lÃ¶senord",
        editUser: "Redigera anvÃ¤ndare",
        enableAutoLogin: "Aktivera automatisk inloggning",
        newPassword: "Nytt lÃ¶senord",
        noChange: "Det finns inga Ã¤ndringar att spara",
        oldPassword: "Gammalt lÃ¶senord",
        password: "LÃ¶senord",
        passwordsDoNotMatch: "LÃ¶senorden matchar inte",
        restoreUser: "Den hÃ¤r anvÃ¤ndaren har tagits bort. Vill du Ã¥terstÃ¤lla den?",
        userGroup: "User Group",
        userGroups: "AnvÃ¤ndargrupper",
        userManagement: "AnvÃ¤ndarhantering",
        userSettings: "AnvÃ¤ndarinstÃ¤llningar",
        username: "AnvÃ¤ndarnamn",
        usernameIsMissing: "AnvÃ¤ndarnamn saknas"
    },
    warningMissingDataModal: {
        continue: "Same data is missing, do you want continue?",
        notFoundBase:
            "This product base is not available. Confirm and be careful to get compatible product base from shelf or cancel this order.",
        notFoundProduct:
            "This product is not available. Confirm and be careful to get compatible product from shelf or cancel this order."
    },
    weekdays: {
        friday: "Fredag",
        monday: "MÃ¥ndag",
        saturday: "LÃ¶rdag",
        sunday: "SÃ¶ndag",
        thursday: "Torsdag",
        tuesday: "Tisdag",
        wednesday: "Onsdag"
    },
    welcome: {
        availableDatabase: "Servern kan inte ansluta till databasen. Kontrollera databaskonfigurationen.",
        availableDatabaseLocalError: "Fel vid anslutning till lokal databas (fel fil, ogiltigt lÃ¶senord)",
        availableDatabaseLocalMissing: "Den lokala databasfilen saknas",
        availableDatabaseLocalUpdate: "Lokal databas behÃ¶ver uppdateras till den nyare versionen",
        availableDatabaseMainAndLocalError:
            "Fel vid anslutning till bÃ¥de huvuddatabaser och lokala databaser (felaktig fil, ogiltigt lÃ¶senord)",
        availableDatabaseMainAndLocalMissing: "Huvud- och lokala databasfiler saknas",
        availableDatabaseMainAndLocalUpdate:
            "BÃ¥de huvuddatabaser och lokala databaser mÃ¥ste uppdateras till den nyare versionen",
        availableDatabaseMainError: "Fel vid anslutning till huvuddatabasen (fel fil, ogiltigt lÃ¶senord)",
        availableDatabaseMainMissing: "Huvuddatabasfilen saknas",
        availableDatabaseMainPartialUpdate: "Main database needs to be updated to the newer version via partial update",
        availableDatabaseMainPartialUpdateAndLocalUpdate:
            "Main database needs to be updated to the newer version via partial update and local database needs to be updated to the newer version",
        availableDatabaseMainUpdate: "Huvuddatabasen behÃ¶ver uppdateras till den nyare versionen",
        closing: "Programvara avslutas",
        compatibility:
            "Kontrollera versionen pÃ¥ din server. Din klient Ã¤r endast kompatibel med servern %{0} eller hÃ¶gre.",
        compatibilityCheck: "Kompatibilitetskontroll pÃ¥gÃ¥r",
        compatibilityDatabase: "Din databas Ã¤r inte kompatibel med servern. Kontrollera databaskonfigurationen.",
        connectingServer: "Ansluter till servern pÃ¥ %{ip}",
        databaseCompatibility: "Din databas Ã¤r inte kompatibel med den aktuella programvaran",
        databasesCompatibility: "Dina databaser Ã¤r inte kompatibla med den aktuella programvaran",
        licenseVerification: "Licensverifiering pÃ¥gÃ¥r",
        loading: "LÃ¤ser in",
        lostConnection: "Anslutningen till servern har brutits",
        moduleMessage:
            "Var uppmÃ¤rksam pÃ¥ modulvalet eftersom framtida modifiering av modulen endast Ã¤r tillgÃ¤ngliga fÃ¶r anvÃ¤ndare med sÃ¤rskild behÃ¶righet.",
        refresh: "Uppdatera",
        restoring: "Ãteransluter",
        selectModule: "VÃ¤lj en av de tillgÃ¤ngliga modulerna.",
        stopUpdate: "Stoppa uppdateringen",
        updateDatabase: "Uppdatera databas",
        updatingDatabase: "Databasen uppdateras",
        updatingDatabases: "Databaserna uppdateras",
        updatingWarning: "StÃ¤ng inte det hÃ¤r fÃ¶nstret. En oÃ¥terkallelig process pÃ¥gÃ¥r.",
        updatingWarningInfo: "Om fÃ¶nstret stÃ¤ngs orsakas dataskador som inte kan repareras."
    }
};
